import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from "react";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";
import $ from "jquery";
import Alert from "react-s-alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import moment from "moment";

// api
import { createRecAcct } from "./api/CarbonSolutions";
import {
  createAcct,
  lightReachPricing,
  createQuote,
  voidQuote,
} from "./api/LightReach";
import lightReachApi from "./api/lightreach-api";
import sungageApi from "./api/sungage-api";
import proposalToolApi from "./api/proposal-tool-api";
import auroraApi from "../../api/aurora-api";

// helper functions
import {
  calculateLoanDetails,
  getAnnualProductionString,
  shouldShowProductionRange,
} from "./helper-functions";
import { getOrSpsAdderRatePerWatt, OR_SPS_ADDER_PER_WATT } from "./helper-functions/adders";
import { getMspForLightReachGetQuote } from "./helper-functions/lightReachMsp";
import {
  getProposalDetails,
  updateProject,
} from "../UsageFunctions/api/SolarGraf";
import MasterCalc from "../UsageFunctions/MasterCalc";
import PNMCalc from "../UsageFunctions/PNMCalc";
import BlackHillsCalc from "../UsageFunctions/BlackHillsCalc";
import OverRideCalc from "../UsageFunctions/OverRideCalc";
import StateUsage from "../UsageFunctions/StateUsage";
import RECCalc from "../UsageFunctions/RECCalc";

// components?
import FindTotalInterest from "./helper-functions/FindTotalInterest";
import HelpButtonMenu from "../HelpButton/HelpButtonMenu";
import RoofProp from "./components/RoofProp";
import UtilityChart from "../Charts/UtilityChart";
import ProdChart from "../Charts/ProdChart";
import PerKwChart from "../Charts/PerKwChart";
import DonutChart from "../Charts/DonutChart";
import { UserContext } from "../../UserContext";
import Title from "../Title/Title";
import FinancingMenu from "./components/menus/FinancingMenu";
import AdderMenu from "./components/menus/AdderMenu";
import EquipmentMenu from "./components/menus/EquipmentMenu";
import ProposalMenu from "./components/menus/ProposalMenu";
import CustomerMenu from "./components/menus/CustomerMenu";
import SendCIAMenu from "./components/menus/SendCIAMenu";
import CustomerData from "./components/CustomerData";
import OffersProvider from "./hooks/contexts/offers-hook";
import AuroraDesignListModal from "./components/Modals/AuroraDesignListModal";
import ErrorModal from "./components/Modals/ErrorModal";

// sass
import "./styles/PropView.sass";

// images
import treeSvg from "../../assets/images/environment-trees.svg";
import gasSvg from "../../assets/images/environment-gas.svg";
import Logo from "../../assets/images/Ion-Solar-Logo.svg";
import WhiteLogo from "../../assets/images/Ion-Solar-Logo-white.svg";

import garbageSvg from "../../assets/images/environment-waste.svg";
import addersBlue from "../../assets/images/menu-adders-blue.svg";
import addersWhite from "../../assets/images/menu-adders-white.svg";
import equipBlue from "../../assets/images/menu-equipment-blue.svg";
import equipWhite from "../../assets/images/menu-equipment-white.svg";
import finBlue from "../../assets/images/menu-financing-blue.svg";
import finWhite from "../../assets/images/menu-financing-white.svg";
import custBlue from "../../assets/images/menu-customer-blue.svg";
import custWhite from "../../assets/images/menu-customer-white.svg";
import propsBlue from "../../assets/images/menu-proposals-blue.svg";
import propsWhite from "../../assets/images/menu-proposals-white.svg";
import arrowDown from "../../assets/images/arrow-down.svg";
import plus from "../../assets/images/plus-lg.svg";
import dash from "../../assets/images/dash-lg.svg";
import linkOut from "../../assets/images/link-out.svg";
import checkCircle from "../../assets/images/check-circle.svg";
import sync from "../../assets/images/sync.svg";
import download from "../../assets/images/download.svg";
import checkmark from "../../assets/images/checkmark.svg";
import brinksBundle from "../../assets/images/brinks_products.png";
import inc500 from "../../assets/images/inc-500.png";
import nabcep from "../../assets/images/nabcep-certified.png";
import bbb from "../../assets/images/bbb.png";
// end images
import { default as utilitiesMap } from "../../lib/utilities-map";
import EstimatedSavings from "./components/EstimatedSavings/EstimatedSavings";
import goodleapApi from "./api/goodleap-api";

const PropView = (props) => {
  const { activeUser, setActiveUser, userGroups } = useContext(UserContext);

  const [user, setUser] = useState();

  const [proposal, setProposal] = useState([]);
  const [proposals, setProposals] = useState([]);
  const [utility, setUtility] = useState("");
  const [monthlyUsage, setMonthlyUsage] = useState("");
  const [SFUsage, setSFUsage] = useState("");
  const [customer, setCustomer] = useState([]);
  const [primaryContact, setPrimaryContact] = useState([]);
  const [stateInfo, setStateInfo] = useState("");

  const [janProduction, setJanProduction] = useState("");
  const [febProduction, setFebProduction] = useState("");
  const [marProduction, setMarProduction] = useState("");
  const [aprProduction, setAprProduction] = useState("");
  const [mayProduction, setMayProduction] = useState("");
  const [junProduction, setJunProduction] = useState("");
  const [julyProduction, setJulyProduction] = useState("");
  const [augProduction, setAugProduction] = useState("");
  const [sepProduction, setSepProduction] = useState("");
  const [octProduction, setOctProduction] = useState("");
  const [novProduction, setNovProduction] = useState("");
  const [decProduction, setDecProduction] = useState("");

  const [panelAmount, setPanelAmount] = useState("");
  const [arrayCount, setArrayCount] = useState("");
  const [originalPanelAmount, setOriginalPanelAmount] = useState("");
  const [systemSize, setSystemSize] = useState("");
  const [systemSizeAC, setSystemSizeAC] = useState("");
  const [systemCost, setSystemCost] = useState("");
  const [totalProduction, setTotalProduction] = useState("");
  const [production, setProduction] = useState([]);
  const [loanAmount, setLoanAmount] = useState("");
  const [rebate, setRebate] = useState("");
  const [pacificPowerRebate, setPacificPowerRebate] = useState(0);
  const [centerPointRebate, setCenterPointRebate] = useState(0);
  const [gvecNewBatteryRebate, setGvecNewBatteryRebate] = useState(0);
  const [partialPanels, setPartialPanels] = useState("");
  const [stateTax, setStateTax] = useState(0);
  const [pRatio] = useState("");
  const [mod, setMod] = useState("");
  const [inverter, setInverter] = useState("");
  const [propInverter, setPropInverter] = useState("");
  const [modules, setModules] = useState([]);
  const [inverters, setInverters] = useState([]);
  const [uType, setUType] = useState("");
  const [design, setDesign] = useState("");
  const [calcUtility, setCalcUtility] = useState("");
  const [annualUsage, setAnnualUsage] = useState("");
  const [squareFootage, setSquareFootage] = useState("");
  const [showDesignModal, setShowDesignModal] = useState(false);
  const [designList, setDesignList] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const [adders, setAdders] = useState([]);
  const [services, setServices] = useState([]);
  const [currentProp, setCurrentProp] = useState("");

  const [viewEquipment, setViewEquipment] = useState(false);
  const [viewAdders, setViewAdders] = useState(false);
  const [viewProposals, setViewProposals] = useState(false);
  const [viewLoans, setViewLoans] = useState(false);
  // no usage for value
  const [viewCustomer, setViewCustomer] = useState(false);
  const [viewCiaInfo, setViewCiaInfo] = useState(false);
  const [sendCiaDoc, setSendCiaDoc] = useState(false);
  // no usage for value
  const [viewNest, setViewNest] = useState(false);
  const [viewPayments, setViewPayments] = useState(false);
  const [index, setIndex] = useState(0);
  const [nem, setNem] = useState(true);
  const [hoa, setHoa] = useState(false);
  const [hoaName, setHoaName] = useState("");
  const [hoaPhone, setHoaPhone] = useState("");
  const [includeSqFtAmendment, setIncludeSqFtAmendment] = useState(true);
  const [newBuild, setNewBuild] = useState(0);
  const [isCash, setIsCash] = useState(false);
  const [viewOptions, setViewOptions] = useState(0);
  const [rebateSF, setRebateSF] = useState("");
  const [cpsRebate, setCpsRebate] = useState(0);
  const [austinRebate, setAustinRebate] = useState(0);
  const [timeStamp, setTimeStamp] = useState("");
  // no usage for value
  const [copied, setCopied] = useState(false);

  //adders
  const [dealerFee, setDealerFee] = useState(0.7);
  const [previousDealerFee, setPreviousDealerFee] = useState(0.7);
  const [adderTotal, setAdderTotal] = useState("");
  const [ppaEligibleAdderTotal, setPpaEligibleAdderTotal] = useState("");
  const [treeRemoval, setTreeRemoval] = useState(0);
  const [townhome, setTownhome] = useState("");
  const [townhomeAmount, setTownhomeAmount] = useState(400 / +dealerFee);
  const [treeRemovalAmount, setTreeRemovalAmount] = useState("");
  const [reRoof, setReRoof] = useState(0);
  const [reRoofAmount, setReRoofAmount] = useState("");
  const [roofQuote, setRoofQuote] = useState({});
  const [smartHome, setSmartHome] = useState(0);
  const [smartHomeAmount, setSmartHomeAmount] = useState("");
  const [hvac, setHvac] = useState(0);
  const [hvacAmount, setHvacAmount] = useState("");
  const [led, setLed] = useState(0);
  const [ledAmount, setLedAmount] = useState("");
  const [turf, setTurf] = useState(0);
  const [turfAmount, setTurfAmount] = useState("");
  const [windows, setWindows] = useState(0);
  const [windowsAmount, setWindowsAmount] = useState("");
  const [utilityReview, setUtilityReview] = useState(false);
  const [utilityReviewAmount, setUtilityReviewAmount] = useState(
    1250 / +dealerFee
  );
  const [currentPerKw, setCurrentPerKw] = useState(0);
  const [currentAnnualUtilityBill, setCurrentAnnualUtilityBill] = useState(0);
  const [water, setWater] = useState(0);
  const [waterAmount, setWaterAmount] = useState("");
  const [travel, setTravel] = useState(0);
  const [travelAmount, setTravelAmount] = useState("");
  const [ballast, setBallast] = useState(0);
  const [ballastAmount, setBallastAmount] = useState(0.23 / +dealerFee);
  const [ballastPanels, setBallastPanels] = useState("");
  const [ballastTotal, setBallastTotal] = useState(0);
  const [ballastPartial, setBallastPartial] = useState(false);
  const [pSolar, setPSolar] = useState(0);
  const [pSolarAmount, setPSolarAmount] = useState(
    roundAndFormatNumber(0.15 / +dealerFee),
    4
  );
  const [groundMount, setGroundMount] = useState(0);
  const [groundMountAmount, setGroundMountAmount] = useState(1.3);
  const [groundMountPanels, setGroundMountPanels] = useState("");
  const [groundMountTotal, setGroundMountTotal] = useState("");
  const [loadSwitch, setLoadSwitch] = useState(0);
  const [loadSwitchAmount, setLoadSwitchAmount] = useState(1500 / +dealerFee);
  const [msp, setMsp] = useState(0);
  /** Oregon only: LightReach getQuoteV2 `msp` flag (+$0.01 pricing); does not affect adders or PPW. */
  const [oregonLightreachPricingBump, setOregonLightreachPricingBump] = useState(false);
  const [mspAmount, setMspAmount] = useState(3500 / +dealerFee);
  useEffect(() => {
    if (customer?.state && customer.state !== "Oregon") {
      setOregonLightreachPricingBump(false);
    }
  }, [customer?.state]);
  const [critterGuard, setCritterGuard] = useState(0);
  const [critterGuardAmount, setCritterGuardAmount] = useState(
    0.1 / +dealerFee
  );
  const [lightReachQuote, setLightReachQuote] = useState([]);
  const [military, setMilitary] = useState(0);
  const [miscCash, setMiscCash] = useState(0);
  const [hasRec, setHasRec] = useState(0);
  const [miscCashAmount, setMiscCashAmount] = useState("");
  const [miscCashNotes, setMiscCashNotes] = useState("");
  const freePower = 0;
  const [shadeWaiver, setShadeWaiver] = useState(0);
  const [freePowerAmount, setFreePowerAmount] = useState(0);
  const [blackFriday, setBlackFriday] = useState(0);
  const [battery3, setBattery3] = useState(0);
  const [battery3Amount] = useState(9204);
  const [battery10, setBattery10] = useState(0); //0:none, 1-10:number of enphase 5p batteries, 11-20:number of tesla powerwalls 11=1(but only 1 possible right now), 21-30: number of enphase 10c 21=1
  const [battery10Amount, setBattery10Amount] = useState(0);
  const [batteryChanged, setBatteryChanged] = useState(false);
  const [powerWall, setPowerWall] = useState(0);
  const [powerWallAmount, setPowerWallAmount] = useState(12500 / +dealerFee);
  const addBattery10Amount = 12500;
  const [selectedPpw, setSelectedPpw] = useState("");
  const [ppw, _setPpw] = useState("");
  const [netPpw, setNetPpw] = useState("");
  const [grossPpw, setGrossPpw] = useState("");
  const [batteryClass, setBatteryClass] = useState("viewBattery");
  const [cashPpw, setCashPpw] = useState("");
  const [basePpw, setBasePpw] = useState("");
  const [overRide] = useState(false);
  const [ionRebate, setIonRebate] = useState(0);
  const ionRebate2 = "";
  const [blkAdder, setBlkAdder] = useState("");
  const [blkAdderAmount, setBlkAdderAmount] = useState(500 / +dealerFee);
  const [panelBonus, setPanelBonus] = useState(0);
  const panelBonusAmount = 250 / +dealerFee;
  const [nest, setNest] = useState("");
  const [nestAmount, setNestAmount] = useState(0);
  const [nestCost, setNestCost] = useState(250 / +dealerFee);
  const nestMax = 0.05;
  const [adderAmount, setAdderAmount] = useState(500 / +dealerFee);
  const [smallSystemAdderAmount, setSmallSystemAdderAmount] = useState(0);
  const [pvSystemAddOn, setPvSystemAddOn] = useState(0);
  const [pvSystemAddOnAmount, setPvSystemAddOnAmount] = useState(
    1000 / +dealerFee
  );
  const [permittingAdder, setPermittingAdder] = useState(0);
  const [permittingAdderAmount, setPermittingAdderAmount] = useState(
    0.1 / +dealerFee
  );
  const [jurisdiction, setJurisdiction] = useState("");
  const [needToResyncTpoPricing, setNeedToResyncTpoPricing] = useState(false);

  // no setState
  const [highLoan, setHighLoan] = useState(0);

  const [preferredUtility, setPreferredUtility] = useState(0);
  const preferredUtilityAmount = 0.4;
  const [sameDay, setSameDay] = useState(0);
  const sameDayAmount = 1000;
  const [referral, setReferral] = useState(0);
  const referralAmount = 1500;
  const [nestAdder, setNestAdder] = useState(0);
  const nestAdderAmount = 100;
  const [calculation, setCalculation] = useState("");
  const [sustainable, setSustainable] = useState(0);
  const [loanProducts, setLoanProducts] = useState([]);
  const [ppaProducts, setPpaProducts] = useState([]);
  const [loanProducts2, setLoanProducts2] = useState([]);
  const [loanA, setLoanA] = useState("");
  const [loanAId, setLoanAId] = useState("");
  const [loanB, setLoanB] = useState([]);
  const [loanBId, setLoanBId] = useState("");
  const pendingTpoResyncAfterAddersRef = useRef(false);
  const onAddersChangedForTpo = useCallback(() => {
    if (+loanA?.isPpa === 1) {
      pendingTpoResyncAfterAddersRef.current = true;
    }
  }, [loanA?.isPpa]);
  // no usage for value
  const [loanADefault, setLoanADefault] = useState([]);
  const [utilityId, setUtilityId] = useState("");
  const [inverterId, setInverterId] = useState("");
  const [hasRebate, setHasRebate] = useState("");
  const [rebateOverride, setRebateOverride] = useState("");
  const [salesTeam, setSalesTeam] = useState("");
  const [team, setTeam] = useState("");
  const [teamPpw, setTeamPpw] = useState("");
  const [teamInv, setTeamInv] = useState([]);
  const [updateCustomer, setUpdateCustomer] = useState(false);
  const [designObj, setDesignObj] = useState("");
  const [designDetails, setDesignDetails] = useState("");
  const [sizeChangeNotes, setSizeChangeNotes] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [electronicConsent, setElectronicConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ciaLoading, setCiaLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [qualify, setQualify] = useState(false);
  const [goodLeapView, setGoodLeap] = useState(false);
  const [sungageView, setSungageView] = useState(false);
  const [viewApps, setViewApps] = useState(false);
  const [bundleId, setBundleId] = useState("");
  const [disclosureToken, setDisclosureToken] = useState("");
  const [disclosures, setDisclosures] = useState([]);
  const [goodLeapApplications, setGoodLeapApplications] = useState([]);
  const [arcadiaSavingsReport, setArcadiaSavingsReport] = useState([]);
  const [sungageApplication, setSungageApplication] = useState(null);
  const [agreed, setAgreed] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const smallBreakPoint = 576;
  const [militaryMonthly, setMilitaryMonthly] = useState([]);
  const [militaryCap, setMilitaryCap] = useState(true);
  const [discounts, setDiscounts] = useState("");
  const [envelopeId, setEnvelopeId] = useState("");
  const [envelopeStatus, setEnvelopeStatus] = useState("");
  const [newPropRatio, setNewPropRatio] = useState("");
  const [netCost, setNetCost] = useState(0);
  const [showNetCost, setShowNetCost] = useState(false);
  const [displayProd, setDisplayProd] = useState("");
  const [slider, setSlider] = useState(false);
  const [sungagePayments, setSungagePayments] = useState(null);
  const [securityToggled, setSecurityToggled] = useState(false);
  const [expansionPack, setExpansionPack] = useState(false);
  const [expansionPackAmount, setExpansionPackAmount] = useState(0);
  const [acCoupled, setAcCoupled] = useState(false);
  const [acCoupledAmount, setAcCoupledAmount] = useState(0);
  const [travelAdderAmount, setTravelAdderAmount] = useState(0);
  const [lightReachQuotes, setLightReachQuotes] = useState([]);
  const [pricingDisclosures, setPricingDisclosures] = useState([]);
  const [waterSoftener, setWaterSoftener] = useState(0);
  const [waterSoftenerAmount, setWaterSoftenerAmount] = useState(4000);
  // variables
  const listOfStates = require("us-state-converter");
  let inverterCount = powerWall ? 1 : panelAmount;
  const [customerData, setCustomerData] = useState("");
  const view = props.match.params.view;
  const apiUrl = proposalToolApi.getUrl();
  //PROD
  const salesApiUrl = `https://dev.iondeveloper.com/api/rep/docusign/?api_key=${process.env.REACT_APP_API_KEY}`;

  const isUsingOldPayscale = () => {
    if (!currentProp?.contractSigned) {
      return false;
    }

    const date = new Date(currentProp?.contractSigned);
    return date < new Date("2025-09-16");
  };

  const convertToCashPpw = (ppwValue, dealerFeeValue) => {
    if (isUsingOldPayscale()) {
      return ppwValue;
    }

    return Number(ppwValue * dealerFeeValue || 0);
  };

  // PPW With Dealer Fee:
  const addDealerFee = (selectedPpw) => {
    if (isUsingOldPayscale()) {
      return selectedPpw;
    }

    return Number(selectedPpw / dealerFee || 0);
  };

  const removeDealerFee = (selectedPpw) => {
    if (isUsingOldPayscale()) {
      return selectedPpw;
    }

    return Number(selectedPpw * dealerFee || 0);
  };

  // Gross PPW (The Final PPW the customer is paying)
  const calculatedGrossPpw = () => {
    if (loanA?.loanName === "LightReach PPA") {
      let systemPrice = loanA?.totalAmount;
      return Number(systemPrice / systemSize || 0);
    }

    let systemPrice = ppw * systemSize;

    if (+loanA.isPpa === 1) {
      return ppw;
    }

    return Number((systemPrice + adderTotal) / systemSize || 0);
  };

  // Net PPW (What the rep actually gets paid on)
  const calculatedNetPpw = () => {
    if (+loanA.isPpa === 1) {
      console.log("Net ppw loan", loanA);
      const solarCost = Number(loanA.totalAmount || 0);

      if (solarCost === 0) {
        return 0;
      }

      const solarMinusAddersPpw = (solarCost - adderTotal) / systemSize;
      const newNetPpw = Number(solarMinusAddersPpw || 0);
      return newNetPpw;
    }
    const newNetPpw = Number(ppw * dealerFee || 0);
    return newNetPpw;
  };

  const setPpw = (value = null, dealerFeeAlreadyIncluded = true) => {
    if (value) {
      value = value;
    } else {
      value = ppw;
      dealerFeeAlreadyIncluded = true;
    }

    console.log("value", value);

    if (value === null || value === undefined || value === "" || value === 0) {
      return;
    }

    const ppwWithoutDealerFee = dealerFeeAlreadyIncluded
      ? removeDealerFee(value)
      : value;
    const ppwValueWithFee = dealerFeeAlreadyIncluded
      ? value
      : addDealerFee(value);

    setSelectedPpw(ppwWithoutDealerFee);
    _setPpw(ppwValueWithFee);
    setNetPpw(calculatedNetPpw());
    setGrossPpw(calculatedGrossPpw());
  };

  useEffect(() => {
    setPpw();
  }, [
    ppw,
    adderTotal,
    ppaEligibleAdderTotal,
    systemSize,
    loanA,
    loanAId,
    dealerFee,
  ]);

  //DEV
  let types = "";
  let sharedHome = 0;
  let startDate = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");

  let endDate = moment().add(1, "month").startOf("month").format("YYYY-MM-DD");

  //production url for mosaic
  const mosaicApiUrl = `https://dev.iondeveloper.com/api/proposal/Mosaic/mosaicProposal.php?api_key=${process.env.REACT_APP_API_KEY}`;
  //development url for mosaic
  // const mosaicApiUrl = 'https://dev.iondeveloper.com/api/proposal/Mosaic/mosaicProposalTest.php'

  const mosaicApi = (method) => {
    axios
      .post(mosaicApiUrl, {
        method: method,
      })
      .then((res) => {
        return [
          setBundleId(res.data.bundleId),
          setDisclosures(res.data.disclosures),
        ];
      });
  };

  //production url for mosaic
  // const goodLeapApiUrl = 'https://dev.iondeveloper.com/api/proposal/Mosaic/mosaicProposal.php'
  //development url for goodLeap
  const goodLeapApiUrl = `https://dev.iondeveloper.com/api/proposal/goodleap/?api_key=${process.env.REACT_APP_API_KEY}`;

  const goodLeapApi2 = (method) => {
    axios
      .post(goodLeapApiUrl, {
        method: method,
      })
      .then((res) => {
        return [
          setDisclosureToken(res.data.data.data[0].token),
          setDisclosures(res.data.data.data[0].sections),
        ];
      });
  };

  // fetch the sungage id from our DB based on the project id + prop id
  // - if it exists, fetch the sungage project and set it to state
  const getSungageApplication = async () => {
    try {
      const projectId = proposal?.projectId + proposal?.propId;

      // 1. get sungage project id
      const { sungageId } = await sungageApi.getData({
        username: activeUser.username,
        projectId,
      });

      if (sungageId) {

        // 2. get sungage project information
        const project = await sungageApi.getProject({
          username: activeUser.username,
          projectId,
          sungageId,
        });

        // 3. set the sungage application to state
        setSungageApplication(project);

      }
    } catch (error) {
      Alert.error(error.message, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 10000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
      console.error(error);
    }
  };

  const getGoodLeapApplications = async () => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        {
          method: "get_goodleap_apps",
          project_id: customer.projectID,
        }
      )
      .then((res) => {
        return setGoodLeapApplications(res.data.data);
      });
  };

  function checkPartialBallast(panelCount, ballastModules, ballast) {
    if (ballast !== 0) {
      setBallastPartial(panelCount % ballastModules !== 0);
    }
  }

  const getProposal = (propId = null) => {
    const proposalId = propId || props.match.params.prop_id;
    axios
      .post(apiUrl, {
        method: "get_proposal",
        prop_id: proposalId,
      })
      .then((res) => {
        const {
          jan,
          feb,
          mar,
          apr,
          may,
          june,
          july,
          aug,
          sept,
          oct,
          nov,
          december,
          modCount,
          ogModCount,
          ballast,
          ballastModules,
          groundMount,
          msp,
          pSolar,
          travel,
          critterGuard,
          battery3,
          battery10,
          id1,
          loan1,
          term1,
          int1,
          pre1,
          post1,
          interest1,
          id2,
          specialPrice1,
          loan2,
          term2,
          int2,
          pre2,
          post2,
          interest2,
          dealerFee1,
          dealerFee2,
          ionRebate,
          ionRebate2,
          ppa1,
          ppa2,
          arrayCount,
          hasNest,
          propDesign,
          travelAmount,
          treeTrim,
          treeTrimAmount,
          reroof,
          reroofAmount,
          itc1,
          itc2,
          utility,
          rebateOverride,
          modId,
          ppw,
          grossPpw,
          netPpw,
          selectedPpw,
          module,
          modModel,
          modSize,
          modPtcRating,
          utilityId,
          invId,
          hasRebate,
          sameDay,
          preferredUtility,
          referral,
          hasNestAdder,
          rebatePanels,
          groundMountModules,
          teamPpw,
          sustainable,
          smartHome,
          smartHomeAmount,
          hvac,
          hvacAmount,
          led,
          ledAmount,
          turf,
          turfAmount,
          windows,
          windowsAmount,
          utilityReview,
          utilityReviewAmount,
          water,
          waterAmount,
          military,
          miscCash,
          miscCashAmount,
          miscCashNotes,
          blackFriday,
          shadeWaiver,
          optionsView,
          panelBonus,
          townhome,
          srec,
          ppaRate1,
          ppaRate2,
          ppwRate1,
          ppaEscalator1,
          ppaEscalator2,
          invType,
          invModel,
          invRating,
          pvSystemAddOn,
          projectId,
          ppaOption1,
          ppwRate,
          ppafirstMonthPayment1,
          ppaTotalAmount1,
          ppaFirstMonthBatteryPayment1,
          ppaOfferId1,
          acCoupled,
          expansionPack,
          expansionPackAmount,
          waterSoftener,
        } = res.data.data;

        let rOverride = hasRebate;
        if (+rebateOverride > 1) {
          rOverride = rebateOverride;
        }
        if (+ppa1) {
          setPpw(+ppwRate1);
        } else {
          setPpw(+ppw);
        }
        (async () => {
          try {
            const response = await goodleapApi.getTpoDisclosures();
            console.log("Disclosures", response);
            setPricingDisclosures(response.data[0].sections);
          } catch (err) {
            console.log(err);
          }
        })();
        return [
          setLoanA({
            loanId: +id1,
            loanName: loan1,
            loanTerm: +term1,
            interestOnlyPayment: +interest1,
            prePayment: +pre1,
            postPayment: +post1,
            loanInterest: +int1,
            itc: +itc1,
            specialPrice: +specialPrice1,
            isPpa: +ppa1,
            ppaRate: +ppaRate1,
            ppaEscalator: +ppaEscalator1,
            dealerFee: +dealerFee1,
            projectId: projectId,
            option: ppaOption1,
            offerId: ppaOfferId1,
            ppwRate: +ppa1 ? ppwRate1 : ppwRate,
            firstMonthBatteryPayment: +ppaFirstMonthBatteryPayment1,
            totalAmount: +ppaTotalAmount1,
            firstMonthPayment: +ppafirstMonthPayment1,
          }),
          setAcCoupled(+acCoupled),
          setDealerFee(+dealerFee1),
          setMod([modId, module, modModel, modSize, modPtcRating]),
          setNest(+hasNest),
          setLoanB({
            loanId: +id2,
            loanName: loan2,
            loanTerm: +term2,
            interestOnlyPayment: +interest2,
            prePayment: +pre2,
            postPayment: +post2,
            loanInterest: +int2,
            itc: +itc2,
            specialPrice: +specialPrice1,
            isPpa: +ppa2,
            ppaRate: +ppaRate2,
            ppaEscalator: +ppaEscalator2,
            dealerFee: +dealerFee2,
          }),
          setProposal(res.data.data),
          setStateInfo(res.data.state),
          setGrossPpw(+grossPpw),
          setNetPpw(+netPpw),
          setSelectedPpw(+selectedPpw),
          setBasePpw(+teamPpw),
          setJanProduction(+jan),
          setFebProduction(+feb),
          setMarProduction(+mar),
          setAprProduction(+apr),
          setMayProduction(+may),
          setJunProduction(+june),
          setJulyProduction(+july),
          setAugProduction(+aug),
          setSepProduction(+sept),
          setOctProduction(+oct),
          setNovProduction(+nov),
          setDecProduction(+december),
          setPanelAmount(+modCount),
          setArrayCount(arrayCount),
          setOriginalPanelAmount(+ogModCount),
          setBallast(+ballast),
          setGroundMount(+groundMount),
          setMsp(+msp),
          setPSolar(+pSolar),
          setTravel(+travel),
          setTravelAmount(+travelAmount),
          setTreeRemoval(+treeTrim),
          setTreeRemovalAmount(+treeTrimAmount),
          setReRoof(+reroof),
          setReRoofAmount(+reroofAmount),
          setRoofQuote(res.data.roofQuote),
          setCritterGuard(+critterGuard),
          setBattery3(+battery3),
          setBattery10(+battery10),
          setIonRebate(+ionRebate),
          setBlkAdder(+ionRebate2),
          setDesign(propDesign),
          setCalcUtility(utility),
          setBallastPanels(+ballastModules),
          checkPartialBallast(+modCount, +ballastModules, +ballast),
          setUtilityId(utilityId),
          setInverterId(invId),
          setSameDay(+sameDay),
          setPreferredUtility(+preferredUtility),
          setReferral(+referral),
          setNestAdder(+hasNestAdder),
          setCalculation(res.data.calc),
          setPartialPanels(+rebatePanels),
          setTeamPpw(+teamPpw),
          setSustainable(+sustainable),
          setSmartHome(+smartHome),
          setSmartHomeAmount(+smartHomeAmount),
          setHvac(+hvac),
          setHvacAmount(+hvacAmount),
          setLed(+led),
          setLedAmount(+ledAmount),
          setTurf(+turf),
          setTurfAmount(+turfAmount),
          setWindows(+windows),
          setWindowsAmount(+windowsAmount),
          setUtilityReview(+utilityReview),
          setUtilityReviewAmount(+utilityReviewAmount),
          setWater(+water),
          setWaterAmount(+waterAmount),
          setMilitary(+military),
          setMiscCash(+miscCash),
          setMiscCashAmount(+miscCashAmount),
          setMiscCashNotes(miscCashNotes),
          setBlackFriday(+blackFriday),
          setRebateOverride(rebateOverride),
          setHasRebate(rOverride),
          setMonthlyUsage(res.data.propUsage),
          setShadeWaiver(+shadeWaiver),
          setViewOptions(1),
          setPanelBonus(+panelBonus),
          setTownhome(+townhome),
          setHasRec(+srec),
          setInverter({
            id: invId,
            type: invType,
            model: invModel,
            rating: invRating,
          }),
          setPropInverter({
            id: invId,
            type: invType,
            model: invModel,
            rating: invRating,
          }),
          setPvSystemAddOn(+pvSystemAddOn),
          setExpansionPack(+expansionPack),
          setExpansionPackAmount(+expansionPackAmount),
          setWaterSoftener(+waterSoftener),
        ];
      });
  };
  const sendCia = () => {
    if (
      hasRec &&
      +loanA?.isPpa !== 1 &&
      (state === "Virginia" || state === "Ohio")
    ) {
      createRecAcct(
        customer,
        mod,
        inverter.type,
        inverter.model,
        systemSize,
        systemSizeAC,
        displayProd,
        proposal.csUtilityId,
        setShowError,
        setErrorMessage
      );
    }
    axios
      .post(salesApiUrl, {
        method: "send_CIA2",
        project_id: customer.projectID,
        add_nem: nem,
        add_hoa: hoa,
        add_sq_ft_amendment: includeSqFtAmendment,
      })
      .then((res) => {
        setEnvelopeId(res.data.envelopeID);
        setEnvelopeStatus("sent");
        Alert.success(`CIA sent to ${customer.email}`, {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
        setCiaLoading(false);
      });
  };
  const getMilitaryMonthly = () => {
    axios
      .post(apiUrl, {
        method: "get_military_monthly",
        start: startDate,
        end: endDate,
      })
      .then((res) => {
        return setMilitaryMonthly(res.data.data);
      });
  };

  const createSignedProposal = () => {
    axios
      .post(apiUrl, {
        method: "create_proposal",
        project_id: proposal.projectId,
        prop_size: systemSize,
        mod_count: panelAmount,
        og_mod_count: originalPanelAmount,
        max_mod_count: maxModCount,
        inv_count: inverterCount,
        total_system_cost: systemCost,
        prop_loan_amount: loanAmount,
        down_payment: downPayment,
        has_nest: nest,
        rebate_amount: rebate,
        rebate_in_sf: rebateSF,
        rebate_override: proposal.rebateOverride,
        rebate_panels: partialPanels,
        array_count: arrayCount,
        prop_ppw: ppw,
        gross_ppw: grossPpw,
        net_ppw: netPpw,
        selected_ppw: selectedPpw,
        cost_override: costOverRide,
        prop_design: design,
        ballast: ballast,
        ballast_amount: ballastAmount,
        ballast_panels: ballastPanels,
        ground_mount: groundMount,
        ground_mount_amount: groundMountAmount,
        ground_mount_panels: groundMountPanels,
        p_solar: pSolar,
        p_solar_amount: pSolarAmount,
        travel: travel,
        travel_amount: travelAmount,
        tree_trim: treeRemoval,
        trim_amount: treeRemovalAmount,
        reroof: reRoof,
        reroof_amount: reRoofAmount,
        ion_rebate: ionRebate,
        ion_rebate2: blkAdder,
        msp: msp,
        msp_amount: mspAmount,
        critter_guard: critterGuard,
        critter_guard_amount: critterGuardAmount,
        battery3: battery3,
        battery10: battery10,
        battery10_amount: battery10Amount,
        rate_override: rateOverRide,
        rate_amount: rateAmount,
        jan: janProduction,
        feb: febProduction,
        mar: marProduction,
        apr: aprProduction,
        may: mayProduction,
        june: junProduction,
        july: julyProduction,
        aug: augProduction,
        sept: sepProduction,
        oct: octProduction,
        nov: novProduction,
        december: decProduction,
        prop_ratio: propRatio,
        mod_id: mod[0],
        inv_id: inverterId,
        utility_id: utilityId,
        loan_id1: loanA.loanId,
        loan_id2: loanB.loanId,
        time_stamp: timeStamp,
        rep_gen: 1,
        cost_25_yr: cost25yr,
        curr_ann_bill: currAnnBill,
        today: today,
        yr_5: yr5,
        yr_10: yr10,
        yr_15: yr15,
        yr_20: yr20,
        yr_25: yr25,
        gallon: gallon,
        home: home,
        garbage: garbage,
        tree: tree,
        display_prod: +displayProd,
        nest_impact: nestImpact,
        utility_power: utilityPower,
        solar_power: solarPower,
        jan_u: janU,
        feb_u: febU,
        mar_u: marU,
        apr_u: aprU,
        may_u: mayU,
        jun_u: junU,
        july_u: julyU,
        aug_u: augU,
        sep_u: sepU,
        oct_u: octU,
        nov_u: novU,
        dec_u: decU,
        jan_p: janP,
        feb_p: febP,
        mar_p: marP,
        apr_p: aprP,
        may_p: maP,
        jun_p: junP,
        july_p: julP,
        aug_p: augP,
        sep_p: sepP,
        oct_p: octP,
        nov_p: novP,
        dec_p: decP,
        pmt_1: pmt1,
        pmt_2: pmt2,
        pmt_3: pmt3,
        state_tax: stateTax,
        net_cost: netCost,
        itc_total: itcTotal,
        all_incentives: allIncentives,
        avg_25_utility: avg25Utility,
        avg_25_1: avg25_1,
        avg_25_2: avg25_2,
        pmt_1_b: pmt1B,
        pmt_2_b: pmt2B,
        loan_1_savings: loan1Savings,
        loan_2_savings: loan2Savings,
        ion_cost_a: ionCostA,
        ion_cost_b: ionCostB,
        remaining_cost: remainingCost,
        current_per_kw: currentPerKw,
        same_day: sameDay,
        preferred_utility: preferredUtility,
        referral: referral,
        has_nest_adder: nestAdder,
        team_ppw: teamPpw,
        sustainable: sustainable,
        smart_home: smartHome,
        smart_home_amt: smartHomeAmount,
        hvac: hvac,
        hvac_amt: hvacAmount,
        led: led,
        led_amt: ledAmount,
        turf: turf,
        turf_amt: turfAmount,
        windows: windows,
        windows_amt: windowsAmount,
        water: water,
        water_amt: waterAmount,
        military: military,
        misc_cash: miscCash,
        misc_cash_amount: miscCashAmount,
        black_friday: blackFriday,
        adder_total: adderTotal,
        sharedHome: sharedHome,
        user: user,
        options_view: viewOptions,
        panel_bonus: panelBonus,
        townhome: townhome,
        security: securityToggled,
        security_amount: securityToggled ? 925 / +dealerFee : 0,
        utility_review: utilityReview,
        utility_review_amount: utilityReviewAmount,
        travel_adder_amount: travelAdderAmount,
        travel_adder_tier:
          +customer.travelDistance < 76
            ? ""
            : +customer.travelDistance <= 100
              ? "Tier 1: 76-100 Miles"
              : +customer.travelDistance <= 125
                ? "Tier 2: 101-125 Miles"
                : "Tier 3: 126-150 Miles",
        financeId: customer.financeId,
        pv_system_add_on: pvSystemAddOn,
        pv_system_add_on_amount: pvSystemAddOnAmount,
        permitting_adder: permittingAdder,
        permitting_adder_amount: permittingAdderAmount,
        water_softener: waterSoftener,
        water_softener_amount: waterSoftenerAmount,
      })
      .then((res) => {
        Alert.success(`${systemSize / 1000}kW Proposal Created`, {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
        getProposalsByProjectId();
        getCustomer();
        setLoading(false);
        setSyncLoading(false);
      });
  };
  // TODO: FIX THIS
  const createLightReachAcct = async () => {
    setLoading(true);
    try {
      const data = await createAcct(
        customer,
        totalProduction,
        systemSize,
        panelAmount,
        mod[1],
        mod[3],
        inverter.type,
        inverter.model,
        proposal.utilityLseId,
        loanA.productId,
        msp,
        reRoof,
        battery10,
        battery10Amount
      );
      // getPpaPricing(data?.id);
      setLoading(false);
    } catch (error) {
      Alert.error(error, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
  };

  const addSrec = async (product, amount) => {
    const res = await axios.post(
      `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
      {
        method: "add_srec",
        finance_id: customer.financeId,
        SREC_Product__c: product,
        SREC_Company__c: "CSG",
        SREC_Amount__c: amount,
      }
    );
  };

  const getAuroraDesignData = async () => {
    setLoading(true);
    setShowDesignModal(false);
    try {
      const res = await auroraApi.syncDesign({
        projectId: customer.projectID,
        propId: proposal.propId,
      });
      if (res?.lightreach?.quoteData && res?.lightreach?.quoteData.length > 0) {
        if (res?.lightreach?.quoteData?.[0]?.systemSizeKw) {
          setSystemSize(res.lightreach.quoteData[0].systemSizeKw * 1000);
        }
      }
      const { heatmapImageUrl, panelArraysCount, numPanelArrays, acMonthly } =
        res.data;


      setDesign(heatmapImageUrl);
      setPanelAmount(panelArraysCount);
      setArrayCount(numPanelArrays);
      setNewPropRatio(
        Math.round(total(acMonthly) / ((panelArraysCount * mod[3]) / 1000))
      );

      const monthSetters = [
        setJanProduction,
        setFebProduction,
        setMarProduction,
        setAprProduction,
        setMayProduction,
        setJunProduction,
        setJulyProduction,
        setAugProduction,
        setSepProduction,
        setOctProduction,
        setNovProduction,
        setDecProduction,
      ];

      acMonthly.forEach((value, index) => {
        monthSetters[index](Math.round(value));
      });

      // Check if redirect is needed
      if (res.redirect && res.redirect !== false) {
        // Update the URL hash with the new proposal ID
        // The useEffect watching props.match.params.prop_id will automatically call getProposal()
        let temp = window.location.hash.split("/");
        temp[2] = res.redirect;
        window.location.hash = temp.join("/");
      }
    } catch (error) {
      console.error("Error in getAuroraDesignData:", error);
      // throw new Error("Failed to get SolarGraf proposal info.");
    } finally {
      setProduction(updateProduction());
      setLoading(false);
    }
  };

  const getAuroraDesignLink = async () => {
    try {
      const res = await auroraApi.getDesignLink({
        email: activeUser?.attributes.email,
        projectId: customer.projectID,
      });
      if(res.success){
        const newWindow = window.open(res.data, '_blank');
        if (!newWindow) {
          setShowErrorModal(true);
          setErrorMessage(`Pop-up blocker is enabled. Contact IT for assistance. Alternatively you can open this link in a new browser: ${res.data}`);
          throw new Error("Pop-up blocker is enabled.");
        }
      }
      else{        
        setShowErrorModal(true);
        setErrorMessage(`Could not get design link from Aurora: ${res.message}. Contact IT for assistance.`);
        throw new Error("Could not get design link from Aurora");        
      }
    } catch (error) {
      console.error("Error in getAuroraDesignLink:", error);
    }
  };

  const getAuroraDesigns = async () => {
    setLoading(true);
    try {
      const res = await auroraApi.getDesignsForProject({
        projectId: proposal.projectId
      });

      if (res.success) {
        if(res.data.designs.length > 1){
          setDesignList(res.data.designs);
          setShowDesignModal(true);
        }
        else{
          getAuroraDesignData();
        }
      }

    } catch (error) {
      console.error("Error in getAuroraDesigns:", error);
    }
  };

  const getAuroraBillSummary = async (projectId) => {
    setLoading(true);
    setShowDesignModal(false);
    try {
      const res = await auroraApi.getBillSummary({
        projectId: projectId
      });
      let auroraUtilityRate = (res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][0] / res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_net_grid_consumption'][0]);
      setCurrentPerKw(auroraUtilityRate);
      let year1TotalBill = (
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][0] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][1] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][2] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][3] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][4] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][5] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][6] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][7] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][8] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][9] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][10] +
        res['data']['projectBillSummary']['data']['bill_summary']['year1_monthly_total_bill'][11]
      );
      setCurrentAnnualUtilityBill(year1TotalBill);
    } catch (error) {
      console.error("Error in getAuroraBillSummary:", error);
    } finally {
      setLoading(false);
    }
  };

  const getDesignTypes = () => {
    let previousDesignTypes = [];
    let designTypes = [];
    let removeFromPreviousDesignTypes = [
      "Mixed Mounting Hardware",
      "Ballast",
      "Ground Mount",
      "Battery",
    ];

    if (customer.designType) {
      previousDesignTypes = customer.designType.split(";");
    }

    if (+ballast === 1) {
      if (ballastModules < modCount && ballastModules > 0) {
        designTypes.push("Mixed Mounting Hardware");
      }
      designTypes.push("Ballast");
    }
    if (+groundMount === 1) {
      if (groundMountModules < modCount && groundMountModules > 0) {
        designTypes.push("Mixed Mounting Hardware");
      }
      designTypes.push("Ground Mount");
    }
    if (+battery10 > 0) {
      designTypes.push("Battery");
    }

    if (customer.designType) {
      for (let i = 0; i <= previousDesignTypes.length; i++) {
        let shouldInclude = true;
        for (let r = 0; r <= removeFromPreviousDesignTypes.length; r++) {
          if (previousDesignTypes[i] === removeFromPreviousDesignTypes[r]) {
            shouldInclude = false;
            break;
          }
        }

        if (shouldInclude) {
          designTypes.push(previousDesignTypes[i]);
        }
      }
    }
    return designTypes.join(";");
  };

  const createProposal = async () => {
    if (
      +loanA.isPpa === 1 &&
      loanA.loanName.toLowerCase().includes("lightreach")
    ) {
      await createAcct(
        customer,
        totalProduction,
        systemSize,
        panelAmount,
        mod[1],
        mod[3],
        inverter.type,
        inverter.model,
        proposal.utilityLseId,
        loanA.productId,
        msp,
        reRoof,
        battery10,
        battery10Amount
      );
    }

    if (state === "Virginia" || state === "Ohio" || state === "Illinois") {
      addSrec(recValue.product, recValue.afterEnergy);
    }
    let designTypes = getDesignTypes();

    const res = await axios
      .post(apiUrl, {
        method: "create_proposal_rep_test",
        project_id: proposal.projectId,
        prop_size: systemSize,
        mod_count: panelAmount,
        og_mod_count: originalPanelAmount,
        max_mod_count: maxModCount,
        inv_count: inverterCount,
        total_system_cost: systemCost,
        prop_loan_amount: loanA.totalAmount || loanAmount,
        down_payment: downPayment,
        has_nest: nest,
        rebate_amount: rebate,
        rebate_in_sf: rebateSF,
        rebate_override: rebateOverride,
        rebate_panels: partialPanels,
        array_count: arrayCount,
        prop_ppw: ppw,
        gross_ppw: grossPpw,
        net_ppw: netPpw,
        selected_ppw: selectedPpw,
        cost_override: costOverRide,
        prop_design: design,
        ballast: ballast,
        ballast_amount: ballastAmount,
        ballast_panels: ballastPanels,
        ground_mount: groundMount,
        ground_mount_amount: groundMountAmount,
        ground_mount_panels: groundMountPanels,
        p_solar: pSolar,
        p_solar_amount: pSolarAmount,
        travel: travel,
        travel_amount: travelAmount,
        tree_trim: treeRemoval,
        trim_amount: treeRemovalAmount,
        reroof: reRoof,
        reroof_amount: reRoofAmount,
        ion_rebate: ionRebate,
        ion_rebate2: blkAdder,
        msp: msp,
        msp_amount: mspAmount,
        critter_guard: critterGuard,
        critter_guard_amount: critterGuardAmount,
        battery3: battery3,
        battery10: battery10,
        battery10_amount: battery10Amount,
        rate_override: rateOverRide,
        rate_amount: rateAmount,
        jan: janProduction,
        feb: febProduction,
        mar: marProduction,
        apr: aprProduction,
        may: mayProduction,
        june: junProduction,
        july: julyProduction,
        aug: augProduction,
        sept: sepProduction,
        oct: octProduction,
        nov: novProduction,
        december: decProduction,
        prop_ratio: propRatio,
        mod_id: mod[0],
        inv_id: inverter.id,
        utility_id: utilityId,
        loan_id1: loanA.loanId,
        loan_id2: loanB.loanId,
        time_stamp: timeStamp,
        rep_gen: 1,
        cost_25_yr: cost25yr,
        curr_ann_bill: currAnnBill,
        today: today,
        yr_5: yr5,
        yr_10: yr10,
        yr_15: yr15,
        yr_20: yr20,
        yr_25: yr25,
        gallon: gallon,
        home: home,
        garbage: garbage,
        tree: tree,
        display_prod: +displayProd,
        nest_impact: nestImpact,
        utility_power: utilityPower,
        solar_power: solarPower,
        jan_u: janU,
        feb_u: febU,
        mar_u: marU,
        apr_u: aprU,
        may_u: mayU,
        jun_u: junU,
        july_u: julyU,
        aug_u: augU,
        sep_u: sepU,
        oct_u: octU,
        nov_u: novU,
        dec_u: decU,
        jan_p: janP,
        feb_p: febP,
        mar_p: marP,
        apr_p: aprP,
        may_p: maP,
        jun_p: junP,
        july_p: julP,
        aug_p: augP,
        sep_p: sepP,
        oct_p: octP,
        nov_p: novP,
        dec_p: decP,
        pmt_1: pmt1,
        pmt_2: pmt2,
        pmt_3: pmt3,
        state_tax: stateTax,
        net_cost: netCost,
        itc_total: itcTotal,
        all_incentives: allIncentives,
        avg_25_utility: avg25Utility,
        avg_25_1: avg25_1,
        avg_25_2: avg25_2,
        pmt_1_b: pmt1B,
        pmt_2_b: pmt2B,
        loan_1_savings: loan1Savings,
        loan_2_savings: loan2Savings,
        ion_cost_a: ionCostA,
        ion_cost_b: ionCostB,
        remaining_cost: remainingCost,
        current_per_kw: currentPerKw,
        same_day: sameDay,
        preferred_utility: preferredUtility,
        referral: referral,
        has_nest_adder: nestAdder,
        team_ppw: teamPpw,
        sustainable: sustainable,
        smart_home: smartHome,
        smart_home_amt: smartHomeAmount,
        hvac: hvac,
        hvac_amt: hvacAmount,
        led: led,
        led_amt: ledAmount,
        turf: turf,
        turf_amt: turfAmount,
        windows: windows,
        windows_amt: windowsAmount,
        water: water,
        water_amt: waterAmount,
        military: military,
        misc_cash: miscCash,
        misc_cash_amount: miscCashAmount,
        black_friday: blackFriday,
        adder_total: adderTotal,
        fId: customer.financeId,
        dId: customer.designId,
        iId: customer.installId,
        surveys: surveys,
        stories: customer.stories,
        ids: adderIds,
        sharedHome: sharedHome,
        user: user,
        misc_cash_notes: miscCashNotes,
        designTypes: designTypes,
        city: city,
        free_months: freePower,
        freeMonthsAmount: freePowerAmount,
        shade_waiver: shadeWaiver,
        options_view: viewOptions,
        Interest__c: totalInterest,
        Total_Number_of_Payments__c: numOfPayments,
        panel_bonus: panelBonus,
        townhome: townhome,
        srec: hasRec,
        security: securityToggled,
        security_amount: securityToggled ? 925 / +dealerFee : 0,
        utility_review: utilityReview,
        utility_review_amount: utilityReviewAmount,
        travel_adder_amount: travelAdderAmount,
        travel_adder_tier:
          +customer.travelDistance < 76
            ? ""
            : +customer.travelDistance <= 100
              ? "Tier 1: 76-100 Miles"
              : +customer.travelDistance <= 125
                ? "Tier 2: 101-125 Miles"
                : "Tier 3: 126-150 Miles",
        ac_coupled: acCoupled,
        ac_coupled_amount: acCoupled ? acCoupledAmount : 0,
        expansion_pack: expansionPack,
        expansion_pack_amount: expansionPackAmount,
        pv_system_add_on: pvSystemAddOn,
        pv_system_add_on_amount: pvSystemAddOnAmount,
        permitting_adder: permittingAdder,
        permitting_adder_amount: permittingAdderAmount,
        water_softener: waterSoftener,
        water_softener_amount: waterSoftenerAmount,
      })
      .then((resi) => {
        let temp = window.location.hash.split("/");
        temp[2] = resi.data.propId;
        let activeProposals = proposals.filter((option) => {
          return +option.isActive === 1;
        });
        temp[3] = activeProposals.length + 1;
        window.location.hash = temp.join("/");
      });
    Alert.success(`${systemSize / 1000}kW Proposal Created and CIA Updated`, {
      position: "top-right",
      effect: "flip",
      beep: false,
      timeout: 5000,
      offset: 100,
      color: "rgba(255, 255, 255, 0.927)",
    });
    getProposalsByProjectId();
    getCustomer();
    setLoading(false);
    setSyncLoading(false);
  };

  const createUpdatedProposal = async () => {
    setLoading(true);
    setSyncLoading(true);
    try {
      const res = await axios.post(apiUrl, {
        method: "create_dns_proposal",
        project_id: proposal.projectId,
        team_id: customer.salesTeamAccountId,
        rep_first: activeUser?.attributes.given_name,
        rep_last: activeUser?.attributes.family_name,
      });
      await Promise.all([getProposalsByProjectId(), getCustomer()]);
      setLoading(false);
      setSyncLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getCustomer = () => {
    axios
      .post(apiUrl, { method: "get_info", project_id: proposal.projectId })
      .then((res) => {
        return [
          setJurisdiction(res.data.data.jurisdiction),
          setCustomer(res.data.data),
          setPrimaryContact(res.data.primaryContact),
          setUtility(res.data.data.utility),
          setEnvelopeId(res.data.data.ciaEnvelopeId),
          setUType(res.data.data.usageType),
          setSquareFootage(res.data.data.sqFootage),
          setSalesTeam(res.data.data.salesTeam),
          setAdders(res.data.adders),
          setServices(res.data.services),
          setCurrentProp(res.data.proposal),
          setSyncLoading(false),
          setSFUsage(res.data.usage),
          setHoaName(res.data.data.hoaName),
          setHoaPhone(res.data.data.hoaPhone),
        ];
      });
  };

  const getSalesTeam = async () => {
    try {
      const res = await axios.post(apiUrl, {
        method: "get_sales_team_test",
        sales_team: salesTeam,
      });

      setTeam(res.data.data);
      setCashPpw(+res.data.data.cashPpw);
      setLoanProducts(res.data.loans);
      setLoanProducts2(res.data.loans2);
      setTeamInv(res.data.inverter);
      setTeam(res.data.data);
      setCashPpw(+res.data.data.cashPpw);
      // TODO: reset this after testing
      setLoanProducts(res.data.loans);
      setLoanProducts2(res.data.loans2);
      setTeamInv(res.data.inverter);
    } catch (error) {
      console.error("Error fetching sales team data:", error);
    }
  };

  const getModules = () => {
    axios.post(apiUrl, { method: "get_modules" }).then((res) => {
      return setModules(res.data.data);
    });
  };

  const getInverters = () => {
    axios.post(apiUrl, { method: "get_inverters" }).then((res) => {
      return setInverters(res.data.data);
    });
  };

  const getProposalsByProjectId = () => {
    axios
      .post(apiUrl, {
        method: "get_proposal_by_project_id",
        project_id: proposal.projectId,
      })
      .then((res) => {
        return setProposals(res.data.data);
      });
  };

  const updateDesignObjective = () => {
    axios
      .post(apiUrl, {
        method: "update_design_objective_test",
        project_id: customer.projectID,
        id: customer.designId,
        Design_Objective__c: designObj,
        Design_Objective_Details__c: designDetails,
        Rep_System_Size_Change_Notes__c: sizeChangeNotes,
        New_to_home_New_build__c: newBuild,
        hoa_name: hoaName,
        hoa_number: hoaPhone,
        e_consent: electronicConsent,
        prop_id: proposal?.propId,
      })
      .then((res) => {
        sendCia();
        getCustomer();
      });
  };

  // military stuff
  let militaryTotal = [];
  militaryMonthly.forEach((e) => {
    militaryTotal.push(+e.amount);
  });

  // USE EFFECTS
  // sets an event listener to the window to update the width of the window
  // TODO: Adjust
  useEffect(() => {
    if (+waterSoftener > 0) {
      setWaterSoftenerAmount(4000 / +dealerFee);
    } else {
      setWaterSoftenerAmount(0);
    }
  }, [waterSoftener, dealerFee]);

  useEffect(() => {
    window.addEventListener("resize", () => setWidth(window.innerWidth));
  }, [window.innerWidth]);

  useEffect(() => {
    if (jurisdiction?.toLowerCase().includes("portland")) {
      setPermittingAdder(1);
      setPermittingAdderAmount(0.1 / +dealerFee);
    } else {
      setPermittingAdder(0);
      setPermittingAdderAmount(0);
    }
  }, [jurisdiction, dealerFee]);

  useEffect(() => {
    if (!dealerFee) return;

    const cost = (() => {
      if (+nest === 0) return 0;
      if (+nest === 1) return 250 / +dealerFee;
      if (+nest === 2) return 450 / +dealerFee;

      return 250 / +dealerFee;
    })();

    setNestCost(cost);
  }, [nest, dealerFee]);

  // handle automatically setting the ac coupled adder if loan a is a ppa and the battery is a tesla
  // handle automatically setting the ac coupled adder if loan a is a ppa and the battery is a tesla
  useEffect(() => {
    if (+loanA.isPpa === 1 && +battery10 >= 11 && +battery10 < 20) {
      setAcCoupled(+battery10 - 10);
      setAcCoupledAmount((1500 * (+battery10 - 10)) / +dealerFee);
    } else if (
      +loanA.isPpa !== 1 &&
      +pvSystemAddOn > 0 &&
      +battery10 >= 11 &&
      +battery10 < 20
    ) {
      setAcCoupled(+battery10 - 10);
      setAcCoupledAmount((1500 * (+battery10 - 10)) / +dealerFee);
    } else {
      setAcCoupled(false);
      setAcCoupledAmount(0);
    }
  }, [loanA, battery10, pvSystemAddOn, dealerFee]);
  // if the view is (1), set user to the active user given and family name
  // TODO: figure out what all the different views are
  // get military monthly, inverters, modules and proposal when the component mounts
  // TODO: Adjust
  useEffect(() => {
    if (+view === 1) {
      setUser(
        `${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`
      );
    }
    getMilitaryMonthly();
    getInverters();
    getModules();
  }, []);

  // Fetch proposal data when proposal ID changes (e.g., after creating a new proposal or initial mount)
  useEffect(() => {
    if (props.match.params.prop_id) {
      getProposal();
    }
  }, [props.match.params.prop_id]);

  // set military cap to true if the total of the military total is greater than or equal to 40000
  // TODO: Adjust
  useEffect(() => {
    if (militaryTotal.length > 0) {
      if (total(militaryTotal) >= 40000) {
        setMilitaryCap(true);
      }
    }
  }, [militaryTotal]);

  // get the estimated lightreach pricing when loanA is "LightReach PPA". This will be displayed in the Solar Amount section
  // TODO: Fix this
  // TODO: Adjust
  useEffect(() => {
    if (loanA?.loanName !== "LightReach PPA" || !state) return;
    // if (powerWall && +battery10Amount % 2 !== 0) return;

    // const getEstimatedPricing = async () => {
    //   try {
    //     // const quotes = await lightReachApi.getQuote({ acctId: customer.lightReachAccountId});
    //     const pricing = await lightReachApi.getEstimatedPricing({
    //       battery: +!!powerWall,
    //       batteryAmount: +!!powerWall ? battery10Amount : 0,
    //       msp,
    //       productId: loanA?.productId,
    //       systemSize: systemSize / 1000,
    //       production: totalProduction,
    //       state: listOfStates.abbr(state),
    //       utilityLseId: proposal.utilityLseId,
    //     });

    //     const quote = pricing.find((q) => q.productId === loanA?.productId);

    //     if (quote) setLightReachQuote(quote);
    //     else throw new Error;
    //   } catch (error) {
    //     console.error("Error fetching LightReach pricing:", error);
    //   }
    // };

    // getEstimatedPricing();
  }, [
    loanA,
    powerWall,
    msp,
    systemSize,
    totalProduction,
    customer,
    battery10Amount,
    dealerFee,
  ]);

  // based on the proposal, set the amounts for the adders if they are greater than 0
  // set the system cost to the sum of the loan amount, rebate and down payment
  // get the proposals by project id and get the customer
  // TODO: Adjust
  useEffect(() => {
    if (+proposal.ballastAmount > 0) {
      setBallastAmount(+proposal.ballastAmount);
    }
    if (+proposal.critterGuardAmount > 0) {
      setCritterGuardAmount(+proposal.critterGuardAmount);
    }
    if (+proposal.mspAmount > 0) {
      setMspAmount(+proposal.mspAmount);
    }
    if (+proposal.pSolarAmount > 0) {
      setPSolarAmount(roundAndFormatNumber(+proposal.pSolarAmount, 4));
    }
    if (+proposal.battery10Amount > 0) {
      if (!batteryChanged) {
        setBattery10Amount(+proposal.battery10Amount);
      }
    }
    if (+proposal.groundMountAmount > 0) {
      setGroundMountAmount(+proposal.groundMountAmount);
    }
    if (!!+proposal.utilityReview) {
      setUtilityReviewAmount(+proposal.utilityReviewAmount);
    }
    setSystemCost(
      Math.ceil(+proposal.loanAmount + +proposal.rebate + +proposal.downPayment)
    );
    if (+proposal.security) {
      setSecurityToggled(true);
    }
    if (+proposal.pvSystemAddOnAmount > 0) {
      setPvSystemAddOnAmount(+proposal.pvSystemAddOnAmount);
    }
    if (proposal?.projectId) {
      getProposalsByProjectId();
      getCustomer();
    }
  }, [proposal]);

  // pushes the services into the adders array
  // @note - adders is a piece of state that needs to be updated via the setAdders function. Not sure if this is acutally working.
  // TODO: Adjust
  useEffect(() => {
    for (let i = 0; i < services.length; i++) {
      adders.push(services[i]);
    }
  }, [services]);

  // sets the timestamp to the current time when the design is updated
  // @note - what is the design?
  // TODO: Adjust
  useEffect(() => {
    if (design) {
      setTimeStamp(moment().format("MM/DD/YY, h:mm a"));
    }
  }, [design]);

  // gets the sales team when the sales team is updated
  // @note - setSalesTeam is only ran when getCustome is ran, there is a better way to do this
  // TODO: Adjust
  useEffect(() => {
    if (salesTeam) {
      getSalesTeam();
    }
  }, [salesTeam]);

  // sets the system size and system size AC based on the panel amount and the mod
  // TODO: Adjust
  useEffect(() => {
    setSystemSize(panelAmount * mod[3]);
    setSystemSizeAC(
      (panelAmount * ((mod[4] * inverter.rating) / 1000)).toFixed(2)
    );
  }, [panelAmount, mod, inverter]);

  // if loan A is 115, set the cash to true and set the view payments to false
  // if loan A is a PPA, set the ion rebate to 0, the dealer fee to 1, the solar to 0 and the MSP amount to 3500
  // else, set the cash to false, the view options to 0, the ppw to the team ppw, the dealer fee to 0.7
  // @note - basically, set certain values based on the loanA type
  // TODO: Adjust
  useEffect(() => {
    if (+loanA.loanId === 115) {
      return (
        setIsCash(true),
        setViewPayments(false),
        setViewOptions(1),
        setPpw(+ppw || cashPpw),
        setBasePpw(+ppw || cashPpw),
        setDealerFee(1)
      );
    }
    if (+loanA.isPpa === 1) {
      // PPA's don't have dealer fees like normal loans
      setViewOptions(1);
      return setDealerFee(1), setPSolar(0), setMspAmount(3500);
    }
    setIsCash(false);
    setViewOptions(1);
    setPpw(+ppw || +team.ppw, true);
    setDealerFee(+loanA.dealerFee);
  }, [loanA]);

  useEffect(() => {
    if (loanA.loanName === "GoodLeap PPA" && proposal?.projectId) {
      goodleapApi
        .getExistingSavings({
          sf_project_id: proposal.projectId,
        })
        .then((res) => {
          setArcadiaSavingsReport(res?.data || []);
        });
    }
  }, [proposal, loanA]);

  // set the annual usage based on the square footage and the usage type ("Square Footage" or "Annual")
  // @note - Las Vegas has a special case for square footage. Also what is uType?
  // TODO: Adjust
  useEffect(() => {
    if (uType === "Square Footage") {
      switch (customer.territory) {
        case "Albuquerque":
         // setAnnualUsage(9503);
          break;
        case "Colorado Springs":
          //setAnnualUsage(9955);
          break;
        case "Buda":
          //setAnnualUsage(12479);
          break;
        case "Denver":
          //setAnnualUsage(10413);
          break;
        case "Dallas":
          //setAnnualUsage(12236);
          break;
        case "Las Vegas":
          if (squareFootage >= 4000) {
            //return setAnnualUsage(
            //  Math.round(2392.4 * Math.pow(+squareFootage, 0.25))
            //);
          } else if (squareFootage < 4000 && squareFootage > 1000) {
            //return setAnnualUsage(Math.round(4.286 * +squareFootage + 1882));
          } else if (squareFootage <= 1000) {
            //return setAnnualUsage(
             // Math.round(195.05 * Math.pow(+squareFootage, 0.5))
            //);
          }
          break;
        case "Utah":
          //setAnnualUsage(10639);
          break;
        case "Oregon":
          //setAnnualUsage(9687);
          break;
        case "North Carolina":
          //setAnnualUsage(13100);
          break;
        case "Richmond":
          //setAnnualUsage(16126);
          break;
        case "Virginia Beach":
          //setAnnualUsage(15052);
          break;
        default:
          //setAnnualUsage(12475);
      }
    }

    if (uType === "Annual" || uType === "Annual - Square Footage") {
      setAnnualUsage(totalUsage);
    }
  }, [customer, uType, squareFootage]);

  // sets each month's production based on the new prop ratio and the system size
  // TODO: Adjust
  useEffect(() => {
    setJanProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * jan)
    );
    setFebProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * feb)
    );
    setMarProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * mar)
    );
    setAprProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * apr)
    );
    setMayProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * mayP)
    );
    setJunProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * jun)
    );
    setJulyProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * julyP)
    );
    setAugProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * aug)
    );
    setSepProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * sep)
    );
    setOctProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * oct)
    );
    setNovProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * nov)
    );
    setDecProduction(
      Math.round(multiply(+newPropRatio, +systemSize / 1000) * dec)
    );
  }, [systemSize]);

  const calculateBatteryCost = () => {
    const basePrice =
      state.toLowerCase().includes("illinois") ||
      state.toLowerCase().includes("texas")
        ? battery10Amount
        : 12500;

    const additionalBatteries = battery10 - 11 > 0 ? (battery10 - 11) * basePrice : 0;
    console.log("addtionalBatteries", additionalBatteries);

    const totalCost = battery10Amount +
      additionalBatteries / +dealerFee +
      acCoupledAmount;
    console.log("totalCost", totalCost);
    return totalCost;
  }

  const createLightReachQuote = async (loan) => {
    const calculatedBatteryCost = calculateBatteryCost();
    const response = await createQuote(
      customer.lightReachAccountId,
      loan.productId,
      msp,
      reRoof,
      battery10,
      calculatedBatteryCost,
      false,
      customer.projectID
    );
    if (response?.errorCode && response.message.includes("Existing QuoteId:")) {
      const match = response.message.match(
        /Existing QuoteId:\s*([a-zA-Z0-9]+)/
      );
      if (match) {
        const curQuote = match[1];
        await createQuote(
          customer.lightReachAccountId,
          loan.productId,
          msp,
          reRoof,
          battery10,
          calculatedBatteryCost,
          false,
          customer.projectID
        );
      }
    }
  };

  // This creates a new temporary TPO loan
  const newLoanCreate = async (loan, isA) => {
    const endIdx = allLoans.at(-1).loanId;
    loan.loanId = endIdx + 1;
    if (isA) {
      const loanDealerFee = +loan.dealerFee || 1;
      if (loan.loanName === "SunGage" && loan.ppwRate != null && Number.isFinite(loan.ppwRate) && loanDealerFee > 0) {
        setPpw(loan.ppwRate / loanDealerFee, true);
      } else if (loan.ppwRate != null && Number.isFinite(loan.ppwRate)) {
        setPpw(loan.ppwRate);
      }
      try {
        const response = await proposalToolApi.savePpaLoanProduct({
          propId: proposal.propId,
          dealerFee: loan.dealerFee,
          firstMonthPayment: loan.firstMonthPayment,
          firstMonthBatteryPayment: loan.firstMonthBatteryPayment,
          interestOnlyPayment: loan.interestOnlyPayment,
          prePayment: loan?.prePayment,
          postPayment: loan?.postPayment,
          isPpa: loan.isPpa,
          itc: loan.itc,
          loanInterest: loan.loanInterest,
          loanName: loan.loanName,
          loanTerm: loan.loanTerm,
          offerId: loan.offerId,
          option: loan.option,
          ppaEscalator: loan.ppaEscalator,
          ppaRate: loan.ppaRate,
          ppwRate: loan.ppwRate,
          productId: loan.productId,
          totalAmount: loan.totalAmount,
        });
        if (loan.loanName === "LightReach PPA") {
          createLightReachQuote(loan);
        }
        loan.loanId = response.loanId;
        allLoans.push(loan);
        // Hopefully this doesnt cause future issues but the setLoanIdA way is actually insanse
        setLoanA(loan);
        // setLoanIdA(allLoans, loanAId.loanId, setLoanA);
      } catch (err) {
        console.log("Error Saving PPA", err.message);
      }
    } else {
      allLoans.push(loan);
      setLoanIdB(allLoans, loanBId.loanId, setLoanB);
    }
  };

  // sets loan a based from a passed in loan id and all loans
  // @note - this is overly complex. There is a way better way to do this. Is also very hard to read.
  // TODO: Adjust
  useEffect(() => {
    if (loanAId?.loanName) {
      newLoanCreate(loanAId, true);
    } else setLoanIdA(allLoans, loanAId, setLoanA);
  }, [loanAId]);

  // sets loan b based from a passed in loan id and all loans
  // @note - this is overly complex and hard to read. It also sets an array instead of a single object like loan a.
  // TODO: Adjust
  useEffect(() => {
    if (loanBId?.loanName) {
      newLoanCreate(loanBId, false);
    } else setLoanIdB(allLoans, loanBId, setLoanB);
  }, [loanBId]);

  // HELPER FUNCTIONS & LOGIC

  // function to set ppa products if acctId and team has ppa and makes an api call to get the light reach pricing
  // @note - confusing function name because it is not getting the light reach pricing, it is setting the ppa products
  const getPpaPricing = async (acctId) => {
    setLoading(true);
    if (acctId && +team.hasPpa === 1) {
      try {
        const expansionPackNum = Number(expansionPack) || 0;
        const expansionPackAmt = Number(expansionPackAmount) || 0;
        const batteryCount =
          battery10 <= 10
            ? +battery10 + expansionPackNum
            : battery10 > 10 && battery10 < 20
              ? +battery10 - 10 + expansionPackNum
              : +battery10 - 20 + expansionPackNum;
        const baseBatteryCost =
          acCoupled && +loanA?.isPpa === 1 && +battery10 >= 11 && +battery10 < 20
            ? calculateBatteryCost()
            : (+battery10 ? +battery10Amount : 0) + (+battery3 ? +battery3Amount : 0);
        const batteryCostForPayload =
          (Number(baseBatteryCost) || 0) + expansionPackAmt * expansionPackNum;

        const res = await lightReachApi.getQuote({
          acctId,
          sfProjectId: customer.projectID,
          hasBattery: battery10 >= 11 && battery10 < 20,
          msp: getMspForLightReachGetQuote(customer?.state, msp, oregonLightreachPricingBump),
          batteryCost: batteryCostForPayload,
          batteryCount,
        });

        if (+reRoof > 0 || !res) {
          setPpaProducts(
            allLoans.map((loan) => ({ ...loan, productId: "", ppwRate: "" }))
          );
        } else {
          let updatedLoans = allLoans.map((loan) => {
            const matchingData = res.find(
              (data) =>
                +data.kwhPrice === +loan.ppaRate &&
                +data.escalationRate === +loan.ppaEscalator
            );
            if (matchingData) {
              return {
                ...loan,
                productId: matchingData.productId,
                ppwRate: matchingData.pricePerWatt,
                ppaRate: matchingData.kwhPrice,
                systemPricingDetails: matchingData.systemPricingDetails,
                totalSystemCost: matchingData.totalSystemCost,
                totalAmountPaid: matchingData.totalAmountPaid,
                dealerFee: 1.0,
              };
            } else {
              return { ...loan, productId: "", ppwRate: "" };
            }
          });
          updatedLoans = updatedLoans.filter((loan) => {
            return loan.loanName !== "LightReach PPA" || loan.productId;
          });
          setPpaProducts(updatedLoans);
          setLoading(false);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  // function to setup margin scalling using jquery.
  // @note - we do NOT want to use jquery in this project and it should be removed.
  var setupMarginScaling = function (firstClass, secondClass) {
    $(window).on("resize", function () {
      var marginRight = $(firstClass).css("margin-right"),
        marginRight15 = parseInt(marginRight) + 12;

      $(secondClass).css({
        width: marginRight15,
      });
    });
    $(window).trigger("resize");
  };
  const getPpaTotalCost = (firstMonthPayment, ppaEscalator, years = 25) => {
    let total = 0;
    let annualCost = firstMonthPayment * 12;
    for (let i = 0; i < years; i++) {
      total += annualCost;
      annualCost *= 1 + ppaEscalator;
    }
    return Math.round(total);
  };

  function roundAndFormatNumber(num, dec) {
    var formattedNumber = num;
    for (let i = 0; i < dec; i++) {
      formattedNumber = formattedNumber * 10;
    }
    formattedNumber = Math.ceil(formattedNumber);
    for (let i = 0; i < dec; i++) {
      formattedNumber = formattedNumber / 10;
    }
    return formattedNumber;
  }

  // callback function that is passed into <AddrMenu /> to handle adding a battery power wall.
  // @note - this is overly complex and hard to read. This callback function also takes 2 callback functions as arguments.
  const adderToggleBatteryPowerWall = (num, operation, operation2) => {
    if (num > 0) {
      return operation(0), operation2(0);
    }
    operation(1); // what is 1?
    operation2(11); // what is 11?
  };

  // callback function that is passed into <AddrMenu /> to handle adding a nest.
  // @note - why are we passing in an extra callback when we could just set it here?
  const adderToggleNest = (num, operation) => {
    if (num === 1 || num > 1) {
      return operation(0);
    }
    operation(1);
  };

  // callback function that is passed into <AddrMenu /> to handle discounts toggling.
  // @note - this function is called "discountToggle" but it is actually setting the preferred utility, same day and referral.
  const discountToggle = (operation) => {
    if (operation === "preferred") {
      // why would we set the preferred utility to 0 if it is already 1?
      if (preferredUtility === 1) {
        return setPreferredUtility(0);
      }
      setSameDay(0);
      setReferral(0);
      setPreferredUtility(1);
    }
    if (operation === "sameDay") {
      // why would we set the same day to 0 if it is already 1?
      if (sameDay === 1) {
        return setSameDay(0);
      }
      setSameDay(1);
      setReferral(0);
      setPreferredUtility(0);
    }
    if (operation === "referral") {
      // why would we set the referral to 0 if it is already 1?
      if (referral === 1) {
        return setReferral(0);
      }
      setSameDay(0);
      setReferral(1);
      setPreferredUtility(0);
    }
  };

  // callback function that is passed into different menus and sets something?
  // @note - This is not a good function name and it is hard to read.
  const adderToggle = (num, operation) => {
    if (num === 1 || num === 2) {
      return operation(0);
    }
    operation(1);
  };

  const adderToggleBoolean = (bool, operation) => {
    if (!!+bool === true) {
      return operation(false);
    }
    operation(true);
  };

  // callback function that is passed into <AddrMenu /> menu and sets something?
  // @note - Not sure what this is doing. The prop we are passing it into is called repAdderToggle but this name does not match.
  const reRoofAdderToggle = (num, operation) => {
    if (num > 0) {
      return operation(0);
    }
    operation(+proposal.reroof);
  };

  // callback function that is passed into <AddrMenu /> menu and runs sets military.
  // @note - num is military and operation is setMilitary in <AddrMenu />
  const militaryAdderToggle = (num, operation) => {
    if (num > 0) {
      return operation(0);
    }
    if (num === 0) {
      if (militaryCap) {
        return operation(3);
      }
      operation(1);
    }
  };

  // callback function that is passed into <AdderMenu />. It is also ran on a few different onClick events.
  const repAdderToggle = (num, operation, number) => {
    if (num === number) {
      return operation(0);
    }
    operation(number);
  };

  // function that returns the prepayment. It is used to show the savings number and pmt1.
  const prePayment = () => {
    if (loanA.loanName === "SunGage") {
      return Math.round(loanA.prePayment * loanAmount);
    }
    if (
      custUtility === "Oncor" ||
      custUtility === "TXU" ||
      custUtility === "Reliant" ||
      custUtility === "Green Mountain Energy" ||
      custUtility === "PEC - Pedernales Electric Cooperative" ||
      custUtility === "GVEC -Guadalupe Valley Electric Cooperative" || // is this a typo?
      custUtility === "Bluebonnet Electric Cooperative" ||
      custUtility === "NBU- New Braunfels Utilities" || // is this a typo?
      custUtility === "City of Boerne Public Utilities" ||
      custUtility === "City Public Service (CPS)" ||
      custUtility === "Colorado Springs Utilities" ||
      custUtility === "City of Georgetown Utility" ||
      custUtility === "Portland General Electric (PGE)" ||
      custUtility === "Pacific Power"
    ) {
      return Math.round(loanA.prePayment * loanAmount);
    }
    let tax = stateTax;
    if (utilityLocation === "South Carolina") {
      tax = 3500;
    }
    if (custUtility === "Xcel Energy (New Mexico)" && powerWall) {
      tax = 1000;
    }
    if (+recValue.afterEnergy > 0) {
      tax = recValue.afterEnergy;
    }
    if (stateTax > 0 || recValue.afterEnergy) {
      let a = loanA.loanInterest / 100 / 12;
      let b = a + 1;
      let c = loanA.loanTerm * 12 - 4;
      let d = Math.pow(b, -c);
      let e = 1 - d;
      let f = a / e;
      let g = f * (loanAmount * (1 - +loanA.itc) - tax);

      return Math.round(g);
    }
    if (+rebate > 0 && +rebateSF === 0) {
      let a = loanA.loanInterest / 100 / 12;
      let b = a + 1;
      let c = loanA.loanTerm * 12 - 6;
      let d = Math.pow(b, -c);
      let e = 1 - d;
      let f = a / e;
      let g = f * (loanAmount * (1 - +loanA.itc) - rebate);

      return Math.round(g);
    }
    // this is already being calculated in the if statement above. Why is it being calculated again?
    return Math.round(loanA.prePayment * loanAmount);
  };

  // sets loan a object based from a passed in loan id and all loans. It does not actually set the loan id.
  const setLoanIdA = (arr, id, operation) => {
    for (let i = 0; i < arr.length; i++) {
      if (+arr[i].loanId === +id) {
        return operation({
          loanId: +arr[i].loanId,
          loanName: arr[i].loanName,
          loanTerm: +arr[i].loanTerm,
          interestOnlyPayment: +arr[i].interestOnlyPayment,
          prePayment: +arr[i]?.prePayment ? +arr[i].prePayment : proposal.pre1,
          postPayment: +arr[i]?.postPayment
            ? +arr[i].postPayment
            : proposal.post1,
          loanInterest: +arr[i].loanInterest,
          itc: +arr[i].itc,
          specialPrice: +arr[i].specialPrice,
          isPpa: +arr[i].isPpa,
          ppaRate: +arr[i].ppaRate,
          ppaEscalator: +arr[i].ppaEscalator,
          dealerFee: +arr[i].dealerFee,
          ppwRate: +arr[i].ppwRate,
          productId: arr[i].productId,
          offerId: arr[i]?.offerId,
          option: arr[i]?.option,
          firstMonthPayment: arr[i]?.firstMonthPayment,
          firstMonthBatteryPayment: arr[i]?.firstMonthBatteryPayment,
          totalAmount: arr[i]?.totalAmount,
        });
      }
    }
  };

  // sets loan b array based from a passed in loan id and all loans. It does not actually set the loan id.
  // @note - this should match loan a. Also why pass in an operation if it will always be setLoanB?
  const setLoanIdB = (arr, id, operation) => {
    for (let i = 0; i < arr.length; i++) {
      if (+arr[i].loanId === +id) {
        return operation({
          loanId: +arr[i].loanId,
          loanName: arr[i].loanName,
          loanTerm: +arr[i].loanTerm,
          interestOnlyPayment: +arr[i].interestOnlyPayment,
          prePayment: +arr[i]?.prePayment ? +arr[i].prePayment : proposal.pre2,
          postPayment: +arr[i]?.postPayment
            ? +arr[i].postPayment
            : proposal.post2,
          loanInterest: +arr[i].loanInterest,
          itc: +arr[i].itc,
          specialPrice: +arr[i].specialPrice,
          isPpa: +arr[i].isPpa,
          ppaRate: +arr[i].ppaRate,
          ppaEscalator: +arr[i].ppaEscalator,
          dealerFee: +arr[i].dealerFee,
          ppwRate: +arr[i].ppwRate,
          productId: arr[i].productId,
          offerId: arr[i]?.offerId,
          option: arr[i]?.option,
          firstMonthPayment: arr[i]?.firstMonthPayment,
          firstMonthBatteryPayment: arr[i]?.firstMonthBatteryPayment,
          totalAmount: arr[i]?.totalAmount,
        });
      }
    }
  };

  // takes in an array of numbers and returns the sum of all the numbers
  const total = (arr) => arr?.reduce((a, b) => a + b);

  // helper function that formats a phone number. This can be moved to a utils file and used in other places.
  function formatPhoneNumber(value) {
    if (!value) return value;

    const phoneNumber = value.replace(/[^\d]/g, "");

    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;

    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  // callback function to handle phone number input? WHy is it called handleInput and uses formatPhoneNumber?
  const handleInput = (e, operation) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    operation(formattedPhoneNumber);
  };

  // function use to calc loan1Savings by passing in loan1Bills.
  // @note - this should be put in the scope of savingsCalc
  let saving = [];
  let savings = [];
  let years1 = [];
  let save = [];
  const savingsCalc = (arr) => {
    postYears.slice(0, arr.length);
    years1 = postYears.slice(-(25 - arr.length), 25);
    for (let i = 0; i < arr.length; i++) {
      saving.push(postYears[i] + arr[i]);
    }
    save = saving.concat(years1);
    for (let i = 0; i <= years.length - 1; i++) {
      savings.push(years[i] - save[i]);
    }
    savings = savings.map((x) => x * 12);
    return total(savings);
  };

  // function use to calc loan2Savings by passing in loan2Bills.
  // @note - this should be put in the scope of savingsCalc
  let saving1 = [];
  let savings1 = [];
  let years11 = [];
  let save1 = [];
  const savingsCalc1 = (arr) => {
    postYears.slice(0, arr.length);
    years11 = postYears.slice(-(30 - arr.length), 30);
    for (let i = 0; i < arr.length; i++) {
      saving1.push(postYears[i] + arr[i]);
    }
    save1 = saving1.concat(years11);
    for (let i = 0; i <= years.length - 1; i++) {
      savings1.push(years[i] - save1[i]);
    }
    savings1 = savings1.map((x) => x * 12);
    return total(savings1);
  };

  // function used to increase the panelAmount by 1
  const addPanel = () => {
    setPanelAmount(panelAmount + 1);
  };

  // function used to decrease the panelAmount by 1
  const removePanel = () => {
    setPanelAmount(panelAmount - 1);
  };

  // what does cia even mean? Looks like it sents errors and makes an api call to update a design objective.
  const cia = () => {
    if (!designObj) {
      return (
        setShowError(true),
        setErrorMessage("Please specify customer's design preference above."),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 7500)
      );
    }
    if (hoa) {
      if (!hoaName || !hoaPhone) {
        return (
          setShowError(true),
          setErrorMessage("Please add HOA information."),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 7500)
        );
      }
    }
    if (panelAmount !== originalPanelAmount && !sizeChangeNotes) {
      return (
        setShowError(true),
        setErrorMessage("Please specify reason for system size change."),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 7500)
      );
    }
    updateDesignObjective();
    setCiaLoading(true);
  };

  // what does twentyFiveYear do?
  const twentyFiveYear = (total, years, ratePercent) => {
    let interestRate = ratePercent / 100 + 1;
    return (total * Math.pow(interestRate, years)).toFixed(2);
  };

  // function that calls createProposal if signed and checks for other possible errors.
  const buildNewProposal = () => {
    if (signedProp === true) {
      return createSignedProposal();
    }
    if (panelAmount < 6) {
      return Alert.error(`Minimum system size is 6 panels`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (miscCash === 1 && miscCashNotes === "") {
      return Alert.error(`Add notes to the Misc Cash Incentive`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (miscCash === 1 && miscCashAmount < 1) {
      return Alert.error(`Add amount to the Misc Cash Incentive`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (maxOffset && uType !== "Square Footage") {
      if ((totalProduction / totalUsage) * 100 >= +maxOffset + 0.5) {
        return Alert.error(`Max offset is ${maxOffset}% in ${custUtility}`, {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
      }
    }
    if (maxSystemSize) {
      if (systemSize > +maxSystemSize) {
        return Alert.error(
          `Max system size is ${maxSystemSize / 1000} kW in ${custUtility}`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          }
        );
      }
      if (maxModCount * mod[3] > +maxSystemSize) {
        return Alert.error(
          `Max system size is ${maxSystemSize / 1000
          } kW in ${custUtility}. Max panel count needs to be lowered`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          }
        );
      }
    }
    if (utilityLocation === "Nevada" && systemCost > 245000) {
      return Alert.error(`Cannot have system cost be over $245,000 in Nevada`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    return createProposal(), setLoading(true), setSyncLoading(true);
  };

  // this just lives on its own and is not used in scope of any function. Why is it here?
  if (originalPanelAmount === 0) {
    setOriginalPanelAmount(panelAmount);
  }

  // this just lives on its own and is not used in scope of any function. Looks like it sets sharedHome to 1 and should be at least a forEach.
  if (customer.designType) {
    types = customer.designType.split(";");
    types.some((designType) => {
      if (designType === "MultiFamily/Shared Roofs") {
        sharedHome = 1;
        return true;
      }
      return false;
    });
  }

  // thoses are definded here but never really used and are overwritten in view6
  let loanSource = loanA.loanName;
  let loanProduct = `Single ${loanA.loanTerm}yr ${loanA.loanInterest}%`;
  if (loanA.loanName?.toLowerCase() === "goodleap") {
    loanSource = "LoanPal";
  }
  if (+loanA.loanId === 115) {
    loanSource = "Owner Financing";
    loanProduct = "";
  }

  // helpre function to multiply. This is not necessary and can be removed.
  let multiply = (num1, num2) => {
    return num1 * num2;
  };

  // set surveyTypes based on customer.surveyType.
  let surveyTypes;
  if (customer.surveyType) {
    surveyTypes = customer.surveyType.split(";");
  }

  // uses surveyTypes to set surveys based on the surveyTypes.
  let surveys = [];
  if (customer.surveyType) {
    for (let i = 0; i <= surveyTypes.length; i++) {
      if (surveyTypes[i] === "Roof Measurements Needed") {
        surveys.push(surveyTypes[i]);
      }
      if (surveyTypes[i] === "Suneyes Needed") {
        surveys.push(surveyTypes[i]);
      }
      if (surveyTypes[i] === "Traditional") {
        surveys.push(surveyTypes[i]);
      }
      if (surveyTypes[i] === "GoPro") {
        surveys.push(surveyTypes[i]);
      }
    }
  }

  // environmental impact functions
  const gallons = () => {
    let one = totalProduction * -0.000689551;
    if (nest > 0) {
      one = totalProduction * -0.000689551;
    }
    let two = -one;
    let three = two * 1.10231;
    let four = three * 67629;
    return Math.round(four / 30);
  };
  const homes = () => {
    let one = totalProduction * 30;
    if (nest > 0) {
      one = totalProduction * 30;
    }
    return Math.round(one / 10000);
  };
  const garbages = () => {
    let one = totalProduction * -0.000689551;
    if (nest > 0) {
      one = totalProduction * -0.000689551;
    }
    let two = -one;
    let three = two * 1.10231;
    let four = three * 36;
    return Math.round(four);
  };
  const trees = () => {
    let one = totalProduction * -0.000689551;
    if (nest > 0) {
      one = totalProduction * -0.000689551;
    }
    let two = -one;
    let three = two * 1.10231;
    let four = three * 798;
    return Math.round(four);
  };

  // Views functions? maybe we can figure out what these do and change the names.
  // @note - why do we need these at all
  const viewA = () => {
    setViewAdders(!viewAdders);
    setViewEquipment(false);
    setViewLoans(false);
    setViewProposals(false);
    setViewCiaInfo(false);
    setSendCiaDoc(false);
  };
  const viewE = () => {
    setViewEquipment(!viewEquipment);
    setViewAdders(false);
    setViewLoans(false);
    setViewProposals(false);
    setViewCiaInfo(false);
    setSendCiaDoc(false);
  };
  const viewL = () => {
    setViewLoans(!viewLoans);
    setViewEquipment(false);
    setViewAdders(false);
    setViewProposals(false);
    setViewCiaInfo(false);
    setSendCiaDoc(false);
  };
  const viewP = () => {
    setViewProposals(!viewProposals);
    setViewLoans(false);
    setViewEquipment(false);
    setViewAdders(false);
    setViewCiaInfo(false);
    setSendCiaDoc(false);
  };
  const viewApp = () => {
    setViewProposals(false);
    setViewLoans(false);
    setViewEquipment(false);
    setViewAdders(false);
    setViewCiaInfo(!viewCiaInfo);
    setSendCiaDoc(false);
  };
  const closeSlider = () => {
    setViewProposals(false);
    setViewCiaInfo(false);
    setViewLoans(false);
    setViewEquipment(false);
    setViewAdders(false);
    setViewNest(false);
    setViewCustomer(false);
    setSendCiaDoc(false);
    setSlider(false);
    setQualify(false);
    setGoodLeap(false);
    setViewApps(false);
  };

  const stateDisclosures = () => {
    return (
      <>
        {state === "Texas" ? (
          <div className="savingsText v9 par">
            Regulated by The Texas Department of Licensing and Regulation, P.O.
            Box 12157, Austin, Texas 78711, 1-800-803-9202, 512-463-6599;
            website: www.tdlr.texas.gov.
            <br />
            <br />
            In the case that you have a de-regulated power utility company, this
            disclosure provides you notice that ION’s proposal and estimate for
            savings, net metering, off-sets, etc. is based on you using a power
            utility service that offers favorable net metering offerings/ terms.
            You are responsible for determining your power utility provider’s
            net metering offerings/terms and acknowledge that switching utility
            power providers may be necessary (where available) to make solar
            most beneficial. You understand that if you move forward with
            signing the Customer Installation Agreement with ION, that you bear
            the ultimate risk regarding the net metering terms available and ION
            is not responsible or liable for actual net metering terms that are
            or are not available through your power utility provider.
            <br />
            <br />
            Licensed Contractor: ION Developer, LLC, TECL # 30990.
          </div>
        ) : null}
        {state === "Utah" ? (
          <div className="savingsText v9 par">
            In Utah, there are multiple different power utility providers that
            offer different net metering offerings. This proposal, estimated
            savings, and offsets are based on the assumption that your
            uLastility provider has a favorable net metering offering. However,
            if your utility provider is Rocky Mountain Power (“RMP”), you will
            not be eligible for one-to-one net metering. Instead, RMP offers a
            credit for any power production your solar system provides to the
            power grid (which is less than the cost you may pay for any power
            you use from the grid). Accordingly, if you have RMP (or a power
            utility company that provides similar net metering offerings),
            please recognize that your "offset" or “savings” estimates can vary
            widely based on numerous factors, which is why ION can only provide
            a broad range for potential estimated savings. Overall, ION cannot
            guarantee any estimates in regards to your potential offset or cost
            savings you may obtain through net metering. You are ultimately
            responsible for verifying the net metering options and potential
            savings that are available through your power utility provider.
          </div>
        ) : null}
        {state === "North Carolina" ? (
          <div className="savingsText v9 par">
            If your utility provider is Duke Energy Carolinas (“Duke Carolinas”)
            or Duke Energy Progress (“Duke Progress”), beginning on October 1,
            2023, net metering policies will be changing and they will no longer
            be offering a true one-to-one net metering rate. There are a few
            different options in moving forward with Duke Carolinas’ or Duke
            Energy Progress’s net metering offerings, including by applying for
            a limited, intermediate/bridge net metering offering. It is
            ultimately your responsibility to look into the new net metering
            offerings/policies, to apply for the appropriate option, and to
            understand the specific benefits of the various offerings. ION
            encourages you to contact your power utility company regarding their
            net metering offerings and changes. Additionally, please recognize
            that your "offset" or “savings” estimates provided in this proposal
            can vary widely based on numerous factors, which is why ION can only
            provide a broad range for potential estimated savings. Your actual
            savings may fall outside this range. Overall, ION cannot guarantee
            any estimates in regards to your potential offset or cost savings
            you may obtain through net metering. You are ultimately responsible
            for verifying the net metering options and potential savings that
            are available through your power utility provider.
          </div>
        ) : null}
      </>
    );
  };
  const view6Ppa = () => {
    return (
      <div className="view6">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="fontNew2 v6">
                Your Solar{" "}
                {isCash ? "Purchase" : +loanA.isPpa === 1 ? "TPO" : "Loan"}{" "}
                Summary
              </div>
              <div className="savingsContainer v6"></div>
            </div>
          </div>
          <div className="costsContainer">
            <div className="row g-lg-5">
              <div className="col">
                <div className="savingsEstimate v6">
                  <div className="savingsNumber v6">
                    ${loanA.ppaRate.toLocaleString(undefined)}
                  </div>
                  <div className="savingsText">Cost per kWh</div>
                </div>
              </div>
              <div className="col">
                <div className="savingsEstimate v6">
                  <div className="savingsNumber v6">
                    {(loanA.ppaEscalator * 100).toLocaleString(undefined)}%
                  </div>
                  <div className="savingsText">Escalator</div>
                </div>
              </div>
              <div className="col">
                <div className="savingsEstimate v6">
                  <div className="savingsNumber v6">
                    $
                    {(loanA.firstMonthPayment
                      ? loanA.firstMonthPayment
                      : loanA.ppaRate * (totalProduction / 12)
                    )
                      .toFixed(2)
                      .toLocaleString(undefined)}
                  </div>
                  <div className="savingsText">Monthly Payment Yr 1</div>
                </div>
              </div>
              {battery10 > 0 &&
                (!+loanA.isPpa ||
                  (+loanA.isPpa === 1 &&
                    loanA.loanName.toLowerCase().includes("lightreach"))) ? (
                <div className="col">
                  <div className="savingsEstimate v6">
                    <div className="savingsNumber v6">
                      $
                      {loanA?.firstMonthBatteryPayment !== 0 &&
                        `${loanA.firstMonthBatteryPayment
                          ?.toLocaleString(undefined)
                          ?.split(".")[0]
                        }`}
                    </div>
                    <div className="savingsText">Battery Payment Yr 1</div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="d-sm-none" align="center">
            <div className="lineBreak m-0 mt-4"></div>
          </div>
          {state === "Illinois" && +loanA.isPpa === 1 && battery10 > 0 &&
            <div className="row">
              <div className="col" align="center">
                <div className="saveText">
                  $4,050 battery rebate is included in the battery pricing and will go to the contractor for both PPA and Loan Proposals
                </div>
              </div>
            </div>
          }
          <div className="row">
            <div className="col" align="center">
              <div className={isCash ? "noDisplay" : "saveText"}>
                {loanA.loanTerm} YEAR AVERAGE POWER COST PER kWh
              </div>
            </div>
          </div>
          <div className="row">
            <div className={isCash ? "noDisplay" : "col chartContainer"}>
              {loanA ? (
                <PerKwChart
                  viewOptions={viewOptions}
                  years={years}
                  totalUsage={totalUsage}
                  postYears={postYears}
                  totalProduction={totalProduction}
                  loan1Bills={loan1Bills}
                  ppaRateA={loanA.ppaRate}
                  ppaRateB={loanB.ppaRate}
                  escalationRateA={loanA?.ppaEscalator}
                  escalationRateB={loanB?.ppaEscalator}
                  loanTermA={loanA.loanTerm}
                  loanTermB={loanB.loanTerm}
                  loan2Bills={loan2Bills}
                  width={width}
                  smallBreakPoint={smallBreakPoint}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const view6 = () => {
    // Tesla IL add-on is only rolled into `rebate` for non-PPA (see useEffect below). The summary
    // "Inverter Rebate" row must not subtract 4050×PW when that amount was never added (e.g. PPA),
    // or the displayed value goes negative.
    const ilTeslaRebateInTotal =
      +loanA.isPpa !== 1 &&
      [
        utilitiesMap["Ameren Illinois"],
        utilitiesMap["Commonwealth Edison (ComEd)"],
      ].includes(custUtility) &&
      +powerWall > 0
        ? 4050 * +powerWall
        : 0;
    const purchaseSummaryInverterRebateDisplay = Math.max(
      0,
      Math.round((+rebate || 0) - ilTeslaRebateInTotal),
    );

    return (
      <div className="view6">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="fontNew2 v6">
                Your Solar{" "}
                {isCash ? "Purchase" : +loanA.isPpa === 1 ? "PPA" : "Loan"}{" "}
                Summary
              </div>
              <div className="savingsContainer v6"></div>
            </div>
          </div>
          <div className="v6Container">
            <div className="v6Container low">
              <div className="row">
                <div className="col-2 offset-3">
                  {showNetCost && <div className="savingsNumber minus">-</div>}
                </div>
                <div className="col-2 offset-3 offset-sm-2">
                  {showNetCost && <div className="savingsNumber equals">=</div>}
                </div>
              </div>
            </div>
          </div>
          <div className="costsContainer">
            <div className="row g-lg-5">
              <div className="col">
                <div className="savingsEstimate v6">
                  <div className="savingsNumber v6">
                    ${Math.ceil(systemCost).toLocaleString(undefined)}
                  </div>
                  <div className="savingsText">Total System Price</div>
                </div>
              </div>
              {showNetCost && (
                <div className="col">
                  <div className="savingsEstimate v6">
                    <div className="savingsNumber v6">
                      $
                      {Math.round(
                        (loanAmount + +downPayment - homeEnergyTotal) *
                        loanA.itc +
                        +stateTax +
                        +discounts +
                        +rebate +
                        +recValue.afterEnergy +
                        pacificPowerRebate +
                        centerPointRebate +
                        gvecNewBatteryRebate

                      ).toLocaleString(undefined)}
                    </div>
                    <div className="savingsText">
                      {" "}
                      {uType === "Square Footage"
                        ? "Potential Local Incentives"
                        : "Local Incentives"}
                    </div>
                  </div>
                </div>
              )}
              {showNetCost && (
                <div className="col">
                  <div className="savingsEstimate v6">
                    <div className="savingsNumber v6">
                      ${Math.round(netCost).toLocaleString(undefined)}
                    </div>
                    <div className="savingsText">
                      {state === "Nevada" || loanA.loanName === "Flic"
                        ? "Potential"
                        : null}{" "}
                      Net System Cost
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="d-sm-none" align="center">
            <div className="lineBreak m-0 mt-4"></div>
          </div>
          {payments()}
          {state === "South Carolina" && (
            <div
              className="row"
              style={{
                marginTop: "1rem",
                textAlign: "center",
                fontSize: "12px",
                opacity: "0.7",
              }}
            >
              This Total System Price is the total amount owed to ION for the
              solar system and its installation. It does not include: (1) total
              interest to be paid if obtaining a loan to finance the system
              (please consult your financing documents for that information); or
              (2) maintenance and/or repairs of the solar system.
            </div>
          )}
          <div className="costsContainer v6">
            <div className="row g-lg-5">
              <div className="col-6 px-0 px-sm-4">
                <div className="financeContainer">
                  <div className="costs v6 black">
                    <div className="costsText v6 black">
                      {isCash ? "PURCHASE" : "FINANCING"}{" "}
                      {viewOptions === 0 ? "OPTIONS" : ""}
                    </div>
                  </div>
                  <div className="costs v6 gray">
                    <div className="costsText v6 gray">Total System Cost</div>
                  </div>
                  {isCash ? null : (
                    <div className="costs v6 dotted">
                      <div className="costsText v6 dotted">Down Payment</div>
                    </div>
                  )}
                  {preferredUtility === 1 ? (
                    <div className="costs v6">
                      <div className="costsText v6">
                        Preferred Utility Discount
                      </div>
                    </div>
                  ) : utility === "Portland General Electric (PGE)" ||
                    utility === "Pacific Power" ? (
                    +rebateSF > 0 ? (
                      <div className="costs v6">
                        <div className="costsText v6">{oregonLabel}</div>
                      </div>
                    ) : (
                      <></>
                    )
                  ) : custUtility === "Austin Energy" && proposal.rebate > 0 ? (
                    <div className="costs v6">
                      <div className="costsText v6">Utility Rebate</div>
                    </div>
                  ) : +rebate > 0 ? (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">
                        {custUtility === "Xcel Energy (New Mexico)" && powerWall
                          ? "Battery"
                          : custUtility === "Ameren Illinois" ||
                            custUtility === "Commonwealth Edison (ComEd)"
                            ? "Inverter"
                            : "Upfront"}{" "}
                        Rebate
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {[
                    utilitiesMap["Ameren Illinois"],
                    utilitiesMap["Commonwealth Edison (ComEd)"],
                  ].includes(custUtility) &&
                    powerWall > 0 && (
                      <div className="costs v6 dotted">
                        <div className="costsText v6">Powerwall Rebate</div>
                      </div>
                    )}
                  {pacificPowerRebate > 0 && (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">Pacific Power Rebate</div>
                    </div>
                  )}
                  {centerPointRebate > 0 && (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">CenterPoint Rebate</div>
                    </div>
                  )}
                  {gvecNewBatteryRebate > 0 && (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">GVEC Rebate</div>
                    </div>
                  )}
                  {isCash && proposal.rebate < 1 ? null : (
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        {isCash ? "Purchase Amount" : "Total Financed Amount"}
                      </div>
                    </div>
                  )}
                  {showNetCost && (
                    <div className="costs v6">
                      <div className="costsText v6">
                        {state === "Illinois" ? `Estimated ` : ""}Potential
                        State/Local/REC's
                      </div>
                    </div>
                  )}
                  {showNetCost && (
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        {state === "Nevada" || loanA.loanName === "Flic"
                          ? "Potential"
                          : null}{" "}
                        Net System Cost
                      </div>
                    </div>
                  )}
                  {isCash ? null : (
                    <>
                      <div className="costs v6">
                        <div className="costsText v6 gray">Term Length</div>
                      </div>
                      <div className="costs v6 blue">
                        <div className="costsText v6 blue">Monthly Payment</div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className={viewOptions === 0 ? "col-3 px-0 px-sm-4" : "col"}>
                <div
                  className={
                    viewOptions === 0 && width < smallBreakPoint
                      ? "financeContainer hide-border"
                      : "financeContainer"
                  }
                >
                  <div className="costs v6 black">
                    <div className="costsText v6 blue">
                      {isCash
                        ? "Pricing"
                        : viewOptions === 0
                          ? "Option 1"
                          : `${loanA.loanName} ${loanA.loanTerm} YR ${loanA.loanInterest}%`}
                    </div>
                  </div>
                  <div className="costs v6 gray">
                    <div className="costsText v6 gray">
                      ${Math.ceil(systemCost).toLocaleString(undefined)}
                    </div>
                  </div>
                  {isCash ? null : (
                    <div className="costs v6 dotted">
                      <div className="costsText v6 dotted">
                        ${Math.round(downPayment).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}

                  {preferredUtility === 1 ? (
                    <>
                      <div className="costs v6">
                        <div className="costsText v6">
                          $
                          {Math.round(
                            preferredUtilityAmount * systemSize
                          ).toLocaleString(undefined)}
                        </div>
                      </div>
                    </>
                  ) : +rebate > 0 ? (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">
                        $
                        {Math.round(
                          [
                            utilitiesMap["Ameren Illinois"],
                            utilitiesMap["Commonwealth Edison (ComEd)"],
                          ].includes(custUtility) && powerWall > 0
                            ? purchaseSummaryInverterRebateDisplay
                            : rebate
                        ).toLocaleString(undefined)}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {[
                    utilitiesMap["Ameren Illinois"],
                    utilitiesMap["Commonwealth Edison (ComEd)"],
                  ].includes(custUtility) &&
                    powerWall > 0 && (
                      <div className="costs v6 dotted">
                        <div className="costsText v6">
                          {proposal.projectId == "a00PC00000NT0H7YAL"
                            ? "$8,100"
                            : "$4,050"}
                        </div>
                      </div>
                    )}
                  {pacificPowerRebate > 0 && (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">
                        ${Math.round(pacificPowerRebate).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}
                  {centerPointRebate > 0 && (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">
                        ${Math.round(centerPointRebate).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}
                  {gvecNewBatteryRebate > 0 && (
                    <div className="costs v6 dotted">
                      <div className="costsText v6">
                        ${Math.round(gvecNewBatteryRebate).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}
                  {isCash && proposal.rebate < 1 ? null : (
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        ${Math.round(loanAmount).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}
                  {showNetCost && (
                    <div className="costs v6">
                      <div className="costsText v6">
                        $
                        {Math.round(
                          recValue.afterEnergy || stateTax
                        ).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}
                  {showNetCost && (
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        ${Math.round(netCost).toLocaleString(undefined)}
                      </div>
                    </div>
                  )}

                  {isCash ? null : (
                    <>
                      <div className="costs v6">
                        <div className="costsText v6 gray">
                          {loanA.loanTerm} Years
                        </div>
                      </div>
                      <div className="costs v6 blue">
                        <div className="costsText v6 blue">
                          $
                          {Math.round(
                            sungagePayments
                              ? sungagePayments.initialMonthlyPayment
                              : loanA.prePayment * loanAmount
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {false ? ( // remove option 2
                <div className="col-3 px-0 px-sm-4">
                  <div className="financeContainer">
                    <div className="costs v6 black">
                      <div className="costsText v6 blue">Option 2</div>
                    </div>
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        ${Math.ceil(systemCost).toLocaleString(undefined)}
                      </div>
                    </div>
                    <div className="costs v6 dotted">
                      <div className="costsText v6 dotted">
                        ${Math.round(downPayment).toLocaleString(undefined)}
                      </div>
                    </div>
                    {preferredUtility === 1 ? (
                      <>
                        <div className="costs v6">
                          <div className="costsText v6">
                            $
                            {Math.round(
                              preferredUtilityAmount * systemSize
                            ).toLocaleString(undefined)}
                          </div>
                        </div>
                      </>
                    ) : +rebate > 0 ? (
                      <div className="costs v6 dotted">
                        <div className="costsText v6">
                          $
                          {Math.round(
                            [
                              utilitiesMap["Ameren Illinois"],
                              utilitiesMap["Commonwealth Edison (ComEd)"],
                            ].includes(custUtility) && powerWall > 0
                              ? purchaseSummaryInverterRebateDisplay
                              : rebate
                          ).toLocaleString(undefined)}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    {[
                      utilitiesMap["Ameren Illinois"],
                      utilitiesMap["Commonwealth Edison (ComEd)"],
                    ].includes(custUtility) &&
                      powerWall > 0 && (
                        <div className="costs v6 dotted">
                          <div className="costsText v6">
                            {proposal.projectId == "a00PC00000NT0H7YAL"
                              ? "$8,100"
                              : "$4,050"}
                          </div>
                        </div>
                      )}
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        ${Math.round(loanAmount).toLocaleString(undefined)}
                      </div>
                    </div>
                    <div className="costs v6 dotted">
                      <div className="costsText v6 dotted">
                        $
                        {Math.round(
                          (loanAmount + +downPayment - homeEnergyTotal) *
                          loanA.itc
                        ).toLocaleString(undefined)}
                      </div>
                    </div>
                    <div className="costs v6">
                      <div className="costsText v6">
                        $
                        {Math.round(
                          recValue.afterEnergy || stateTax
                        ).toLocaleString(undefined)}
                      </div>
                    </div>
                    <div className="costs v6 gray">
                      <div className="costsText v6 gray">
                        ${Math.round(netCost).toLocaleString(undefined)}
                      </div>
                    </div>
                    <div className="costs v6">
                      <div className="costsText v6 gray">
                        {loanB.loanTerm} Years
                      </div>
                    </div>
                    <div className="costs v6 lightBlue">
                      <div className="costsText v6 lightBlue">
                        ${Math.round(loanB.prePayment * loanAmount)}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            {loanA.loanName === "Flic" ? (
              <div className="row">
                <div className="col">
                  <div className="savingsText v5">
                    This provided loan term and payment is subject to approval
                    by lender and is provided for illustrative purposes only.
                    Your payment will automatically be the higher payment amount
                    provided that does not account for you applying the amount
                    or value you may receive from a tax credit/incentive to the
                    loan principal. The 15-year loan product provides a
                    promotion whereby you will not have any loan payments for
                    the first 24 months of your loan term. Before the 24th month
                    of your loan term, you may apply the value you may receive
                    from any tax credit/incentive to recalculate your loan to
                    the provided lower payment. For the 20-year loan product,
                    upon lender approval, you may apply the value you may
                    receive of any tax credit toward the principal of your loan
                    and receive a one-time recalculation of your loan to obtain
                    the provided lower payment.
                  </div>
                </div>
              </div>
            ) : loanA.loanName === "Sunlight" ? (
              <div className="row">
                <div className="col">
                  <div className="savingsText v5">
                    No down payment required. The fixed Annual Percentage Rate
                    for a {loanA.loanTerm} year loan is {loanA.loanInterest}%.
                    The first monthly payment on the loan is due approximately
                    90 days after installation. The amount of your first 16
                    payments will be $
                    {Math.round(loanA.prePayment * loanAmount)}. If you make a
                    voluntary payment of $
                    {(loanAmount + +downPayment - homeEnergyTotal) * loanA.itc}{" "}
                    ({loanA.itc}% of your amount financed) by payment 16, your
                    remaining {loanA.loanTerm * 12 - 16} payments will be
                    approximately ${Math.round(loanA.prePayment * loanAmount)}.
                    If no voluntary payment is made, the remaining{" "}
                    {loanA.loanTerm * 12 - 16} payments will be $
                    {Math.round(loanA.postPayment * loanAmount)}. The numbers
                    presented here are estimates only. The payment term stated
                    in your loan documents will govern. Your loan agreement may
                    assume you have not elected to pay by ACH
                  </div>
                </div>
              </div>
            ) : null}
            {/* <div className={isCash ? "noDisplay" : ""}>
              {+view === 1 ? (  // remove option 2
                <div className="col">
                  <div className="costs">
                    <div className="form-check form-switch form-switch">
                      <input
                        disabled={+loanA.specialPrice > 1}
                        onChange={(e) =>
                          adderToggle(viewOptions, setViewOptions)
                        }
                        className="form-check-input v6"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={viewOptions === 0}
                      />
                    </div>
                    <div className="costsText option2">Option 2</div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div> */}
            <div className="row">
              <div className="col" align="center">
                <div className={isCash ? "noDisplay" : "saveText"}>
                  ESTIMATED {loanA.loanTerm} YEAR AVERAGE POWER COST PER kWh
                </div>
              </div>
            </div>
            <div className="row">
              <div className={isCash ? "noDisplay" : "col chartContainer"}>
                {loanA ? (
                  <PerKwChart
                    viewOptions={viewOptions}
                    years={years}
                    totalUsage={totalUsage}
                    postYears={postYears}
                    totalProduction={totalProduction}
                    loan1Bills={loan1Bills}
                    loan2Bills={loan2Bills}
                    width={width}
                    smallBreakPoint={smallBreakPoint}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="costsContainer v6 down">
              <div className="row g-lg-5">
                <div className="col">
                  <div className={isCash ? "noDisplay" : "costs v6 blue"}>
                    <div className="costsText v6 blue">
                      Solar {viewOptions === 0 ? "Option 1" : ""} Est. Savings:
                      ${Math.round(loan1Savings).toLocaleString(undefined)}
                    </div>
                  </div>
                </div>
                {viewOptions === 0 ? (
                  <div className="col">
                    <div className="costs v6 lightBlue">
                      <div className="costsText v6 lightBlue">
                        Solar Option 2 Est. Savings: $
                        {Math.round(loan2Savings).toLocaleString(undefined)}
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div className="savingsText v5">
            {uType === "Square Footage" && (
              <>
                <div className="savingsText v5">
                  The availability and/or applicability of any potential “ITC &
                  Local Incentives” are not guaranteed. See “Incentive Overview
                  | Federal Tax Credit” section below.
                </div>{" "}
                <br />
                Federal Tax Credit and State/Local/RECs are not guaranteed. See
                “Incentive Overview | Federal Tax Credit” section below.
                <br /> <br />
              </>
            )}
            The “Utility Power” price reflected on this graph is determined
            based on the average of your current utility costs per kWh with an
            estimated 4% increase in that kWh utility cost each year over the
            next {loanA.loanTerm} years. See “Assumptions and Details” section
            below. The “Solar Options” reflect the average of your costs per kWh
            based on the proposed solar loan costs spread out over{" "}
            {loanA.loanTerm} years based on the estimated power production of
            the proposed solar system. The basis for the total amount of
            “Savings” is further explained below on the “Your Estimated Savings”
            page.
          </div>
        </div>
      </div>
    );
  };
  const ciaButton = () => {
    return (
      <button
        className="proposalButton confirm"
        style={{ marginTop: "10px", marginBottom: "0px" }}
        disabled={updateCustomer || ciaLoading}
        onClick={() => cia()}
      >
        {ciaLoading ? (
          <CircularProgress size={40} color="inherit" />
        ) : currentProp.financingSource === "Owner Financing" ? (
          "Send Cash CIA"
        ) : currentProp.financingSource === "LightReach PPA" ||
          currentProp.financingSource === "EnFin" ? (
          "Send PPA CIA"
        ) : (
          "Send Loan CIA"
        )}{" "}
      </button>
    );
  };
  const blkAdders = () => {
    return (
      <>
        {salesTeam === "OH BLK Sales Team" ||
          salesTeam === "HTX BLK Sales Team" ||
          salesTeam === "STX Sales Team" ||
          salesTeam === "NBTX Sales Team" ||
          salesTeam === "Tulsa Sales Team" ||
          salesTeam === "Development Sales Team" ||
          salesTeam === "H-Town BLK Sales Team" ? (
          <>
            <div
              className="row"
              onClick={(e) => repAdderToggle(blkAdder, setBlkAdder, 1)}
            >
              <div className="col-lg-1 col-2">
                <div
                  className={blkAdder === 1 ? "checkBox checked" : "checkBox"}
                >
                  <img src={checkmark}></img>
                </div>
              </div>
              <div className="col">
                <div className="savingsText modals add">
                  {" "}
                  $500 {listOfStates.abbr(team.teamLocation)} Customer Bonus
                </div>
              </div>
            </div>
            <div
              className="row"
              onClick={
                +ppw <= +basePpw - 0.2
                  ? () => ""
                  : () => repAdderToggle(blkAdder, setBlkAdder, 2)
              }
            >
              <div className="col-lg-1 col-2">
                <div
                  className={blkAdder === 2 ? "checkBox checked" : "checkBox"}
                >
                  <img src={checkmark}></img>
                </div>
              </div>
              <div className="col">
                <div
                  className={
                    +ppw <= +basePpw - 0.2
                      ? "savingsText modals add void"
                      : "savingsText modals add"
                  }
                >
                  {" "}
                  $500 {listOfStates.abbr(team.teamLocation)} Rep Bonus
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  };
  const panelBonuses = () => {
    return (
      <>
        {[
          "Development Sales Team",
          "Portland Sales Team",
          "Salem Sales Team",
          "Houston Sales Team",
          "Virginia Beach Sales Team",
          "Hampton Sales Team",
          "TX BLK Sales Team",
          "Austin Sales Team",
          "Richmond Sales Team",
          "STX Sales Team",
        ].includes(salesTeam) && +mod[0] === 19 ? (
          <>
            <div
              className="row"
              onClick={(e) => repAdderToggle(panelBonus, setPanelBonus, 1)}
            >
              <div className="col-lg-1 col-2">
                <div
                  className={panelBonus === 1 ? "checkBox checked" : "checkBox"}
                >
                  <img src={checkmark}></img>
                </div>
              </div>
              <div className="col">
                <div className="savingsText modals add">
                  Panel Bonus Customer
                </div>
              </div>
            </div>
            <div
              className="row"
              onClick={() => repAdderToggle(panelBonus, setPanelBonus, 2)}
            >
              <div className="col-lg-1 col-2">
                <div
                  className={panelBonus === 2 ? "checkBox checked" : "checkBox"}
                >
                  <img src={checkmark}></img>
                </div>
              </div>
              <div className="col">
                <div className="savingsText modals add">Panel Bonus Rep</div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  };
  const financingLabel = () => {
    return (
      <>
        <div className="savingsText modals doc">
          {currentProp.financingSource === "Owner Financing"
            ? "Purchase"
            : "Loan"}{" "}
          Amount:{" "}
          {(+currentProp.financingAmount).toLocaleString(undefined, {
            style: "currency",
            currency: "USD",
          })}
        </div>
        <div className="savingsText modals doc">
          Product: {currentProp.financingSource.replace("LoanPal", "Goodleap")}{" "}
          {currentProp.financingSource === "Owner Financing"
            ? null
            : currentProp.financingProduct.replace("Single ", "")}
        </div>
      </>
    );
  };
  const payments = () => {
    return (
      <>
        {isCash && (state === "Nevada" || state === "Ohio") ? (
          <>
            <div className="savingsContainer v6">
              <div className="row g-lg-5">
                <div className="col pt-10">
                  <div className="savingsEstimate v6 payments">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="savingsNumber v6">
                            ${Math.round(1000).toLocaleString(undefined)}
                          </div>
                          <div className="savingsText payments">
                            <>
                              First Payment <br /> <span> UPFRONT</span>
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="savingsEstimate v6 payments g">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="savingsNumber v6">
                            $
                            {Math.round(
                              (loanAmount - 1000) * 0.25
                            ).toLocaleString(undefined)}
                          </div>
                          <div className="savingsText payments">
                            Second Payment <br /> <span>PERMIT</span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="savingsEstimate v6 payments g">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="savingsNumber v6">
                            $
                            {Math.round(
                              (loanAmount - 1000) * 0.7
                            ).toLocaleString(undefined)}
                          </div>
                          <div className="savingsText payments">
                            <>
                              Third Payment <br /> <span>INSTALL</span>
                            </>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="savingsEstimate v6 payments g">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="savingsNumber v6">
                            $
                            {Math.round(
                              (loanAmount - 1000) * 0.05
                            ).toLocaleString(undefined)}
                          </div>
                          <div className="savingsText payments">
                            <>
                              Fourth Payment <br /> <span>PTO</span>
                            </>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="savingsContainer v6">
              {loanA?.loanName !== "SunGage" && (
                <div className="row g-lg-5">
                  <div className={isCash ? "col" : "noDisplay"}>
                    <div className="savingsEstimate v6 payments g">
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="savingsNumber v6">
                              $
                              {Math.round(loanAmount * 0.5).toLocaleString(
                                undefined
                              )}
                            </div>
                            <div className="savingsText payments">
                              First Payment
                              <br /> <span>UPFRONT</span>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={isCash ? "col" : "noDisplay"}>
                    <div className="savingsEstimate v6 payments g">
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="savingsNumber v6">
                              $
                              {Math.round(loanAmount * 0.4).toLocaleString(
                                undefined
                              )}
                            </div>
                            <div className="savingsText payments">
                              Second Payment <br /> <span>INSTALL</span>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {stateTax ||
                    recValue.afterEnergy ||
                    custUtility === "Salem Electric" ||
                    custUtility === "Fort Collins Utilities (FCU)" ||
                    +loanA.interestOnlyPayment > 0 ||
                    (custUtility === "Austin Energy" && rebate > 0) ? (
                    <></>
                  ) : (
                    <>
                      <div className="col">
                        <div className="savingsEstimate v6 payments g">
                          <div className="row">
                            <div className="col">
                              <div className="row">
                                <div className="savingsNumber v6">
                                  $
                                  {isCash
                                    ? Math.round(
                                      loanAmount * 0.4
                                    ).toLocaleString(undefined)
                                    : Math.round(
                                      loanA.postPayment * loanAmount
                                    )}
                                </div>
                                <div className="savingsText payments">
                                  {isCash ? (
                                    <>
                                      Second Payment <br /> <span>INSTALL</span>
                                    </>
                                  ) : (
                                    <>
                                      {loanA.loanName === "Sunlight"
                                        ? "Estimated"
                                        : null}{" "}
                                      Monthly Loan Payment <br />{" "}
                                      <span> NO INCENTIVE APPLIED</span>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className={isCash ? "col" : "noDisplay"}>
                    <div className="savingsEstimate v6 payments g">
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="savingsNumber v6">
                              $
                              {Math.round(loanAmount * 0.1).toLocaleString(
                                undefined
                              )}
                            </div>
                            <div className="savingsText payments">
                              Third Payment <br /> <span>PTO</span>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

{stateTax ||
                recValue.afterEnergy ||
                custUtility === "Salem Electric" ||
                custUtility === "Fort Collins Utilities (FCU)" ||
                loanA.interestOnlyPayment > 0 ||
                loanA?.loanName === "SunGage" ||
                (custUtility === "Austin Energy" && rebate > 0) ? (
                <div className={isCash ? "noDisplay" : "savingsContainer v6"}>
                  <div className="row g-lg-5">
                    {loanA?.loanName === "SunGage" && (
                      <div className="col">
                        <div className="savingsEstimate v6 payments g">
                          <div className="row">
                            <div className="col">
                              <div className="row">
                                <div className="savingsNumber">
                                  ${prePayment()}
                                </div>
                                <div className="savingsText payments">
                                  {loanA.loanName === "Sunlight"
                                    ? "Estimated"
                                    : null}{" "}
                                  Monthly Loan Payment <br />
                                  <span>{"INITIAL MONTHLY PAYMENT"}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col">
                      <div className="savingsEstimate v6 payments g">
                        <div className="row">
                          <div className="col">
                            <div className="row">
                              <div className="savingsNumber">
                                {loanA?.loanName === "SunGage" && (loanA.ppaEscalator == 0 || loanA.ppaEscalator === undefined)
                                  ? `$${Math.round(loanA.postPayment * loanAmount)}`
                                  : `${(loanA.ppaEscalator * 100).toFixed(2)}%`}
                              </div>
                              <div className="savingsText payments">
                                {loanA.loanName === "Sunlight"
                                  ? "Estimated"
                                  : null}{" "}
                                {loanA?.loanName === "SunGage" && (loanA.ppaEscalator == 0 || loanA.ppaEscalator === undefined)
                                  ? "Monthly Loan Payment"
                                  : "Escalation Rate"}{" "}
                                <br />
                                <span>
                                  {loanA?.loanName === "SunGage" && (loanA.ppaEscalator == 0 || loanA.ppaEscalator === undefined)
                                    ? "PAYMENT AFTER 36 MONTHS"
                                    : "YEARLY PAYMENT INCREASE"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </>
        )}
      </>
    );
  };
  const creditCheck = (match) => {
    if (loanA.loanName === "Dividend" || loanA.loanName === "Dividend 26%") {
      link1 = `https://partner.dividendfinance.com/application/IonSolar?borrower_first-name=${primaryContact.firstName
        }&borrower_middle-initial=${primaryContact.middleName
        }&borrower_last-name=${primaryContact.lastName
        }&borrower_phone=${phoneLink}&borrower_email=${emailLink}&address_street1=${linkStreet}&address_city=${cityLink}&address_state=${stateLink}&address_zip=${zip}&project_project-cost=${loanAmount}&project_system-size=${systemSize / 1000
        }&installer_sales-rep-email=${repEmailLink}&project_product_term=${loanA.loanTerm
        }&project_product_rate=${(+loanA.loanInterest / 100).toFixed(
          4
        )}&external-project-id=${customer.projectID}`;
    }
    if (loanA.loanName === "Ygrene") {
      link1 = "https://portal.ygrene.com/#/login";
    }
    if (loanA.loanName === "LightReach PPA") {
      link1 = `https://sabal.palmetto.com/accounts/${customer.lightReachAccountId}/application/create`;
    }
    if (
      loanA.loanName === "Sunlight" ||
      loanA.loanName === "Sunlight Int Only"
    ) {
      link1 = "https://slfportal.com/orange/#/";
    }
    if (loanA.loanName === "GoodLeap" || loanA.loanName === "GoodLeap 22") {
      link1 = `https://apply.goodleap.com/ion/${intLink}.html??refnum=${customer.projectID}&lname=${primaryContact.lastName}&fname=${primaryContact.firstName}&street=${linkStreet}&city=${cityLink}&state=${stateLink}&zip=${zip}&email=${emailLink}&phone=${phoneLink}&cost=${financingLink}&language=English&srfn=${repNameLink[0]}&srln=${repNameLink[1]}&sre=${repEmailLink}&srphone=${repPhoneLink}`;
    }

    return !+loanA.isPpa ? (
      <>
        {custView === 1 ? (
          <a href={link1} target="_blank">
            <button
              disabled={match}
              className={match ? "custButton disabled" : "custButton confirm"}
            >
              <img className="img" src={linkOut}></img> Apply through{" "}
              {loanA.loanName}
            </button>
          </a>
        ) : (
          <>
            <button
              className="custButton confirm"
              onClick={() => {
                if (loanA.loanName.includes("GoodLeap")) {
                  setGoodLeap(true);
                } else {
                  setCustView(1);
                }
              }}
            >
              <img className="img" src={linkOut}></img> Apply through{" "}
              {loanA.loanName}
            </button>
          </>
        )}
      </>
    ) : (
      <></>
    );
  };

  // destructuring monthly usage
  const {
    january,
    february,
    march,
    april,
    may,
    june,
    july,
    august,
    september,
    october,
    november,
    december,
  } = monthlyUsage;

  // destructuring proposal
  const {
    modSize,
    rebateType,
    invRating,
    modPtcRating,
    rebatePerWatt,
    rebateFixed,
    modId,
    modModel,
    rebateMax,
    module,
    invType,
    invModel,
    modCount,
    propRatio,
    downPayment,
    utilityLocation,
    rateOverRide,
    rateAmount,
    maxModCount,
    costOverRide,
    ballastModules,
    groundMountModules,
    maxSystemSize,
    maxOffset,
  } = proposal;

  // destructuring team
  const {
    loan3,
    term3,
    interest3,
    post3,
    pre3,
    int3,
    id3,
    itc3,
    specialPrice3,
    specialLoanIncrease,
    loanChangeSize,
    loanChangeIncrease,
    loanOptions,
  } = team;

  // destructuring calculation
  const {
    tierType,
    surcharge,
    tax,
    tier1,
    tier2,
    tier3,
    tier4,
    sTier1,
    sTier2,
    sTier3,
    sTier4,
    wTier1,
    wTier2,
    wTier3,
    wTier4,
    tierAmount,
    sTierAmount,
    wTierAmount,
    tier1Amount,
    tier2Amount,
    tier3Amount,
    tier4Amount,
    sTier1Amount,
    sTier2Amount,
    sTier3Amount,
    sTier4Amount,
    wTier1Amount,
    wTier2Amount,
    wTier3Amount,
    wTier4Amount,
  } = calculation;

  // calcs array built from tax, surcharge and different tier amounts and tier numbers
  let calcs = [
    tierType,
    +surcharge,
    +tax,
    +tier1,
    +tier2,
    +tier3,
    +tier4,
    +sTier1,
    +sTier2,
    +sTier3,
    +sTier4,
    +wTier1,
    +wTier2,
    +wTier3,
    +wTier4,
    +tierAmount,
    +sTierAmount,
    +wTierAmount,
    +tier1Amount,
    +tier2Amount,
    +tier3Amount,
    +tier4Amount,
    +sTier1Amount,
    +sTier2Amount,
    +sTier3Amount,
    +sTier4Amount,
    +wTier1Amount,
    +wTier2Amount,
    +wTier3Amount,
    +wTier4Amount,
  ];

  // set prop ratio when prop ratio chnages
  // @note - why set this if it is ran when prop ratio changes?
  // TODO: Adjust
  useEffect(() => {
    setNewPropRatio(propRatio);
  }, [propRatio]);

  // set ballast panels and total
  // TODO: Adjust
  useEffect(() => {
    if (ballast === 1) {
      if (!ballastPartial) {
        setBallastPanels(+panelAmount);
        return setBallastTotal(+systemSize * +ballastAmount);
      }
      return setBallastPanels(+ballastModules);
    }
    setBallastPanels(+panelAmount);
    if (ballastModules > 0) {
      return setBallastTotal(+ballastPanels * +mod[3] * +ballastAmount);
    }
    setBallastTotal(+systemSize * +ballastAmount);
  }, [
    proposal,
    ballastPanels,
    ballast,
    panelAmount,
    ballastModules,
    systemSize,
    ballastAmount,
    mod,
  ]);

  // set ground mount panels and total
  // TODO: Adjust
  useEffect(() => {
    if (groundMount === 1 && +groundMountModules > 0) {
      return setGroundMountPanels(+groundMountModules);
    }
    setGroundMountPanels(+panelAmount);
    if (+groundMountModules > 0) {
      return setGroundMountTotal(
        +groundMountPanels * +mod[3] * +groundMountAmount
      );
    }
    setGroundMountTotal(+systemSize * +groundMountAmount);
  }, [proposal, groundMountPanels, groundMount, panelAmount]);

  // all of these are used in the calculations and have very confusing names and are not descriptive
  let totalInterest = FindTotalInterest(
    loanA.prePayment,
    loanA.postPayment,
    loanA.loanTerm,
    loanAmount,
    loanA.loanName
  );
  let numOfPayments = loanA.loanTerm * 12;
  let usage = [
    +january,
    +february,
    +march,
    +april,
    +may,
    +june,
    +july,
    +august,
    +september,
    +october,
    +november,
    +december,
  ];
  let currentUsage = [
    +SFUsage.january,
    +SFUsage.february,
    +SFUsage.march,
    +SFUsage.april,
    +SFUsage.may,
    +SFUsage.june,
    +SFUsage.july,
    +SFUsage.august,
    +SFUsage.september,
    +SFUsage.october,
    +SFUsage.november,
    +SFUsage.december,
  ];
  let jan = 0;
  let feb = 0;
  let mar = 0;
  let apr = 0;
  let mayP = 0;
  let jun = 0;
  let julyP = 0;
  let aug = 0;
  let sep = 0;
  let oct = 0;
  let nov = 0;
  let dec = 0;

  const updateProduction = () => {
    const curProduction = [
      +janProduction,
      +febProduction,
      +marProduction,
      +aprProduction,
      +mayProduction,
      +junProduction,
      +julyProduction,
      +augProduction,
      +sepProduction,
      +octProduction,
      +novProduction,
      +decProduction,
    ];

    const totalCurProduction = total(curProduction);
    jan = +janProduction / totalCurProduction;
    feb = +febProduction / totalCurProduction;
    mar = +marProduction / totalCurProduction;
    apr = +aprProduction / totalCurProduction;
    mayP = +mayProduction / totalCurProduction;
    jun = +junProduction / totalCurProduction;
    julyP = +julyProduction / totalCurProduction;
    aug = +augProduction / totalCurProduction;
    sep = +sepProduction / totalCurProduction;
    oct = +octProduction / totalCurProduction;
    nov = +novProduction / totalCurProduction;
    dec = +decProduction / totalCurProduction;

    return curProduction;
  };

  updateProduction();

  useEffect(() => {
    setProduction(updateProduction());
  }, [
    janProduction,
    febProduction,
    marProduction,
    aprProduction,
    mayProduction,
    junProduction,
    julyProduction,
    augProduction,
    sepProduction,
    octProduction,
    novProduction,
    decProduction
  ]);

  // sets the state tax amount
  // TODO: Adjust
  useEffect(() => {
    if (+stateInfo.stateTax === 1) {
      if (stateInfo.taxType === "Fixed") {
        setStateTax(+stateInfo.taxFixed);
      }
      if (stateInfo.taxType === "Percentage") {
        let tax = (systemCost - homeEnergyTotal) * +stateInfo.taxPerWatt;
        if (tax >= +stateInfo.taxMax) {
          return setStateTax(+stateInfo.taxMax);
        }
        setStateTax(tax);
      }
      if (stateInfo.taxType === "Per Watt") {
        let tax = systemSize * +stateInfo.taxPerWatt;
        if (tax >= +stateInfo.taxMax) {
          return setStateTax(+stateInfo.taxMax);
        }
        setStateTax(tax);
      }
    }
    if (custUtility === "Xcel Energy (New Mexico)") {
      if (powerWall) {
        return setStateTax(1000);
      }
      setStateTax(0);
    }
  }, [stateInfo, panelAmount, systemCost, systemSize, powerWall, calcUtility]);
  // sets totalProduction, nestAmount, and nestAdder
  // TODO: Adjust
  useEffect(() => {
    if (production.length > 0) {
      setTotalProduction(total(production));
    }
    if (billCalc[2] * nestMax < 2076) {
      setNestAmount(billCalc[2] * nestMax);
    }
    if (nest === 0) {
      setNestAdder(0);
    }
  }, [production, nest]);

  // calculates the total usage. Not in scope of any function
  const { name, street, state, city, zip, phone } = customer;
  const mspForLightReachGetQuote = useMemo(
    () => getMspForLightReachGetQuote(state, msp, oregonLightreachPricingBump),
    [state, msp, oregonLightreachPricingBump]
  );
  let newUsage = StateUsage(utilityLocation, usage, annualUsage, uType);
  let totalUsage;
  if (newUsage) {
    usage = newUsage;
    totalUsage = total(newUsage);
  }
  if (uType === "Partial 12 Months") {
    totalUsage = Math.round(totalUsage);
  }

  // calculates the new bill based on usage and production
  let newBill = [];
  for (let i = 0; i <= production.length - 1; i++) {
    newBill.push(usage[i] - production[i]);
  }

  let custUtility = calcUtility;
  let billCalc;
  let postBill;

  // sets load switch to 1 only if the custUtility is SRP
  // TODO: Adjust
  useEffect(() => {
    if (custUtility === "Salt River Project (SRP)") {
      setLoadSwitch(1);
    }
  }, [custUtility]);

  // sets billCalc and postBill based on the custUtility
  // @note - only runs if rateOverRide is 0. THis should be true/false if not being treated as a number
  if (rateOverRide === "0") {
    switch (custUtility) {
      case "PNM - Public Service Company of New Mexico":
      case "Continental Divide Electric":
      case "CNM":
        billCalc = PNMCalc(usage);
        postBill = PNMCalc(newBill);
        break;
      case "Black Hills Electric":
        billCalc = BlackHillsCalc(usage);
        postBill = BlackHillsCalc(newBill);
        break;
      default:
        billCalc = MasterCalc(usage, calcs);
        postBill = MasterCalc(newBill, calcs);
    }
  } else {
    billCalc = OverRideCalc(usage, rateAmount);
    postBill = OverRideCalc(newBill, rateAmount);
  }

  // sets loan amount and discounts. This logic is being used elsewhere and should be refactored
  // TODO: Adjust
  useEffect(() => {
    //  this is where we should check if we can allow the loan
    setCustomerData(
      new CustomerData(
        loanA,
        systemSize,
        battery10,
        battery10Amount,
        expansionPack,
        expansionPackAmount,
        systemCost,
        downPayment,
        sameDay,
        sameDayAmount,
        preferredUtility,
        preferredUtilityAmount,
        referral,
        referralAmount,
        custUtility,
        rebate,
        homeEnergyTotal,
        stateTax,
        recValue,
        powerWall,
        totalProduction,
        listOfStates.abbr(state),
        proposal.utilityLseId,
        msp,
        ppaProducts,
        dealerFee
      )
    );

    if (+loanA.isPpa === 1) {
      const loanAmount =
        +loanA.ppwRate * systemSize + (+battery10 > 0 ? +battery10Amount : 0);
      return setLoanAmount(loanAmount);
    }
    let preferredUtilityTotal = 0;
    let sameDayTotal = 0;
    let referralTotal = 0;
    if (sameDay === 1) {
      sameDayTotal = +sameDayAmount;
    }
    if (preferredUtility === 1) {
      preferredUtilityTotal = +preferredUtilityAmount;
    }
    if (referral === 1) {
      referralTotal = +referralAmount;
    }
    if (
      custUtility === "Austin Energy" ||
      custUtility === "Salem Electric" ||
      custUtility === "Fort Collins Utilities (FCU)" ||
      custUtility.includes("Xcel Energy") ||
      custUtility === "Ameren Illinois" ||
      custUtility === "Commonwealth Edison (ComEd)"
    ) {
      const loanAmount = Math.ceil(
        systemCost -
        downPayment -
        sameDayTotal -
        referralTotal -
        systemSize * preferredUtilityTotal
      );
      return (
        setLoanAmount(loanAmount),
        setDiscounts(
          sameDayTotal + referralTotal + systemSize * preferredUtilityTotal
        )
      );
    }
    const loanAMount = Math.ceil(
      systemCost -
      rebate -
      downPayment -
      sameDayTotal -
      referralTotal -
      systemSize * preferredUtilityTotal
    );
    setLoanAmount(loanAMount);
    setDiscounts(
      sameDayTotal + referralTotal + systemSize * preferredUtilityTotal
    );
  }, [panelAmount, systemCost, rebate, custUtility, loanA, battery10Amount]);

  // sets cpsRebate and austinRebate based on custUtility and proposal rebate
  // @note = this is setting it to a 1. This should be a boolean?
  // TODO: Adjust
  useEffect(() => {
    if (custUtility === "City Public Service (CPS)" && +proposal.rebate > 0) {
      setCpsRebate(1);
    }
    if (
      custUtility === "Austin Energy" &&
      +proposal.rebate > 0 &&
      +proposal.rebateOverride === 0
    ) {
      setAustinRebate(1);
    }
  }, [proposal.rebate, custUtility]);

  // sets partialPanels to partialPanels or panelAmount.
  // @note - why would we set partialPanels to point to itself?
  // TODO: Adjust
  useEffect(() => {
    if (proposal.rebatePanels < +proposal.modCount) {
      return setPartialPanels(+partialPanels);
    }
    return setPartialPanels(+panelAmount);
  }, [partialPanels, panelAmount]);

  // sets rebateOverride based on hasRebate and proposal.rebateOverride.
  // @note - this is setting it to a number, but it should be a boolean
  // TODO: Adjust
  useEffect(() => {
    if (+hasRebate < 2 && +proposal.rebateOverride < 2) {
      return setRebateOverride(+proposal.rebateOverride);
    }
    if (+proposal.rebateOverride > 1 && +hasRebate === 1) {
      return setRebateOverride(0);
    }
    setRebateOverride(+hasRebate);
  }, [hasRebate, proposal.rebateOverride, rebateOverride]);

  // sets rebate and has specific logic for orgeonDc
  // TODO: Adjust
  useEffect(() => {
    // The Xcel Renewable Battery Connect Program:
    // We only do Tesla batteries (in 2025) and they will always max out the rebate to 5000
    if (custUtility === "Xcel Energy (New Mexico)" && powerWall > 0) {
      let xcelRebateMax = 5000;
      return setRebate(xcelRebateMax);
    }
    if (
      (+proposal.rebateOverride === 1 || +proposal.rebate < 1) &&
      +cpsRebate < 1 &&
      +austinRebate < 1
    ) {
      return setRebate(proposal.rebate);
    }
    let oregonDc = 0;
    if (cpsRebate === 0 && austinRebate === 0) {
      if (+hasRebate > 0) {
        let oregonMax = 5000;
        let ac = 0;
        let pa = +panelAmount;
        let rMax = +rebateMax;
        let perWatt = +rebatePerWatt;
        if (+hasRebate > 1) {
          rMax = oregonMax;
        }
        if (+hasRebate === 2) {
          perWatt = 1.8;
        }
        if (+hasRebate === 3) {
          perWatt = 0.2;
        }
        if (+hasRebate === 4) {
          perWatt = 1.8;
        }
        if (+hasRebate === 5) {
          perWatt = 1.8 + +rebatePerWatt;
          rMax = +oregonMax + +rebateMax;
        }
        if (+proposal.rebatePanels !== +proposal.modCount) {
          pa = partialPanels;
        }
        if (rebateType === "Per Watt A/C") {
          ac = pa * mod[4] * inverter.rating * perWatt;
        }
        let dc = 0;
        if (rebateType === "Per Watt D/C") {
          dc = pa * mod[3] * perWatt;
        }
        let fixed = 0;
        if (rebateType === "Fixed") {
          fixed = rebateFixed;
        }
        let totalRebate = ac + dc + fixed;
        if (rebateMax || rMax) {
          if (totalRebate >= +rMax) {
            return setRebate(Math.round(+rMax));
          }
          return setRebate(Math.round(+totalRebate));
        }
        return setRebate(Math.round(+totalRebate));
      }
      return setRebate(0 + oregonDc);
    }
  }, [
    systemSize,
    hasRebate,
    salesTeam,
    rebate,
    utility,
    proposal.rebateOverride,
    cpsRebate,
    austinRebate,
    powerWall,
  ]);

  // sets "Austin Energy" rebate to potentially 0 and nothing else
  // TODO: Adjust
  useEffect(() => {
    if (custUtility === "Austin Energy") {
      if (
        panelAmount * mod[4] * inverter.rating < 3000 &&
        total(production) / total(usage) < 0.75
      ) {
        return setRebate(0);
      }
    }
  }, [systemSize, production, panelAmount]);

  // sets reRoofAmount to roofQuote.roofQuoteAmount if it is greater than 0
  // @note - why not just set it to 0?
  // TODO: Adjust
  useEffect(() => {
    if (+roofQuote.roofQuoteAmount > 0) {
      return setReRoofAmount(roofQuote.roofQuoteAmount);
    }
  }, [roofQuote.roofQuoteAmount]);

  // sets battery10Amount, inverter, and powerWall
  // @note - what is the significance of 11?
  // TODO: Adjust
  useEffect(() => {
    if (+proposal.battery10 === 0) {
      if (+powerWall === 1) {
        // setBattery10Amount(powerWallAmount);
        setInverter({
          id: 12,
          type: "Tesla",
          model: "Powerwall 3",
          rating: 0.975,
        });
      }
    }
    if (battery10 === 11) {
      setPowerWall(1);
    }
    if (+powerWall === 0) {
      setInverter({
        id: propInverter.id,
        type: propInverter.type,
        model: propInverter.model,
        rating: propInverter.rating,
      });
    }
  }, [powerWall, battery10, powerWallAmount]);

  useEffect(() => {
    setTravelAdderAmount(
      (+customer.travelAdder * proposal.systemSize) / +dealerFee
    );
  }, [proposal.systemSize, customer.travelAdder, dealerFee]);

  // overwrites batterClass if powerWall is 1
  // @note - what is the significance of 1? Is one the amount or the boolean?
  useEffect(() => {
    if (+powerWall === 1 || (+battery10 >= 11 && +battery10 < 20)) {
      setBatteryClass("viewBatteryPowerWall");
    } else if (+battery10 > 20 && +battery10 < 31) {
      setBatteryClass("viewBatteryEn10c");
    } else {
      setBatteryClass("viewBattery");
    }
  }, [battery10, powerWall]);

  const switchDealerFee = (amount) => {
    return (amount * +previousDealerFee) / +dealerFee;
  };

  // adjusts different amounts based on dealerFee
  // TODO: Adjust
  useEffect(() => {
    setTreeRemovalAmount(switchDealerFee(treeRemovalAmount));
    setReRoofAmount(switchDealerFee(reRoofAmount));
    setUtilityReviewAmount(1250 / +dealerFee);
    setLoadSwitchAmount(1500 / +dealerFee);
    setBattery10Amount(switchDealerFee(battery10Amount));
    setExpansionPackAmount(switchDealerFee(expansionPackAmount));
    setTownhomeAmount(400 / +dealerFee);
    setBallastAmount(0.23 / +dealerFee);
    setPSolarAmount(roundAndFormatNumber(0.15 / +dealerFee, 4));
    setMspAmount(3500 / +dealerFee);
    setCritterGuardAmount(0.1 / +dealerFee);
    setPowerWallAmount(12500 / +dealerFee);
    setAdderAmount(500 / +dealerFee);
    setBlkAdderAmount(500 / +dealerFee);
    setPvSystemAddOnAmount(1000 / +dealerFee);

    setPreviousDealerFee(dealerFee);
  }, [dealerFee, customer]);

  // sets adderTotal based on a lot of different values (mostly adders)
  let militaryAmount =
    +military === 1 || +military === 3 ? 250 / +dealerFee : 500 / +dealerFee;
  // TODO: Adjust
  useEffect(() => {
    let md = 0;
    if (+military > 0) {
      md = +militaryAmount;
    }
    let tb = 0;
    if (nest > 0) {
      tb = +nestCost;
    }
    let th = 0;
    if (townhome === 1) {
      th = +townhomeAmount;
    }
    let tt = 0;
    if (treeRemoval === 1) {
      tt = +treeRemovalAmount;
    }
    let rr = 0;
    if (reRoof > 0) {
      rr = +reRoofAmount;
    }
    let sh = 0;
    if (smartHome === 1) {
      sh = +smartHomeAmount;
    }
    let hv = 0;
    if (hvac === 1) {
      hv = +hvacAmount;
    }
    let ld = 0;
    if (led === 1) {
      ld = +ledAmount;
    }
    let trf = 0;
    if (turf === 1) {
      trf = +turfAmount;
    }
    let wdw = 0;
    if (windows === 1) {
      wdw = +windowsAmount;
    }
    let utl_rvw = 0;
    if (!!utilityReview) {
      utl_rvw = +utilityReviewAmount;
    }
    let wtr = 0;
    if (water === 1) {
      wtr = +waterAmount;
    }
    let bal = 0;
    if (ballast === 1) {
      bal = +ballastTotal;
    }
    let gm = 0;
    if (groundMount === 1) {
      gm = +groundMountTotal / +dealerFee;
    }
    let ps = 0;
    if (pSolar === 1) {
      ps = +pSolarAmount;
    }
    let tr = 0;
    if (travel === 1) {
      tr = +travelAmount;
    }
    let adder = 0;
    if (ionRebate === 1 || ionRebate === 2 || ionRebate === 3) {
      adder = +adderAmount;
    }
    let blk = 0;
    if (blkAdder === 1 || blkAdder === 2) {
      blk = +blkAdderAmount;
    }
    let pb = 0;
    if (panelBonus === 1 || panelBonus === 2) {
      pb = +panelBonusAmount;
    }
    let ms = 0;
    if (msp === 1 || msp === 2) {
      ms = +mspAmount;
    }
    let cg = 0;
    if (critterGuard === 1) {
      cg = +critterGuardAmount;
    }
    let b3 = 0;
    if (battery3 === 1) {
      b3 = +battery3Amount;
    }
    let b10 = 0;
    if (battery10 > 0 && battery10 < 11) {
      b10 = +battery10Amount * 1;
    }
    if (battery10 >= 11 && battery10 < 20) {
      const additionalBatteryAmount =
        (state === "Illinois" || state === "Texas" ? battery10Amount : 12500) /
        +dealerFee;
      b10 = battery10Amount + additionalBatteryAmount * (battery10 - 11);
    }
    if (battery10 > 20 && battery10 < 31) {
      b10 = +battery10Amount * 1;
    }
    let b10add = 0;
    if (battery10 > 1 && battery10 < 11) {
      b10add = +addBattery10Amount * (battery10 - 1);
    }
    // using sustainable as portland .34/watt adder
    let sus = 0;
    if (sustainable === 1) {
      sus = 0.34;
    }
    const orSps = getOrSpsAdderRatePerWatt(state);
    let ls = 0;
    if (loadSwitch === 1) {
      ls = +loadSwitchAmount;
    }
    let securityAdderCost = 0;
    if (securityToggled) {
      securityAdderCost = 925 / +dealerFee;
    }
    let ta = 0;
    if (+customer.travelAdder > 0) {
      ta = travelAdderAmount;
    }
    let ep = 0;
    if (expansionPack && battery10 >= 11 && battery10 < 20) {
      ep = +expansionPackAmount * expansionPack;
    }
    let ac = 0;
    if (acCoupled) {
      ac = acCoupledAmount;
    }
    let pa = 0;
    if (permittingAdder > 0) {
      pa = permittingAdderAmount * systemSize;
    }

    let pvo = 0;
    if (pvSystemAddOn === 1) {
      pvo = +pvSystemAddOnAmount;
    }

    let ws = 0;
    if (waterSoftener === 1) {
      ws = +waterSoftenerAmount;
    }

    // TODO:
    // Replicate logic in the "Backend"
    // What if it is a rebate?
    // Couple adder is not in...
    // TODO
    // battery3Amount
    // battery10Amount
    // powerWallAmount
    // addBattery10Amount

    const electricalUpgrade = loanA.loanName === "LightReach PPA" ? ms : 0;

    setPpaEligibleAdderTotal(
      Math.round(b3 + b10 + b10add + ac + ep + electricalUpgrade)
    );

    return setAdderTotal(
      Math.round(
        (ps + tr + cg + sus + orSps) * systemSize +
        adder +
        blk +
        pb +
        ms +
        gm +
        bal +
        b3 +
        b10 +
        b10add +
        securityAdderCost +
        tt +
        th +
        tb +
        md +
        rr +
        sh +
        hv +
        ld +
        trf +
        wdw +
        wtr +
        ls +
        utl_rvw +
        ta +
        smallSystemAdderAmount +
        ep +
        ac +
        pvo +
        pa +
        ws
      )
    );
  }, [
    treeRemoval,
    treeRemovalAmount,
    reRoof,
    reRoofAmount,
    smartHome,
    smartHomeAmount,
    hvac,
    hvacAmount,
    led,
    ledAmount,
    turf,
    turfAmount,
    windows,
    windowsAmount,
    water,
    waterAmount,
    ballast,
    ballastTotal,
    groundMountTotal,
    groundMountPanels,
    ionRebate,
    ionRebate2,
    groundMount,
    pSolar,
    msp,
    critterGuard,
    overRide,
    systemSize,
    basePpw,
    panelAmount,
    smallSystemAdderAmount,
    travel,
    travelAmount,
    adderTotal,
    ppaEligibleAdderTotal,
    custUtility,
    costOverRide,
    salesTeam,
    ppw,
    loanA,
    highLoan,
    battery3,
    battery10,
    sameDay,
    preferredUtility,
    referral,
    nestAdder,
    nest,
    blkAdder,
    sustainable,
    city,
    loadSwitch,
    panelBonus,
    townhome,
    military,
    powerWall,
    powerWallAmount,
    battery10Amount,
    expansionPack,
    securityToggled,
    utilityReview,
    utilityReviewAmount,
    customer,
    adders,
    dealerFee,
    acCoupled,
    pvSystemAddOn,
    nestCost,
    permittingAdder,
    permittingAdderAmount,
    waterSoftener,
    waterSoftenerAmount,
    state,
  ]);

  // sets systemCost based on a lot of different values and calculations
  let homeEnergyTotal =
    smartHomeAmount +
    hvacAmount +
    ledAmount +
    turfAmount +
    windowsAmount +
    waterAmount;
  // TODO: Adjust
  useEffect(() => {
    if (panelAmount && panelAmount <= 9) {
      // is a small system
      //setSmallSystemAdder(true);
      if (panelAmount <= 5 && +view === 1) {
        // too small / 5 and under panels
        Alert.error("Minimum panel count is 6.", {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
        setSmallSystemAdderAmount(2000 / dealerFee);
      } else {
        if (panelAmount <= 7) {
          // 6 or 7 panels
          setSmallSystemAdderAmount(1000 / dealerFee);
        } else {
          // 8 or 9 panels
          setSmallSystemAdderAmount(500 / dealerFee);
        }
      }
    } else {
      setSmallSystemAdderAmount(0);
    }
  }, [panelAmount, dealerFee]);
  // TODO: Adjust
  useEffect(() => {
    let perWatt = +ppw;
    let sd = 0;
    if (sameDay === 1) {
      sd = +sameDayAmount;
    }
    let pu = 0;
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount;
    }
    let ref = 0;
    if (referral === 1) {
      ref = +referralAmount;
    }
    if (costOverRide === "1") {
      return setSystemCost(
        +proposal.loanAmount +
        +proposal.rebate +
        +proposal.downPayment +
        ref +
        sd +
        pu * systemSize
      );
    }
    return setSystemCost(
      Math.ceil((+perWatt + pu) * systemSize + adderTotal + ref + sd)
    );
  }, [
    ballast,
    ballastTotal,
    groundMountTotal,
    groundMountPanels,
    ionRebate,
    ionRebate2,
    groundMount,
    pSolar,
    msp,
    critterGuard,
    overRide,
    systemSize,
    basePpw,
    travel,
    travelAmount,
    adderTotal,
    custUtility,
    costOverRide,
    salesTeam,
    ppw,
    loanA,
    highLoan,
    battery3,
    battery10,
    sameDay,
    preferredUtility,
    referral,
    nestAdder,
    nest,
    blkAdder,
    sustainable,
    utilityReview,
  ]);

  // creates an array of loan bills
  // @note - there is a lot of logic here that is not clear
  let loan1Bills = [];
  if (+loanA.isPpa === 1) {
    loan1Bills = [+(+loanA.ppaRate * (totalProduction / 12)).toFixed(2)];
    for (let i = 1; i < +loanA.loanTerm; i++) {
      const previousYearBill = loan1Bills[i - 1];
      const escalatedBill = +(
        previousYearBill *
        (1 + (+loanA.ppaEscalator - 0.0051))
      ).toFixed(2);
      loan1Bills.push(escalatedBill);
    }
  } else if (loanA && loanA.interestOnlyPayment) {
    loan1Bills = new Array(+loanA.loanTerm - 1).fill(
      +(+loanA.prePayment * loanAmount).toFixed(2)
    );
    loan1Bills.unshift(+(+loanA.interestOnlyPayment * loanAmount).toFixed(2));
  } else if (loanA.loanName === "Flic") {
    loan1Bills = new Array(+loanA.loanTerm - 2).fill(
      +(+loanA.postPayment * loanAmount).toFixed(2)
    );
    loan1Bills.unshift(0, 0);
  } else if (+loanA.loanTerm > 0) {
    loan1Bills = new Array(+loanA.loanTerm).fill(
      +(+loanA.prePayment * loanAmount).toFixed(2)
    );
  }

  // creates an array of loan bills
  // @note - I assume this is for loan 2? WHY IS LOAN B IN AN ARRAY?
  let loan2Bills = [];
  if (loanB && loanB.interestOnlyPayment) {
    loan2Bills = new Array(+loanB.loanTerm - 1).fill(
      +(loanB.prePayment * loanAmount).toFixed(2)
    );
    loan2Bills.unshift(+(loanB.interestOnlyPayment * loanAmount).toFixed(2));
  } else if (loanB && !loanB.interestOnlyPayment) {
    loan2Bills = new Array(loanB.loanTerm).fill(
      +(loanB.prePayment * loanAmount).toFixed(2)
    );
  }

  // what does this increase do? Needs to be more descriptive
  let increase = +stateInfo.utilityEscalator;
  if (custUtility === "Austin Energy") {
    increase = 2;
  }

  if (loanA.isPpa === 1 && increase > 4) {
    increase = 4;

  }

  // what is years in reference to? Needs to be more descriptive
  let years = [];
  if (janProduction) {
    for (let i = 0; i <= 24; i++) {
      years.push(+twentyFiveYear(+billCalc[1], i, increase));
    }
  } else {
    years.push(0);
  }

  // what is postYears in reference to? Needs to be more descriptive
  let postYears = [];
  if (postBill) {
    for (let i = 0; i <= 24; i++) {
      postYears.push(+twentyFiveYear(+postBill[1], i, increase));
    }
  } else {
    postYears.push(0);
  }

  // what is postYears1 in reference to? Needs to be more descriptive
  let postYears1 = [];
  if (postBill) {
    for (let i = 0; i <= 29; i++) {
      postYears1.push(+twentyFiveYear(35, i, increase));
    }
  } else {
    postYears1.push(0);
  }

  // sets nestPanelAmount to 2 if nestMax is greater than 0.05
  let nestPanelAmount = 1;
  if (nestMax > 0.05) {
    nestPanelAmount = 2;
  }

  // we do use disableNest
  // @note - I do not think we use disableNest. It is only reassigning a value
  let disableNest = true;
  if (
    panelAmount + nestPanelAmount >= +maxModCount ||
    (proposal.maxOffset &&
      (totalProduction / totalUsage) * 100 >= +proposal.maxOffset * 0.97)
  ) {
    disableNest = true;
  } else if (+proposal.hasNest > 0 && nest > 0) {
    disableNest = false;
  } else if (+proposal.hasNest === 0 && nest === 0) {
    disableNest = false;
  }

  // used for displaying some offset value in the HTML
  const offset = Math.round((totalProduction / +totalUsage) * 100);

  // sets allLoans to loan products and loan products 2 unless ppaProducts is greater than 0 then it sets allLoans to ppaProducts
  const combinedLoans = [...loanProducts, ...loanProducts2];
  const loansMap = new Map();

  for (let i = 0; i < combinedLoans.length; i++) {
    const curLoan = combinedLoans[i];
    const loanExists = loansMap.get(curLoan.loanId);

    if (!loanExists) {
      loansMap.set(curLoan.loanId, curLoan);
    } else {
      if (curLoan.dealerFee && !loanExists.dealerFee) {
        loansMap.set(curLoan.loanId, curLoan);
      }
    }
  }

  let allLoans = Array.from(loansMap.values());

  if (ppaProducts.length > 0) {
    allLoans = ppaProducts;
  }

  // mapped loans are returned as options for the select element
  let mappedLoans = allLoans
    .filter((loan) => {
      if (
        +loan.isPpa === 0 ||
        (+loan.isPpa === 1 &&
          (team.salesTeam === "H-Town BLK Sales Team" ? 2.7 : 2.8) <=
          +loan.ppwRate &&
          // +loan.ppwRate * systemSize >= 12500 && // Remooving the min $12,500 system size requirement
          +proposal.utilityLseId > 0 &&
          proposal.utilityPpa)
      ) {
        return true;
      }
      return false;
    })
    .map((loan, i) => (
      <option key={i} value={loan.loanId}>
        {viewLoans ? null : "OPTION 1 |"}{" "}
        {loan.loanName.replace("Owner Financing", "Cash")}{" "}
        {+loan.loanId === 115
          ? null
          : +loan.isPpa === 1
            ? `$${loan.ppaRate} ${(+loan.ppaEscalator * 100).toFixed(2)}% $${loan.ppwRate
            }`
            : `${+loan.loanTerm} YR ${+loan.loanInterest}% APR`}
      </option>
    ));

  // mapped loans 2 are returned as options for the select
  let mappedLoans2 = loanProducts2.map((loans, i) => {
    return (
      <option key={i} value={loans.loanId}>
        {" "}
        {viewLoans ? null : "OPTION 2 |"} {loans.loanName} {loans.loanTerm} YR{" "}
        {loans.loanInterest}% APR
      </option>
    );
  });

  // sets loanIdA to ppaProducts anytime ppaProducts changes
  // @note = again, this not clear on what setLoadIdA is doing.
  // TODO: Adjust
  useEffect(() => {
    if (+loanA.isPpa === 1 && ppaProducts.length > 0) {
      setLoanIdA(ppaProducts, loanA.loanId, setLoanA);
    }
  }, [ppaProducts]);

  // what is recValue?
  let recValue = {
    afterEnergy: 0,
    capacityFactor: 0,
    numRecs: 0,
    acSystem: 0,
    additionalCollateral: 0,
    utilityCollateral: 0,
    applicationFee: 0,
    grossValue: 0,
    product: 0,
  };

  // sets recValue based on the state and runs RECCalc. All of this logic could be moved into its own function
  if (["Illinois", "Virginia", "Ohio"].includes(state)) {
    recValue = RECCalc(
      panelAmount,
      mod,
      inverter.rating,
      totalProduction,
      state,
      loanA.loanName,
      hasRec,
      custUtility
    );
  }

  // sets freePowerAmount based on loanA, loanAmount, freePower, and systemSize
  // TODO: Adjust
  useEffect(() => {
    if (loanA.prePayment * loanAmount * 6 >= 1000) {
      return setFreePowerAmount(1000);
    }
    setFreePowerAmount(Math.round(loanA.prePayment * loanAmount) * 6);
  }, [freePower, systemSize, loanA, loanAmount]);

  // avg25_1 and ionCostA are used to create a proposal and sign a proposal
  let avg25_1;
  let ionCostA;
  if (loanA) {
    avg25_1 = ((total(loan1Bills) * 12) / 30 / totalProduction).toFixed(2);
    ionCostA = Math.round(total(loan1Bills) * 12);
  }

  // gallon, home, garbage, and tree are values used to create a proposal and sign a proposal
  const gallon = gallons();
  const home = homes();
  const garbage = garbages();
  const tree = trees();

  // nestImpact is used to create a proposal and sign a proposal
  let nestImpact = Math.round((nestAmount / totalUsage) * 100);
  if (nest === 0) {
    nestImpact = "-";
  }

  // utilityPower and solarPower is used to create a proposal and sign a proposal
  let utilityPower = Math.round(100 - (totalProduction / totalUsage) * 100);
  if (utilityPower < 0) {
    utilityPower = 0;
  }
  let solarPower = Math.round((totalProduction / totalUsage) * 100);

  // all these values are used to create a proposal and sign a proposal
  // @note - these can all be moved to a function and do not need to be in the scope of the component
  let janU = Math.round(usage[0]);
  let febU = Math.round(usage[1]);
  let marU = Math.round(usage[2]);
  let aprU = Math.round(usage[3]);
  let mayU = Math.round(usage[4]);
  let junU = Math.round(usage[5]);
  let julyU = Math.round(usage[6]);
  let augU = Math.round(usage[7]);
  let sepU = Math.round(usage[8]);
  let octU = Math.round(usage[9]);
  let novU = Math.round(usage[10]);
  let decU = Math.round(usage[11]);
  let janP = Math.round(production[0]);
  let febP = Math.round(production[1]);
  let marP = Math.round(production[2]);
  let aprP = Math.round(production[3]);
  let maP = Math.round(production[4]);
  let junP = Math.round(production[5]);
  let julP = Math.round(production[6]); // same as julyP? Why is there two values?
  let augP = Math.round(production[7]);
  let sepP = Math.round(production[8]);
  let octP = Math.round(production[9]);
  let novP = Math.round(production[10]);
  let decP = Math.round(production[11]);
  const cost25yr = Math.round(total(years) * 12);
  const currAnnBill = Math.round(years[0] * 12);
  const today = Math.round(years[0]);
  const yr5 = Math.round(years[4]);
  const yr10 = Math.round(years[9]);
  const yr15 = Math.round(years[14]);
  const yr20 = Math.round(years[19]);
  const yr25 = Math.round(years[24]);
  const yr30 = Math.round(years[29]); // this value is not being used
  const avg25Utility = ((total(years) * 12) / 30 / totalUsage).toFixed(2);
  const avg25_2 = ((total(loan2Bills) * 12) / 30 / totalProduction).toFixed(2);

  // calculates the new net cost
  // TODO: Adjust
  useEffect(() => {
    let newNetCost = Math.round(
      +loanAmount +
      +downPayment -
      (+loanAmount + +downPayment - homeEnergyTotal) * loanA.itc -
      stateTax -
      (recValue?.afterEnergy || 0)
    );

    if (
      custUtility === "Austin Energy" ||
      powerWall ||
      custUtility === "Ameren Illinois" ||
      custUtility === "Commonwealth Edison (ComEd)"
    ) {
      newNetCost = Math.round(
        +loanAmount -
        +rebate -
        pacificPowerRebate -
        centerPointRebate -
        gvecNewBatteryRebate +
        +downPayment -
        (+loanAmount + +downPayment - homeEnergyTotal) * loanA.itc -
        stateTax -
        (recValue?.afterEnergy || 0)
      );
    }

    setNetCost(newNetCost);
  }, [
    loanAmount,
    downPayment,
    homeEnergyTotal,
    loanA,
    stateTax,
    recValue,
    custUtility,
    powerWall,
    rebate,
    pacificPowerRebate,
    centerPointRebate,
    gvecNewBatteryRebate
  ]);

  // only used to create a proposal and sign a proposal
  const itcTotal = (loanAmount + +downPayment - homeEnergyTotal) * loanA.itc;
  const allIncentives = Math.round(itcTotal + stateTax + recValue?.afterEnergy);
  const pmt1 = prePayment();
  const pmt2 = Math.round(loanAmount * loanA.postPayment);
  const pmt3 = Math.round(loanAmount * loanA.interestOnlyPayment);
  const pmt1B = Math.round(loanAmount * loanB.prePayment);
  const pmt2B = Math.round(loanAmount * loanB.postPayment);

  // used to create a proposal and sign a proposal.
  // also used to display the savings on the proposal
  const loan1Savings = savingsCalc(loan1Bills);
  const loan2Savings = savingsCalc1(loan2Bills);

  // only used to create a proposal and sign a proposal
  const ionCostB = Math.round(total(loan2Bills) * 12);
  let remainingCost = Math.round(total(postYears) * 12);
  if (remainingCost <= 0) {
    remainingCost = Math.round(total(postYears1));
  }
  // const currentPerKw = (billCalc[1] / billCalc[4]).toFixed(3); //update to Aurora
  useEffect(() => {
    getAuroraBillSummary(proposal.projectId);
  }, [proposal]);

  // sets rebateSF based on custUtility and utilityLocation
  // TODO: Adjust
  useEffect(() => {
    if (
      custUtility === "City Public Service (CPS)" ||
      custUtility === "Colorado Springs Utilities" ||
      utilityLocation === "Oregon"
    ) {
      setRebateSF(rebate);
    }
  }, [rebate, custUtility]);

  // sets displayProd based on totalProduction
  // @note - displayProd is used to show values in HTML
  // TODO: Adjust
  useEffect(() => {
    return setDisplayProd(Math.round(+totalProduction));
  }, [nest, totalProduction, janProduction]);

  // updates the project in SolarGraf when the customer is updated
  // also updates the hasUpdatedProject ref
  const hasUpdatedProject = useRef(false);
  // TODO: Adjust
  useEffect(() => {
    if (
      !hasUpdatedProject.current &&
      customer.solarGrafProjectId &&
      Object.keys(customer).length > 0
    ) {
      updateProject(
        customer.solarGrafProjectId,
        `${customer.name} - ${customer.street}`,
        customer.name,
        customer.phone,
        customer.email,
        activeUser?.username
      );
      hasUpdatedProject.current = true;
    }
  }, [customer]);

  // sets IonRebate and BlkAdder when ppw or basePpw changes
  // TODO: Adjust
  useEffect(() => {
    setIonRebate(+proposal.ionRebate);
    setBlkAdder(+proposal.ionRebate2);
  }, [ppw, basePpw]);

  // Set the ionRebate for Virginia customers
  // TODO: Adjust
  useEffect(() => {
    if (["Virginia", "South Carolina", "Maryland"].includes(customer.state)) {
      if (customer.insideSalesSetter) {
        return; // Do not auto-add Rep/Customer rebate for inside sales setter
      }
      if (!customer.setter) {
        return setIonRebate(2); // Rep Cash Bonus
      }

      return setIonRebate(3); // Setter Cash Bonus
    }
  }, [customer, ppw, basePpw]);

  // version of the proposal to be displayed
  let propVersion = props.match.params.number;

  // formatted details that are sent to 3rd party integrations
  let linkStreet;
  let cityLink;
  let stateLink = listOfStates.abbr(state);
  let emailLink = "";
  let repEmailLink;
  let repPhoneLink;
  let repNameLink = [];
  let financingLink;
  let phoneLink = "";
  let loanLink1;
  let loanLink2;
  let intLink;
  if (name && currentProp) {
    linkStreet = street.replace(" ", "%20");
    cityLink = city.replace(" ", "%20");
    if (customer.email) {
      emailLink = customer.email.replace("@", "%40");
    }
    repNameLink = customer.salesRep.split(" ");
    repEmailLink = customer.repEmail.replace("@", "%40");
    financingLink = currentProp.financingAmount;
    if (phone) {
      phoneLink = phone.replace(/\D/g, "");
    }
    if (customer.repPhone) {
      repPhoneLink = customer.repPhone.replace(/\D/g, "");
    }
    if (loanA && loanA.loanTerm && loanA.loanInterest) {
      loanLink1 = `${loanA.loanTerm}${loanA.loanInterest
        .toString()
        .replace(".", "")}`;
      intLink = loanA.loanInterest.toString().replace(".", "");
    }
  }

  // links is updated based on loan A
  let link1;

  const [custView, setCustView] = useState(0);

  //  component? idk
  const mappedAdders = adders.map((adder, i) => {
    return (
      <div key={i}>
        <div className="savingsText modals doc">
          {adder.name === "Thermostat (Free)"
            ? "Thermostat"
            : adder.name === "LED Light Bulbs (Free)"
              ? "LED Light Bulbs"
              : adder.name === "Adder" ||
                adder.name === "Home Energy Efficiency Upgrade"
                ? adder.type
                : adder.name}{" "}
          {adder.name === "Thermostat (Free)" ||
            adder.name === "LED Light Bulbs (Free)"
            ? Math.round(adder.quantity)
            : adder.type === "Tree Removal" ||
              adder.type === "Reroof" ||
              adder.type === "Pool Solar"
              ? `Quote: $${Math.round(adder.amount)} Fee: $${Math.round(
                adder.fee
              )} Total: $${Math.round(adder.totalAmount)}`
              : adder.name === "Rep Cash Bonus" ||
                adder.type === "Engineering/Permitting" ||
                adder.name === "6 Months of Solar Payments - Rep"
                ? `$${Math.round(adder.amount)} (Internal - not displayed on CIA)`
                : adder.type === "OR SPS Adder"
                  ? `$${Math.round(adder.totalAmount ?? adder.amount)} (Internal - not displayed on CIA)`
                : adder.type === "Battery - Encharge 10" ||
                  adder.type === "Service Panel Replacement" ||
                  adder.name === "Military Discount (Check sent at PTO)" ||
                  adder.name === "MISC Cash" ||
                  adder.name === "BlackFriday"
                  ? `$${Math.round(adder.totalAmount)}`
                  : adder.name === "Cash (Check sent at PTO)"
                    ? `$${adder.amount}`
                    : adder.type === "Service Panel Replacement - Utah" ||
                      adder.type === "Service Panel Replacement - Oregon"
                      ? "$1000"
                      : adder.name === "6 Months of Solar Payments"
                        ? `$${Math.round(adder.amount)}`
                        : ""}
        </div>
      </div>
    );
  });

  // array of adderIds. Only usedin creating a proposal and a text endpoint
  let adderIds = [];

  for (let i = 0; i < adders.length; i++) {
    adderIds.push(adders[i].id);
  }

  // sets Ppw and LoanA, however, loanA is being set to an array which will break a lot of things if that is ran
  // TODO: Adjust
  useEffect(() => {
    if (cpsRebate === 0 && austinRebate === 0) {
      if (loanChangeSize > 0 && +team.id1 === +loanA.loanId) {
        if (systemSize >= +loanChangeSize) {
          setLoanA([
            +id3,
            loan3,
            +term3,
            +int3,
            +pre3,
            +post3,
            +interest3,
            +itc3,
            +specialPrice3,
            0,
          ]);
          if (+proposal.ppa1 === 1) {
            setPpw(+proposal.ppwRate1 + +loanChangeIncrease);
          } else {
            setPpw(+proposal.ppw + +loanChangeIncrease);
          }
        } else {
          if (+proposal.ppa1 === 1) {
            setPpw(+proposal.ppwRate1);
          } else {
            setPpw(+proposal.ppw);
          }
          return (
            setLoanA([
              +proposal.id1,
              proposal.loan1,
              +proposal.term1,
              +proposal.int1,
              +proposal.pre1,
              +proposal.post1,
              +proposal.interest1,
              +proposal.itc1,
              +proposal.specialPrice1,
              +proposal.ppa1,
            ])
          );
        }
      }
    }
  }, [systemSize, loanChangeSize, cpsRebate, austinRebate]);

  // sets Ppw, basePpw, and viewOptions based on loanA, salesTeam, and proposal
  // TODO: Adjust
  useEffect(() => {
    if (cpsRebate === 0 && austinRebate === 0 && +loanA.loanId !== 115) {
      if (
        loanA.specialPrice > 0 &&
        salesTeam !== "Las Vegas Sales Team II" &&
        +specialLoanIncrease === 1
      ) {
        if (+loanA.specialPrice < 1) {
          return (
            setPpw(+ppw || +team.ppw + +loanA.specialPrice, true),
            setBasePpw(+team.ppw + loanA.specialPrice)
          );
        }
        if (
          +loanA.specialPrice > 1 ||
          loanA.loanName === "Flic" ||
          +loanA.isPpa === 1
        ) {
          return (
            setPpw(+ppw || +loanA.specialPrice, true),
            setBasePpw(loanA.specialPrice),
            setViewOptions(0)
          );
        }
      } else if (+loanA.isPpa === 1) {
        return setViewOptions(1);
      }
      setPpw(+ppw || +proposal.ppw, true);
      setBasePpw(+teamPpw);
      setViewOptions(1);
    }
  }, [loanA, salesTeam, proposal, cpsRebate, austinRebate]);

  // sets Ppw, basePpw
  // TODO: Adjust
  useEffect(() => {
    if (cpsRebate === 0 && austinRebate === 0) {
      if (
        loanB.specialPrice > 0 &&
        salesTeam !== "Las Vegas Sales Team II" &&
        +specialLoanIncrease === 1
      ) {
        if (+loanB.specialPrice < 1) {
          return (
            setPpw(+team.ppw + +loanB.specialPrice),
            setBasePpw(+team.ppw + loanB.specialPrice)
          );
        }
        if (+loanB.specialPrice > 1) {
          return setPpw(+loanB.specialPrice), setBasePpw(+loanB.specialPrice);
        }
      }
      if (+proposal.ppa1 === 1) {
        setPpw(+proposal.ppwRate1);
      } else {
        setPpw(+proposal.ppw);
      }
      setBasePpw(+teamPpw);
    }
  }, [loanB, salesTeam, proposal, cpsRebate, austinRebate]);

  // sets LoanB, HighLoan, and Ppw
  // TODO: Adjust
  useEffect(() => {
    if (
      salesTeam === "Las Vegas Sales Team II" ||
      salesTeam === "Las Vegas Sales Team 3"
    ) {
      if (+loanA.specialPrice > 0) {
        setLoanB([68, "Dividend", 12, 0.99, 0.0052252, 0.0076952, 0, 0.3]);
        setHighLoan(0.2);
        if (+basePpw !== +proposal.ppw) {
          if (+proposal.ppa1 === 1) {
            setPpw(+proposal.ppwRate1 + highLoan);
          } else {
            setPpw(+proposal.ppw + highLoan);
          }
        }
        setPpw(+basePpw + highLoan);
      } else {
        return (
          setLoanB({
            loanId: +proposal.id2,
            loanName: proposal.loan2,
            loanTerm: +proposal.term2,
            interestOnlyPayment: +proposal.interest2,
            prePayment: +proposal.pre2,
            postPayment: +proposal.post2,
            loanInterest: +proposal.int2,
            itc: +proposal.itc2,
            specialPrice: +proposal.specialPrice2,
            isPpa: +proposal.ppa2,
            ppaRate: +proposal.ppaRate2,
            ppaEscalator: +proposal.ppaEscalator2,
            dealerFee: +proposal.dealerFee2,
            ppwRate: +proposal.ppwRate2,
          }),
          setHighLoan(0)
        );
      }
      if (loanA.specialPrice > 0) {
        if (+proposal.id1 === +loanA.loanId) {
          if (+proposal.ppa1 === 1) {
            return setPpw(+proposal.ppwRate1), setBasePpw(+proposal.ppwRate1);
          } else {
            return setPpw(+proposal.ppw), setBasePpw(+proposal.ppw);
          }
        }
      }
    }
  }, [proposal, salesTeam, loanA, highLoan]);

  // sets LoanA, LoanB, BasePpw, Ppw, Rebate, and IonRebate if custUtility is CPS and cpsRebate is 1 (true?)
  // @note What do these values mean?
  // TODO: Adjust
  useEffect(() => {
    if (custUtility === "City Public Service (CPS)") {
      if (cpsRebate === 1) {
        return (
          setLoanA([82, "GoodLeap", 20, 4.99, 0.00504, 0.00684, 0, 0.3, 0, 0]),
          setLoanB([
            79,
            "GoodLeap",
            12,
            2.99,
            0.0059987,
            0.0087759,
            0,
            0.3,
            0,
            0,
          ]),
          setBasePpw(4),
          setPpw(4),
          setRebate(2500),
          setIonRebate(0)
        );
      }
    }
  }, [cpsRebate]);

  // sets Rebate and IonRebate if custUtility is Austin Energy and austinRebate is 1 (true?)
  // TODO: Adjust
  useEffect(() => {
    if (custUtility === "Austin Energy") {
      if (austinRebate === 1) {
        return setRebate(2500), setIonRebate(0), setPreferredUtility(0);
      }
    }
  }, [austinRebate]);

  // sets Ppw and BasePpw if loanA.specialPrice is greater than 0, but why?
  // TODO: Adjust
  useEffect(() => {
    if (loanA.specialPrice > 0) {
      if (+proposal.id1 === +loanA.loanId) {
        if (+proposal.ppa1 === 1) {
          return setPpw(+proposal.ppwRate1), setBasePpw(+proposal.ppwRate1);
        } else {
          return setPpw(+proposal.ppw), setBasePpw(+proposal.ppw);
        }
      }
    }
  }, [loanA, salesTeam, proposal]);

  // Following were removed from the pricing config (August 2025):
  // cash
  // default
  // nevada
  // flic
  // guzmanPrices
  // texasCPS
  // texas
  // virginia
  // peninsulaSalesTeam
  // newCash

  let minPrice = 2.4;
  let maxPrice = 4.0;
  let incrementor = 0.05;
  let new_pricing = [];

  if (salesTeam?.includes("Las Vegas")) {
    minPrice = 2.8;
  }

  if (salesTeam?.includes("Inside Sales")) {
    minPrice = 2.5;
  }

  if (
    salesTeam?.includes("MA - South Sales Team") ||
    salesTeam?.includes("MA - North Sales Team") ||
    salesTeam?.includes("MA - West Sales Team")
  ) {
    minPrice = 2.6;
  }

  for (let price = maxPrice; price >= minPrice - 0.0001; price -= incrementor) {
    new_pricing.push({
      commType: "",
      amount: price.toFixed(2),
      label: "",
    });
  }

  const defaultPpw = +ppw
    ? (+convertToCashPpw(+ppw, +dealerFee)).toFixed(2)
    : 3.8;

  let selectedPrices = [
    {
      commType: "Current",
      amount: defaultPpw,
    },
    ...new_pricing,
  ];

  let mappedPrices = selectedPrices.map((price, i) => {
    return (
      <option key={i} value={+price.amount}>
        {price.label}{" "}
        {price.amount.toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        })}{" "}
        PPW
      </option>
    );
  });

  // conditionally renders different elements but not sure what the if statement is checking
  let signedProp = true;
  if (currentProp) {
    if (
      customer.step === "asdfasdf" ||
      customer.step === "asdfefdfs" ||
      currentProp.contractSigned === false
    ) {
      signedProp = false;
    }
  }

  // this is absolutely giant this needs to be it's own component
  // mapped proposals - here!!!
  // @note - this is almost 1000 lines of code and should not be that big. It is only being passed into
  let mappedProposals = proposals
    .filter((option) => {
      return +option.isActive === 1;
    })
    .map((proposals, i) => {
      const {
        jan,
        feb,
        mar,
        apr,
        may,
        june,
        july,
        aug,
        sept,
        oct,
        nov,
        december,
        januaryUsage,
        februaryUsage,
        marchUsage,
        aprilUsage,
        mayUsage,
        juneUsage,
        julyUsage,
        augustUsage,
        septemberUsage,
        octoberUsage,
        novemberUsage,
        decemberUsage,
      } = proposals;
      let production = [
        +jan,
        +feb,
        +mar,
        +apr,
        +may,
        +june,
        +july,
        +aug,
        +sept,
        +oct,
        +nov,
        +december,
      ];
      let propUsage = [
        +januaryUsage,
        +februaryUsage,
        +marchUsage,
        +aprilUsage,
        +mayUsage,
        +juneUsage,
        +julyUsage,
        +augustUsage,
        +septemberUsage,
        +octoberUsage,
        +novemberUsage,
        +decemberUsage,
      ];
      let proposalsTotalProduction = total(production);
      let totalPropUsage = total(propUsage);
      let plusMinus = 0;
      let commission;
      let batteryType = null;
      let eto = "NO";
      let propNestAmount = 2076;
      let batteryString = "Battery";
      let groundMountString = "Ground Mount";
      let ballastAmount = 0.27;
      let critterGuardAmount = 0.1;
      let mspAmount = 3500;
      let pSolarAmount = 0.15;
      let battery10Amount = 18000;
      let groundMountAmount = 1.3;
      let freeAmount = proposals.payment1 * 6;
      let utilityReviewAmount = 1250;

      let previousDesignTypes = [];
      let designTypes = [];
      let removeFromPreviousDesignTypes = [
        "Mixed Mounting Hardware",
        "Ballast",
        "Ground Mount",
        "Battery",
      ];

      if (customer.designType) {
        previousDesignTypes = customer.designType.split(";");
      }

      if (+proposals.ballast === 1) {
        if (
          +proposals.ballastModules < +proposals.modCount &&
          +proposals.ballastModules > 0
        ) {
          designTypes.push("Mixed Mounting Hardware");
        }
        designTypes.push("Ballast");
      }
      if (+proposals.groundMount === 1) {
        if (
          +proposals.groundMountModules < +proposals.modCount &&
          +proposals.groundMountModules > 0
        ) {
          designTypes.push("Mixed Mounting Hardware");
        }
        designTypes.push("Ground Mount");
      }
      if (+proposals.battery10 > 0) {
        designTypes.push("Battery");
      }

      if (customer.designType) {
        for (let i = 0; i <= previousDesignTypes.length; i++) {
          let shouldInclude = true;
          for (let r = 0; r <= removeFromPreviousDesignTypes.length; r++) {
            if (previousDesignTypes[i] === removeFromPreviousDesignTypes[r]) {
              shouldInclude = false;
              break;
            }
          }

          if (shouldInclude) {
            designTypes.push(previousDesignTypes[i]);
          }
        }
      }

      proposals.designTypes = designTypes;

      if (proposals.payment1 * 6 >= 1000) {
        freeAmount = 1000;
      }

      if (+proposals.ballastAmount > 0) {
        ballastAmount = +proposals.ballastAmount;
      }
      if (+proposals.critterGuardAmount > 0) {
        critterGuardAmount = +proposals.critterGuardAmount;
      }
      if (+proposals.mspAmount > 0) {
        mspAmount = +proposals.mspAmount;
      }
      if (+proposals.pSolarAmount > 0) {
        pSolarAmount = +proposals.pSolarAmount;
      }
      if (+proposals.battery10Amount > 0) {
        battery10Amount = +proposals.battery10Amount;
      }
      if (+proposals.groundMountAmount > 0) {
        groundMountAmount = +proposals.groundMountAmount;
      }

      if (proposals.ogModCount !== proposals.modCount) {
        plusMinus = 1;
      }

      if (+proposals.utilityReviewAmount > 0) {
        utilityReviewAmount = +proposals.utilityReviewAmount;
      }

      let highLoanProp = 0;

      if (salesTeam === "Las Vegas Sales Team") {
        if (proposals.id1 === "32" || proposals.id1 === "45") {
          highLoanProp = 0.15;
        }
        highLoanProp = 0;
      }

      let surveyTypes = [];
      if (+proposals.battery10 === 1) {
        surveyTypes.push(batteryString);
      }
      if (+proposals.groundMount === 1) {
        surveyTypes.push(groundMountString);
      }

      let siteSurveyTypes = surveyTypes.concat(surveys);

      if (+proposals.battery10 > 0) {
        batteryType = "Encharge 10";
      }

      if (+proposals.rebate > 0) {
        eto = "YES";
      }

      if (
        proposals.utility === "Pacific Power" ||
        proposals.utility === "Portland General Electric (PGE)"
      ) {
        if (+proposals.rebateSF > 0) {
          eto = "YES";
        }
      }

      if (proposals.ppw + highLoanProp >= basePpw + highLoanProp + 0.2) {
        commission = "Plus";
      } else if (
        proposals.ppw + highLoanProp >= basePpw + highLoanProp &&
        proposals.ppw + highLoanProp < basePpw + highLoanProp + 0.2
      ) {
        commission = "100%";
      } else if (
        proposals.ppw + highLoanProp >= basePpw + highLoanProp - 0.2 &&
        proposals.ppw + highLoanProp < basePpw + highLoanProp
      ) {
        commission = "50%";
      } else if (proposals.ppw + highLoanProp < basePpw + highLoanProp - 0.2) {
        commission = "None";
      }
      if (proposals.utilityLocation === "Virginia") {
        commission = "";
      }

      let interest = FindTotalInterest(
        proposals.pre1,
        proposals.post1,
        proposals.term1,
        proposals.loanAmount,
        proposals.loan1
      );
      let numOfPayments = proposals.term1 * 12;

      let loanSource = proposals.loan1;
      let loanProduct = `Single ${proposals.term1}yr ${proposals.int1}%`;

      if (proposals.loan1?.toLowerCase() === "goodleap") {
        loanSource = "LoanPal";
      }
      if (+proposals.id1 === 115) {
        loanSource = "Owner Financing";
        loanProduct = "";
      }
      if (+proposals.ppa1 === 1) {
        loanProduct = `${+proposals.ppaRate1 * 100} ${(
          proposals.ppaEscalator1 * 100
        ).toFixed(2)}%`;
      }

      const updateRepProposal = async () => {
        try {
          if (
            +proposal.utilityLseId > 0 &&
            proposal.utilityPpa &&
            +proposal.ppa1 === 1
          ) {
            await createAcct(
              customer,
              totalProduction,
              systemSize,
              panelAmount,
              mod[1],
              mod[3],
              proposal.invType,
              proposal.invModel,
              proposal.utilityLseId,
              proposal.msp,
              proposal.reroof
            );
          }
          const res = await axios.post(apiUrl, {
            method: "update_proposal",
            id: customer.financeId,
            id2: customer.designId,
            id3: customer.projectID,
            of_Solar_Panels__c: +proposals.modCount,
            Number_of_Inverters__c: +proposals.invCount,
            Inverter_Make__c: proposals.invType,
            Inverter_Model__c: proposals.invModel,
            Solar_Panel_Make__c: proposals.module,
            Solar_Panel_Model__c: +proposals.modSize,
            of_Arrays__c: +proposals.arrayCount,
            Utility_Rebate__c: +proposals.rebateSF,
            Primary_Financing_Amount__c: loanA?.totalAmount || loanAmount,
            System_Size__c: +proposals.systemSize,
            Secondary_Financing_Amount__c: +proposals.downPayment,
            Est_Annual_Production__c: +proposalsTotalProduction,
            jan: +proposals.jan,
            feb: +proposals.feb,
            mar: +proposals.mar,
            apr: +proposals.apr,
            may: +proposals.may,
            june: +proposals.june,
            july: +proposals.july,
            aug: +proposals.aug,
            sept: +proposals.sept,
            oct: +proposals.oct,
            nov: +proposals.nov,
            dec: +proposals.december,
            version: +i + 1,
            ballast: +proposals.ballast,
            groundMount: +proposals.groundMount,
            propId: proposals.propId,
            Offset__c: offset(),
            Plus_Minus_Panels__c: plusMinus,
            Battery_Type__c: batteryType,
            State_Rebate_Project__c: eto,
            id4: customer.installId,
            id5: customer.projectID,
            of_Stories__c: customer.stories,
            survey: siteSurveyTypes.join(";"),
            rep_gen: +proposals.repGen,
            sharedHome,
            Financing_Source__c: loanSource,
            Financing_Product__c: loanProduct,
            Rebate_Type__c: "",
            designTypes: proposals.designTypes.join(";"),
            Roof_Space_Limited__c: "",
            Shade_Waiver__c: proposals.shadeWaiver,
            Interest__c: interest,
            Total_Number_of_Payments__c: numOfPayments,
            security: securityToggled,
            security_amount: securityToggled ? 925 / +dealerFee : 0,
            Rebate_Project__c: state === "Illinois" && proposals.battery10 > 0,
            net_ppw: netPpw,
            gross_ppw: grossPpw,
            selected_ppw: selectedPpw,
          });
          Alert.success(`Proposal info added to App`, {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          });
          let temp = window.location.hash.split("/");
          temp[2] = proposals.propId;
          temp[3] = +i + 1;
          window.location.hash = temp.join("/");
          getCustomer();
        } catch (error) {
          console.error("Error updating proposal:", error);
        }
      };

      const addHomeEnergyAll = () => {
        if (homeEnergyAdderCall.length > 0) {
          axios
            .post(apiUrl, {
              method: "add_home_energy_all",
              financing_id: customer.financeId,
              project_id: customer.projectID,
              adders: JSON.stringify(homeEnergyAdderCall),
            })
            .then((res) => {
              getCustomer();
            });
        }
      };

      let adderCall = [];
      let homeEnergyAdderCall = [];

      // Define a map of energy efficiency upgrades
      const energyUpgrades = [
        {
          key: "smartHome",
          label: "Smart Home Energy Efficiency Upgrade",
          amount: proposals.smartHomeAmount,
        },
        {
          key: "hvac",
          label: "HVAC Energy Efficiency Upgrade",
          amount: proposals.hvacAmount,
        },
        { key: "led", label: "LED Lighting", amount: proposals.ledAmount },
        {
          key: "turf",
          label: "Landscaping and Turf Energy Efficiency Upgrade",
          amount: proposals.turfAmount,
        },
        {
          key: "windows",
          label: "Windows and Doors Energy Efficiency Upgrade",
          amount: proposals.windowsAmount,
        },
        {
          key: "water",
          label: "Water Efficiency Upgrade",
          amount: proposals.waterAmount,
        },
      ];

      // Loop through the energy upgrades and push to `homeEnergyAdderCall` if selected
      energyUpgrades.forEach((upgrade) => {
        if (proposals[upgrade.key] === "1") {
          homeEnergyAdderCall.push({
            adder: upgrade.label,
            amount: upgrade.amount * dealerFee,
          });
        }
      });

      // Nest type handling
      let nestType =
        +proposals.hasNestAdder === 1
          ? "Smart Thermostat +"
          : "Smart Thermostat";

      const adders = [
        {
          condition: waterSoftener === 1,
          adder: {
            adder: "waterSoftener",
            amount: waterSoftenerAmount,
          },
        },
        {
          condition: +proposals.sustainable === 1,
          adder: {
            adder: "portlandAdder",
            amount: proposals.systemSize * 0.34,
          },
        },
        {
          condition: state === "Oregon",
          adder: {
            adder: "orSpsAdder",
            amount: proposals.systemSize * OR_SPS_ADDER_PER_WATT,
          },
        },
        { condition: +townhome === 1, adder: { adder: "townhome" } },
        {
          condition: +proposals.modCount <= 5,
          adder: {
            adder: "smallSystem5AndUnder",
            amount: 2000 / dealerFee,
          },
        },
        {
          condition: +proposals.modCount > 5 && +proposals.modCount <= 7,
          adder: {
            adder: "smallSystem7or6",
            amount: 1000 / dealerFee,
          },
        },
        {
          condition: +proposals.modCount > 7 && +proposals.modCount <= 9,
          adder: {
            adder: "smallSystem8or9",
            amount: 500 / dealerFee,
          },
        },
        {
          condition: +proposals.hasNest > 0,
          adder: {
            adder: "hasNest",
            type: nestType,
            amount: +proposals.hasNest,
          },
        },
        {
          condition: proposals.hasNest === "3",
          adder: {
            adder: "hasNest",
            type: nestType,
            amount: +proposals.hasNest,
          },
        }, // Repeat Nest Test
        {
          condition: proposals.ionRebate === "2",
          adder: { adder: "repAdder" },
        },
        {
          condition: proposals.ionRebate === "1",
          adder: { adder: "custAdder" },
        },
        {
          condition: proposals.ionRebate2 === "2",
          adder: { adder: "blkRepAdder" },
        },
        {
          condition: proposals.ionRebate2 === "1",
          adder: { adder: "blkCustAdder" },
        },
        {
          condition: proposals.panelBonus === "2",
          adder: { adder: "panelBonusRep" },
        },
        {
          condition: proposals.panelBonus === "1",
          adder: { adder: "panelBonusCust" },
        },
        {
          condition: proposals.battery10 > 0 && proposals.battery10 < 11,
          adder: {
            adder: "battery10",
            quantity: 1,
            amount: battery10Amount * dealerFee,
          },
        },
        {
          condition: proposals.battery10 > 1 && proposals.battery10 < 11,
          adder: {
            adder: "battery10Add",
            quantity: +proposals.battery10 - 1,
            amount: 12500 * dealerFee,
          },
        },
        {
          condition: proposals.battery10 > 20 && proposals.battery10 < 31,
          adder: {
            adder: "battery10c",
            quantity: proposals.battery10 - 20,
            amount: (battery10Amount * dealerFee) / (proposals.battery10 - 20),
          },
        },
        {
          condition: +proposals.battery10 === 11,
          adder: {
            adder: "powerWall",
            quantity: 1,
            amount: battery10Amount * dealerFee,
          },
        },
        {
          condition: ["1", "2"].includes(proposals.msp),
          adder: { adder: "msp", amount: mspAmount },
        },
        {
          condition: proposals.freeMonths === "1",
          adder: { adder: "freeMonths", amount: freeAmount },
        },
        {
          condition: proposals.utility === "Salt River Project (SRP)",
          adder: { adder: "loadSwitch", amount: +loadSwitchAmount },
        },
        {
          condition: proposals.freeMonths === "2",
          adder: { adder: "freeMonthsRep", amount: freeAmount },
        },
        {
          condition: proposals.ballast === "1",
          adder: {
            adder: "ballast",
            amount:
              proposals.ballastModules * proposals.modSize * ballastAmount,
          },
        },
        {
          condition: proposals.critterGuard === "1",
          adder: {
            adder: "critterGuard",
            amount: proposals.systemSize * critterGuardAmount,
          },
        },
        {
          condition: proposals.treeTrim === "1",
          adder: {
            adder: "treeRemoval",
            amount: proposals.treeTrimAmount * dealerFee,
          },
        },
        {
          condition: !!+proposals.utilityReview,
          adder: {
            adder: "utilityReview",
            amount: proposals.utilityReviewAmount * dealerFee,
          },
        },
        {
          condition: +proposals.reroof > 0,
          adder: {
            adder: "reroof",
            amount: proposals.reroofAmount * dealerFee,
          },
        },
        {
          condition: proposals.groundMount === "1",
          adder: {
            adder: "groundMount",
            amount:
              proposals.groundMountModules *
              proposals.modSize *
              groundMountAmount,
          },
        },
        {
          condition: proposals.travel === "1",
          adder: {
            adder: "travel",
            amount: proposals.systemSize * proposals.travelAmount,
          },
        },
        {
          condition: proposals.pSolar === "1",
          adder: {
            adder: "poolSolar",
            amount: proposals.systemSize * pSolarAmount,
          },
        },
        {
          condition: +proposals.military > 0,
          adder: { adder: "repMilitary", amount: proposals.military },
        },
        {
          condition: proposals.miscCash === "1",
          adder: { adder: "miscCash", amount: proposals.miscCashAmount },
        },
        {
          condition: proposals.blackFriday === "1",
          adder: { adder: "blackFriday" },
        },
        {
          condition: proposals.blackFriday === "2",
          adder: { adder: "christmas" },
        },
        {
          condition: +proposal.security > 0,
          adder: { adder: "security", amount: proposal.security_amount },
        },
        {
          condition: true,
          adder: {
            adder: "travelAdder",
            amount: travelAdderAmount,
            tier:
              +customer.travelDistance < 76
                ? ""
                : +customer.travelDistance <= 100
                  ? "Tier 1: 76-100 Miles"
                  : +customer.travelDistance <= 125
                    ? "Tier 2: 101-125 Miles"
                    : "Tier 3: 126-150 Miles",
          },
        },
        {
          condition: ionRebate === 3,
          adder: { adder: "setterCashBonus" },
        },
        {
          condition: proposals.pvSystemAddOn === "1",
          adder: {
            adder: "pvSystemAddOn",
            amount: 1000 / dealerFee,
          },
        },
        {
          condition: acCoupled > 0,
          adder: {
            adder: "acCoupled",
            quantity: acCoupled,
          },
        },
        {
          condition: permittingAdder > 0,
          adder: {
            adder: "permittingAdder",
            amount: permittingAdderAmount * systemSize,
          },
        },
      ];

      // Push the adders based on conditions
      adders.forEach(({ condition, adder }) => {
        if (condition) adderCall.push(adder);
      });

      if (totalPropUsage * nestMax < 2076) {
        propNestAmount = totalPropUsage * nestMax;
      }

      const offset = () => {
        if (uType === "Square Footage") {
          return "0";
        }
        if (uType === "Partial 12 Months") {
          return Math.round((proposalsTotalProduction / totalPropUsage) * 100);
        }
        return Math.round((proposalsTotalProduction / totalPropUsage) * 100);
      };

      const copier = () => {
        return Alert.success(
          `${proposals.systemSize / 1000}kW Customer Link Copied`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          }
        );
      };

      const deleteProp = () => {
        axios
          .post(apiUrl, {
            method: "delete_prop",
            active: 0,
            prop_id: proposals.propId,
          })
          .then((res) => {
            getProposalsByProjectId();
            Alert.success(`Proposal Removed`, {
              position: "top-right",
              effect: "flip",
              beep: false,
              timeout: 5000,
              offset: 100,
              color: "rgba(255, 255, 255, 0.927)",
            });
          });
      };

      let custLink;
      if (name) {
        custLink =
          Math.round(Math.random() * (9999 - 1000) + 1000) +
          `${name.split(" ").join("")}`;
      }
      const propV = i + 1;

      const syncProp = () => {
        axios
          .post(apiUrl, {
            method: "sync_prop",
            sync: 1,
            prop_id: proposals.propId,
          })
          .then((res) => { });
      };

      let synced = false;
      let syncedId;
      if (currentProp) {
        syncedId = currentProp.syncPropId;
      }
      if (proposals.propId === syncedId) {
        synced = true;
      }

      const linkOut = () => {
        return window.open(
          `https://proposalist.iondeveloper.com/?proj_id=${proposal.projectId
          }#/propview/${proposals.propId}/${i + 1}/1`,
          "_blank"
        );
      };

      return (
        <div key={i}>
          <div>
            {sendCiaDoc ? (
              <>
                <div
                  className="savingsText modals doc"
                  onClick={
                    syncLoading === true || signedProp === true
                      ? () => null
                      : () => {
                        updateRepProposal();
                        syncProp();
                        addHomeEnergyAll();
                        setSyncLoading(true);
                      }
                  }
                >
                  {synced ? (
                    <CheckBoxOutlinedIcon />
                  ) : syncLoading === true ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <CheckBoxOutlineBlankOutlinedIcon />
                  )}{" "}
                  v{i + 1} - {proposals.systemSize / 1000} kW -{" "}
                  {proposals.utility === "Austin Energy" ||
                    proposals.utility.includes("Xcel Energy")
                    ? (+proposals.loanAmount).toLocaleString(undefined, {
                      style: "currency",
                      currency: "USD",
                    })
                    : (
                      +proposals.loanAmount +
                      +proposals.rebate +
                      +proposals.downPayment
                    ).toLocaleString(undefined, {
                      style: "currency",
                      currency: "USD",
                    })}{" "}
                  - {uType === "Square Footage" ? "" : `${offset()}%`}
                </div>
              </>
            ) : viewProposals === true ? (
              <>
                {width < smallBreakPoint ? (
                  <>
                    <div className="row" align="center">
                      <div className="col-2" onClick={() => linkOut()}>
                        <div
                          className={`savingsText modals props ${synced ? "signed" : ""
                            }`}
                        >
                          {" "}
                          {proposals.systemSize / 1000}kW{" "}
                        </div>
                      </div>
                      <div className="col-3" onClick={() => linkOut()}>
                        <div
                          className={`savingsText modals props ${synced ? "signed" : ""
                            }`}
                        >
                          {proposals.utility === "Austin Energy" ||
                            proposals.utility.includes("Xcel Energy")
                            ? (+proposals.loanAmount).toLocaleString(
                              undefined,
                              { style: "currency", currency: "USD" }
                            )
                            : (
                              +proposals.loanAmount +
                              +proposals.rebate +
                              +proposals.downPayment
                            ).toLocaleString(undefined, {
                              style: "currency",
                              currency: "USD",
                            })}{" "}
                        </div>
                      </div>
                      {synced && signedProp === false ? (
                        <div className="col-2">
                          <button className="custButton current">
                            <img className="img" src={checkCircle}></img>Current
                          </button>
                        </div>
                      ) : signedProp === false ? (
                        <div className="col-2">
                          <button
                            className="custButton sync"
                            onClick={
                              syncLoading === true
                                ? () => null
                                : () => {
                                  updateRepProposal();
                                  syncProp();
                                  addHomeEnergyAll();
                                  setSyncLoading(true);
                                }
                            }
                          >
                            {syncLoading === true ? (
                              <CircularProgress
                                size={15}
                                color="inherit"
                                className="img"
                              />
                            ) : (
                              <img className="img" src={sync}></img>
                            )}
                            Sync
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                      {width > smallBreakPoint ? (
                        <div className="col-2">
                          <a
                            href={`https://dev.iondeveloper.com/api/proposal/generatePDF/proposalv2.php?propId=${proposals.propId}&projectId=${proposal.projectId}`}
                            target="_blank"
                          >
                            <button className="custButton sync">
                              <img className="img pdf" src={download}></img> PDF
                            </button>
                          </a>
                        </div>
                      ) : null}
                      <div className="col-2">
                        <CopyToClipboard
                          onCopy={() => {
                            setCopied(true);
                            copier();
                          }}
                          text={`https://proposalist.iondeveloper.com/?proj_id=${proposal.projectId
                            }#/customerpropview/${proposals.propId}/${i + 1
                            }/${custLink}`}
                        >
                          <button className="custButton custLink">
                            CustLink
                          </button>
                        </CopyToClipboard>
                      </div>
                      {signedProp === false ? (
                        <>
                          {synced ? (
                            <div className="col-2">
                              <button className="custButton gray">
                                Delete
                              </button>
                            </div>
                          ) : (
                            <div className="col-2">
                              <button
                                className="custButton delete"
                                onClick={() => deleteProp()}
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-1" onClick={() => linkOut()}>
                        <div
                          className={`savingsText modals props ${synced ? "signed" : ""
                            }`}
                        >
                          V{i + 1}
                        </div>
                      </div>
                      <div className="col-1" onClick={() => linkOut()}>
                        <div
                          className={`savingsText modals props ${synced ? "signed" : ""
                            }`}
                        >
                          {" "}
                          {proposals.systemSize / 1000}kW{" "}
                        </div>
                      </div>
                      <div className="col-2" onClick={() => linkOut()}>
                        <div
                          className={`savingsText modals props ${synced ? "signed" : ""
                            }`}
                        >
                          {" "}
                          {proposals.utility === "Austin Energy" ||
                            proposals.utility.includes("Xcel Energy")
                            ? (+proposals.loanAmount).toLocaleString(
                              undefined,
                              { style: "currency", currency: "USD" }
                            )
                            : (
                              +proposals.loanAmount +
                              +proposals.rebate +
                              +proposals.downPayment
                            ).toLocaleString(undefined, {
                              style: "currency",
                              currency: "USD",
                            })}{" "}
                        </div>
                      </div>
                      <div className="col-1" onClick={() => linkOut()}>
                        {uType === "Square Footage" ? (
                          ""
                        ) : (
                          <div
                            className={`savingsText modals props ${synced ? "signed" : ""
                              }`}
                          >
                            {offset()}%{" "}
                          </div>
                        )}
                      </div>
                      {synced && signedProp === false ? (
                        <div className="col">
                          <button className="custButton current">
                            <img className="img" src={checkCircle}></img>Current
                          </button>
                        </div>
                      ) : signedProp === false ? (
                        <div className="col">
                          <button
                            className="custButton sync"
                            onClick={
                              syncLoading === true
                                ? () => null
                                : () => {
                                  updateRepProposal();
                                  syncProp();
                                  addHomeEnergyAll();
                                  setSyncLoading(true);
                                }
                            }
                          >
                            {syncLoading === true ? (
                              <CircularProgress
                                size={15}
                                color="inherit"
                                className="img"
                              />
                            ) : (
                              <img className="img" src={sync}></img>
                            )}
                            Sync
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="col">
                        <a
                          href={`https://dev.iondeveloper.com/api/proposal/generatePDF/proposalv2.php?propId=${proposals.propId}&projectId=${proposal.projectId}`}
                          target="_blank"
                        >
                          <button className="custButton sync">
                            <img className="img pdf" src={download}></img> PDF
                          </button>
                        </a>
                      </div>
                      <div className="col">
                        <CopyToClipboard
                          onCopy={() => {
                            setCopied(true);
                            copier();
                          }}
                          text={`https://proposalist.iondeveloper.com/?proj_id=${proposal.projectId
                            }#/customerpropview/${proposals.propId}/${i + 1
                            }/${custLink}`}
                        >
                          <button className="custButton custLink">
                            Cust Link
                          </button>
                        </CopyToClipboard>
                      </div>
                      {signedProp === false ? (
                        <>
                          {synced ? (
                            <div className="col">
                              <button className="custButton gray">
                                Delete
                              </button>
                            </div>
                          ) : (
                            <div className="col">
                              <button
                                className="custButton delete"
                                onClick={() => deleteProp()}
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      );
    });

  // label used to display info in view (HTML)
  let oregonLabel = "Rebate";
  if (+hasRebate === 3 || +hasRebate === 4) {
    oregonLabel = "ODOE Rebate";
  }

  // disables scroll when slider is open
  // TODO: Adjust
  useEffect(() => {
    if (slider === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [slider]);

  // no idea what list refers to but it is not being used anywhere
  let list = [];
  let offsetOptions = () => {
    var min = 50,
      max = 200,
      multiplier = 5;
    if (proposal.maxOffset) {
      max = +proposal.maxOffset;
    }
    for (var i = min; i <= max; i += multiplier) {
      list.push(i);
    }
    return list;
  };
  offsetOptions();

  // sets margin upsacling for the view using JQuery. Needs to be refactored or remvoed
  useEffect(() => {
    setupMarginScaling(".view1 .container", ".view1 .blur-right");
    setupMarginScaling(".view10 .container", ".view10 .v10-right");
    setupMarginScaling(".viewRoof .container", ".viewRoof .blur-roof");
  }, [window, name]);

  // all values are used to calculate shouldRender and then is passed into <AdderMenu />
  const targetDate = new Date("2024-11-24");
  const targetEndedByDate = new Date("2024-12-01");
  const currentDate = new Date();
  const shouldRender =
    currentDate > targetDate && currentDate <= targetEndedByDate;

  // gets lightreach pricing if customer has a lightreach account and loanProducts2 is not empty
  // TODO: Fix this
  // TODO: Adjust
  useEffect(() => {
    if (customer.lightReachAccountId && loanProducts2.length > 0) {
      // getPpaPricing(customer.lightReachAccountId);
    }
  }, [loanProducts2, msp]);

  // passed into <ProposalMenu /> but is never used in this file. It does not need to be here.
  const [callComplete, setCallComplete] = useState(false);

  // sets HOA if hoaName or state is Virginia.
  // TODO Adjust
  useEffect(() => {
    if (hoaName || state === "Virginia") {
      setHoa(true);
    }
  }, [hoaName, state]);

  // shows goodLeapApplications if viewLoans is true
  // TODO: Adjust
  useEffect(() => {
    if (viewLoans) {
      getGoodLeapApplications();
      getSungageApplication();
    }
  }, [viewLoans]);

  useEffect(() => {
    const teslaBatteryAmount = +battery10 > 10 ? +battery10 - 10 : 0;
    if (teslaBatteryAmount && custUtility === "Pacific Power") {
      setPacificPowerRebate(teslaBatteryAmount > 1 ? 6000 : 3000);
    } else {
      setPacificPowerRebate(0);
    }
    if (custUtility === "CenterPoint Energy") {
      setCenterPointRebate(systemSize / 1000 > 15 ? 2025 : systemSize / 1000 * 135);
    } else {
      setCenterPointRebate(0);
    }

    if (custUtility === "Guadalupe Valley Electric Cooperative (GVEC)") {
      //check battery rating
      let batteryRating = 0; //kW
      //check number of battery
      let batteryCount = 0;
      //check proposal battery type and installed date ?
      //Note: Do we need to backtrack previously installed systems to apply the rebates?
      if (+battery10 > 10 && +battery10 < 21) { //tesla
        batteryRating = 11.5;
        batteryCount = +battery10 - 10;
      }

      //battery types below are no longer available in the ui but can still be added 
      if (+battery10 < 11 && +battery10 > 0) { //enphase 5
        batteryRating = 3.84;
        batteryCount = +battery10;
      }
      if (+battery10 > 20) { //enphase 10
        batteryRating = 7.08;
        batteryCount = +battery10 - 20;
      }

      let gvecRebateInitial = (220 * batteryRating) * batteryCount;
      let gvecRebateAnnual = (75 * batteryRating) * batteryCount;
      let totalGvecRebate = gvecRebateInitial + gvecRebateAnnual;
      setGvecNewBatteryRebate(totalGvecRebate);
    } else {
      setGvecNewBatteryRebate(0);
    }

  }, [battery10])

  // handles fetching the Sungage payments when systemCost changes and loanName is Sungage
  // @note - there are conditional checks throughout the HTML to show specific nuumbers for Sungage
  // TODO: Make async and await the call to the API
  const fetchSungagePayments = async (
    loanTerm,
    loanInterest,
    loanAmount,
    itc,
    ppaEscalator
  ) => {
    if (!customer?.state) return;

    try {
      const listOfStates = require("us-state-converter");

      const payload = {
        state: listOfStates.abbr(state),
        term: +loanTerm,
        rate: +loanInterest,
        solarAmount: +loanAmount,
        solarSize: proposal.systemSize / 1000,
        downPayment: +proposal.downPayment,
        ach: true,
        paydown: false,
        dppType: "36",
        itc: 0,
        utility: proposal.utility,
      };

      if (ppaEscalator != null) {
        payload.ppaEscalator = +ppaEscalator;
      }

      // handle roof loan amount
      if (!!reRoof) {
        payload.roofAmount = +reRoofAmount;
        payload.solarAmount -= +reRoofAmount;
      }

      // handle battery loan amount
      const batteryAmount =
        (+battery10 ? +battery10Amount : 0) + (+battery3 ? +battery3Amount : 0);

      if (+batteryAmount > 0) {
        payload.batteryAmount = +batteryAmount.toFixed(2);
        payload.solarAmount -= +batteryAmount.toFixed(2);
      }

      // handle special cases for illinois rebates
      if (
        state === "Illinois" && [
          utilitiesMap[
            ("Ameren Illinois", utilitiesMap["Commonwealth Edison (ComEd)"])
          ].includes(custUtility),
        ]
      ) {
        // manually add the inverter/battery rebate
        if (rebate > 0) {
          payload.solarRebate = (payload.solarRebate || 0) + rebate;
          payload.solarRebatePaidToHomeowner = true;
        }

        // manually add the solar rebate
        if (recValue?.afterEnergy > 0) {
          payload.solarRebate =
            (payload.solarRebate || 0) + Math.round(recValue.afterEnergy);
          payload.solarRebatePaidToHomeowner = true;
        }
      }

      const data = await sungageApi.calculateMonthlyPayments({
        username: activeUser.username,
        ...payload,
      });

      return data;
    } catch (error) {
      Alert.error(error.message, {
        position: "top-left",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
      console.error("Sungage Payments Error", error);
    }
  };

  useEffect(() => {
    if (
      downPayment > 0 ||
      homeEnergyTotal > 0 ||
      loanA.itc > 0 ||
      stateTax > 0 ||
      discounts > 0 ||
      rebate > 0 ||
      recValue.afterEnergy > 0
    ) {
      setShowNetCost(true);
    } else {
      setShowNetCost(false);
    }
  }, [
    downPayment,
    homeEnergyTotal,
    loanA.itc,
    stateTax,
    discounts,
    rebate,
    recValue.afterEnergy,
  ]);

  // for legal reasons all proposals in south carolina must be at least 12px or larger
  useEffect(() => {
    if (state === "South Carolina") {
      document.querySelectorAll(".savingsText").forEach((el) => {
        if (
          el.className.includes("v2") ||
          el.className.includes("v3") ||
          el.className.includes("v5") ||
          el.className.includes("v7")
        ) {
          el.style.fontSize = "12px";
        }
      });
    }
  }, [customer, state]);

  useEffect(() => {
    if (+loanA?.isPpa === 1) {
      setNeedToResyncTpoPricing(true);
    }
  }, [battery10Amount, expansionPackAmount, battery10, expansionPack]);

  useEffect(() => {
    if (!viewLoans || +loanA?.isPpa !== 1) return;
    if (pendingTpoResyncAfterAddersRef.current) {
      setNeedToResyncTpoPricing(true);
      pendingTpoResyncAfterAddersRef.current = false;
    }
  }, [viewLoans, loanA?.isPpa]);

  /**
   * Send CIA / Create New: Sales-Reps need net PPW ≥ $2.40. Any other Cognito role is not blocked by PPW.
   * Until groups load, keep prior behavior (block when net PPW is below $2.40).
   */
  const isValidNetPpwForProposalMenu = useMemo(() => {
    const groupsLoaded = Array.isArray(userGroups);
    const netPpwNum = Number(netPpw) || 0;
    const ppwMeetsMinimum = netPpwNum >= 2.4;
    if (!groupsLoaded) {
      return ppwMeetsMinimum;
    }
    const isSalesRep = (userGroups || []).includes("Sales-Rep");
    return !isSalesRep || ppwMeetsMinimum;
  }, [userGroups, netPpw]);

  // this is the main return for propview
  return (
    <>
      <div>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
          crossOrigin="anonymous"
        ></link>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css"
        ></link>
        <div className={slider ? "modalMenu openModal" : "modalMenu"}>
          <div className="container">
            <div className="row"></div>
            <div className="row">
              <div className="col-sm row g-0 p-0 m-0">
                <div
                  className={
                    viewCiaInfo ? "modalButton checked" : "modalButton"
                  }
                  onClick={viewCiaInfo ? null : () => viewApp()}
                >
                  <img
                    className="img cust"
                    src={
                      viewCiaInfo || width < smallBreakPoint
                        ? custBlue
                        : custWhite
                    }
                  ></img>
                  <div
                    className={
                      viewCiaInfo
                        ? "modalButtonText checked"
                        : "modalButtonText"
                    }
                  >
                    Customer
                  </div>
                </div>
              </div>
              <div className="col-sm row g-0 p-0 m-0">
                <div
                  className={viewAdders ? "modalButton checked" : "modalButton"}
                  onClick={viewAdders ? null : () => viewA()}
                >
                  <img
                    className="img add"
                    src={
                      viewAdders || width < smallBreakPoint
                        ? addersBlue
                        : addersWhite
                    }
                  ></img>
                  <div
                    className={
                      viewAdders ? "modalButtonText checked" : "modalButtonText"
                    }
                  >
                    Adders
                  </div>
                </div>
              </div>
              {/*

              <div className="col-sm row g-0 p-0 m-0">
                <div
                  className={
                    viewEquipment ? "modalButton checked" : "modalButton"
                  }
                  onClick={viewEquipment ? null : () => viewE()}
                >
                  <img
                    className="img equip"
                    src={
                      viewEquipment || width < smallBreakPoint
                        ? equipBlue
                        : equipWhite
                    }
                  ></img>
                  <div
                    className={
                      viewEquipment
                        ? "modalButtonText checked"
                        : "modalButtonText"
                    }
                  >
                    Equipment
                  </div>
                </div>
              </div> */}
              <div className="col-sm row g-0 p-0 m-0">
                <div
                  className={viewLoans ? "modalButton checked" : "modalButton"}
                  onClick={viewLoans ? null : () => viewL()}
                >
                  <img
                    className="img fin"
                    src={
                      viewLoans || width < smallBreakPoint ? finBlue : finWhite
                    }
                  ></img>
                  <div
                    className={
                      viewLoans ? "modalButtonText checked" : "modalButtonText"
                    }
                  >
                    Financing
                  </div>
                </div>
              </div>
              <div className="col-sm row g-0 p-0 m-0">
                <div
                  className={
                    viewProposals ? "modalButton checked" : "modalButton"
                  }
                  onClick={viewProposals ? null : () => viewP()}
                >
                  <img
                    className="img props"
                    src={
                      viewProposals || width < smallBreakPoint
                        ? propsBlue
                        : propsWhite
                    }
                  ></img>
                  <div
                    className={
                      viewProposals
                        ? "modalButtonText checked"
                        : "modalButtonText"
                    }
                  >
                    Proposals
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {/* menu components */}
              <div className="innerModal">
                {sendCiaDoc && (
                  <SendCIAMenu
                    // Current Property Details
                    currentProp={currentProp}
                    // Financing and Proposal Information
                    mappedAdders={mappedAdders}
                    mappedProposals={mappedProposals}
                    financingLabel={financingLabel}
                    ciaButton={ciaButton}
                    // Panel Information
                    panelAmount={panelAmount}
                    originalPanelAmount={originalPanelAmount}
                    // Design Preferences
                    designObj={designObj}
                    designDetails={designDetails}
                    // State Management
                    nem={nem}
                    hoa={hoa}
                    hoaName={hoaName}
                    hoaPhone={hoaPhone}
                    includeSqFtAmendment={includeSqFtAmendment}
                    newBuild={newBuild}
                    showError={showError}
                    errorMessage={errorMessage}
                    sizeChangeNotes={sizeChangeNotes}
                    checkmark={checkmark}
                    // Utility and Location Information∂
                    utilityLocation={utilityLocation}
                    // Callback Functions
                    setNem={setNem}
                    setHoa={setHoa}
                    setHoaName={setHoaName}
                    setHoaPhone={setHoaPhone}
                    setIncludeSqFtAmendment={setIncludeSqFtAmendment}
                    adderToggle={adderToggle}
                    setNewBuild={setNewBuild}
                    setDesignObj={setDesignObj}
                    setDesignDetails={setDesignDetails}
                    setSizeChangeNotes={setSizeChangeNotes}
                    handleInput={handleInput}
                    state={state}
                    electronicConsent={electronicConsent}
                    setElectronicConsent={setElectronicConsent}
                  />
                )}
                {viewCiaInfo && (
                  <CustomerMenu
                    // Current Property Check
                    currentProp={currentProp}
                    // Customer Information
                    customer={customer}
                    primaryContact={primaryContact}
                    name={name}
                    // Address Information
                    phone={phone}
                    street={street}
                    city={city}
                    state={state}
                    zip={zip}
                    // Callback Functions
                    getCustomer={getCustomer}
                    setUpdateCustomer={setUpdateCustomer}
                    updateCustomer={updateCustomer}
                    // Responsive Design Props
                    width={width}
                    smallBreakPoint={smallBreakPoint}
                  />
                )}
                {viewProposals && (
                  <ProposalMenu
                    // Mapped Proposals
                    mappedProposals={mappedProposals}
                    // Proposal and Team Details
                    proposal={proposal}
                    team={team}
                    signedProp={signedProp}
                    callComplete={callComplete}
                    // Customer Information
                    customer={customer}
                    primaryContact={primaryContact}
                    // Address Information
                    street={street}
                    city={city}
                    state={state}
                    zip={zip}
                    // Financing Details
                    currentProp={currentProp}
                    loanA={loanA}
                    // Envelope Details
                    envelopeId={envelopeId}
                    envelopeStatus={envelopeStatus}
                    // Callback Functions
                    setSendCiaDoc={setSendCiaDoc}
                    setViewProposals={setViewProposals}
                    setEnvelopeStatus={setEnvelopeStatus}
                    setCallComplete={setCallComplete}
                    buildNewProposal={buildNewProposal}
                    createUpdatedProposal={createUpdatedProposal}
                    // Miscellaneous
                    loading={loading}
                    isValidNetPpw={isValidNetPpwForProposalMenu}
                  />
                )}
                {viewEquipment && (
                  <EquipmentMenu
                    // Module and Inverter Information
                    mod={mod}
                    inverter={inverter}
                    // Proposal Details
                    proposal={proposal}
                    // Panel Information
                    panelAmount={panelAmount}
                    maxModCount={maxModCount}
                    totalProduction={totalProduction}
                    totalUsage={totalUsage}
                    // View State
                    view={view}
                    // Callback Functions
                    addPanel={addPanel}
                    removePanel={removePanel}
                    // Miscellaneous
                    dash={dash}
                    plus={plus}
                  />
                )}
                {viewAdders && (
                  <AdderMenu
                    systemSize={systemSize}
                    systemSizeAC={systemSizeAC}
                    viewAdders={viewAdders}
                    onAddersChangedForTpo={onAddersChangedForTpo}
                    // State and Utility Flags
                    acCoupled={acCoupled}
                    expansionPack={expansionPack}
                    expansionPackAmount={expansionPackAmount}
                    setExpansionPackAmount={setExpansionPackAmount}
                    setExpansionPack={setExpansionPack}
                    waterSoftener={waterSoftener}
                    setWaterSoftener={setWaterSoftener}
                    battery10={battery10}
                    nest={nest}
                    nestAdder={nestAdder}
                    blackFriday={blackFriday}
                    ionRebate={ionRebate}
                    miscCash={miscCash}
                    powerWall={powerWall}
                    military={military}
                    reRoof={reRoof}
                    preferredUtility={preferredUtility}
                    utilityLocation={utilityLocation}
                    shouldRender={shouldRender}
                    cpsRebate={cpsRebate}
                    austinRebate={austinRebate}
                    sustainable={sustainable}
                    militaryCap={militaryCap}
                    dealerFee={dealerFee}
                    battery10Amount={battery10Amount}
                    hasRec={hasRec}
                    miscCashAmount={miscCashAmount}
                    miscCashNotes={miscCashNotes}
                    loanA={loanA}
                    critterGuard={critterGuard}
                    msp={msp}
                    oregonLightreachPricingBump={oregonLightreachPricingBump}
                    setOregonLightreachPricingBump={setOregonLightreachPricingBump}
                    securityToggled={securityToggled}
                    salesTeam={salesTeam}
                    utilityReview={utilityReview}
                    townhome={townhome}
                    ballast={ballast}
                    ballastAmount={ballastAmount}
                    treeTrim={treeRemoval}
                    treeTrimAmount={treeRemovalAmount}
                    pSolar={pSolar}
                    pSolarAmount={pSolarAmount}
                    // Customer Information
                    customer={customer}
                    // Proposal Information
                    proposal={proposal}
                    // Address Information
                    state={state}
                    // Callback Functions
                    adderToggle={adderToggle}
                    adderToggleBoolean={adderToggleBoolean}
                    adderToggleNest={adderToggleNest}
                    repAdderToggle={repAdderToggle}
                    adderToggleBatteryPowerWall={adderToggleBatteryPowerWall}
                    militaryAdderToggle={militaryAdderToggle}
                    discountToggle={discountToggle}
                    blkAdders={blkAdders}
                    panelBonuses={panelBonuses}
                    reRoofAdderToggle={reRoofAdderToggle}
                    // Setters
                    setNest={setNest}
                    setNestAdder={setNestAdder}
                    setBlackFriday={setBlackFriday}
                    setIonRebate={setIonRebate}
                    setMiscCash={setMiscCash}
                    setMiscCashAmount={setMiscCashAmount}
                    setMiscCashNotes={setMiscCashNotes}
                    setPowerWall={setPowerWall}
                    setBattery10Amount={setBattery10Amount}
                    setBatteryChanged={setBatteryChanged}
                    setMilitary={setMilitary}
                    setHasRec={setHasRec}
                    setCritterGuard={setCritterGuard}
                    setMsp={setMsp}
                    setUtilityReview={setUtilityReview}
                    setUtilityReviewAmount={setUtilityReviewAmount}
                    setBattery10={setBattery10}
                    setReRoof={setReRoof}
                    setSecurityToggled={setSecurityToggled}
                    // Miscellaneous
                    checkmark={checkmark}
                    travelAdder={customer.travelAdder}
                    travelAdderAmount={travelAdderAmount}
                    panelAmount={panelAmount}
                    smallSystemAdderAmount={smallSystemAdderAmount}
                    pvSystemAddOn={pvSystemAddOn}
                    pvSystemAddOnAmount={pvSystemAddOnAmount}
                    permittingAdder={permittingAdder}
                    permittingAdderAmount={permittingAdderAmount}
                  />
                )}
                {viewLoans && (
                  <FinancingMenu
                    needToResyncTpoPricing={needToResyncTpoPricing}
                    setNeedToResyncTpoPricing={setNeedToResyncTpoPricing}
                    qualify={qualify}
                    sungageView={sungageView}
                    goodLeapView={goodLeapView}
                    custView={custView}
                    mod={mod}
                    setSungageApplication={setSungageApplication}
                    viewOptions={viewOptions}
                    checkmark={checkmark}
                    townhome={townhome}
                    inverter={inverter}
                    customer={customer}
                    loanA={loanA}
                    loanB={loanB}
                    bundleId={bundleId}
                    financingAmount={currentProp.financingAmount}
                    currentProp={currentProp}
                    phone={phone}
                    street={street}
                    city={city}
                    state={state}
                    stateAbbr={listOfStates(state)}
                    zip={zip}
                    setQualify={setQualify}
                    setGoodLeap={setGoodLeap}
                    setSungageView={setSungageView}
                    setUpdateCustomer={setUpdateCustomer}
                    setCustView={setCustView}
                    setAustinRebate={setAustinRebate}
                    updateCustomer={updateCustomer}
                    getCustomer={getCustomer}
                    setViewApps={setViewApps}
                    viewApps={viewApps}
                    setAgreed={setAgreed}
                    disclosures={disclosures}
                    disclosureToken={disclosureToken}
                    setLoanAId={setLoanAId}
                    setLoanBId={setLoanBId}
                    setPpw={setPpw}
                    selectedPpw={selectedPpw}
                    ppw={ppw}
                    netPpw={netPpw}
                    grossPpw={grossPpw}
                    dealerFee={dealerFee}
                    adderTotal={adderTotal}
                    ppaEligibleAdderTotal={ppaEligibleAdderTotal}
                    isUsingOldPayscale={isUsingOldPayscale}
                    convertToCashPpw={convertToCashPpw}
                    team={team}
                    proposal={proposal}
                    custUtility={custUtility}
                    agreed={agreed}
                    primaryContact={primaryContact}
                    isCash={isCash}
                    austinRebate={austinRebate}
                    loading={loading}
                    mappedPrices={mappedPrices}
                    mappedLoans={mappedLoans}
                    mappedLoans2={mappedLoans2}
                    allLoans={allLoans}
                    msp={msp}
                    loanProducts2={loanProducts2}
                    loanAmount={loanAmount}
                    batteryAmount={
                      (+battery10 ? +battery10Amount : 0) +
                      (+battery3 ? +battery3Amount : 0)
                    }
                    battery10={battery10}
                    acCoupled={acCoupled}
                    acCoupledAmount={
                      acCoupled ? (1500 * acCoupled) / +dealerFee : 0
                    }
                    calculateBatteryCost={calculateBatteryCost}
                    panelAmount={panelAmount}
                    systemSize={systemSize}
                    estimatedAnnualProduction={+totalProduction}
                    goodLeapApplications={goodLeapApplications}
                    sungageApplication={sungageApplication}
                    creditCheck={creditCheck}
                    createLightReachAcct={createLightReachAcct}
                    adderToggle={adderToggle}
                    powerWall={powerWall}
                    powerWallAmount={powerWallAmount}
                    reRoof={reRoof}
                    reRoofAmount={reRoofAmount}
                    mosaicApi={mosaicApi}
                    goodLeapApi={goodLeapApi2}
                    setPricingDisclosures={setPricingDisclosures}
                    systemCost={systemCost}
                    setSungagePayments={setSungagePayments}
                    recValue={recValue}
                    downPayment={downPayment}
                    activeUser={activeUser}
                    rebate={rebate}
                    customerData={customerData}
                    mspForLightReachGetQuote={mspForLightReachGetQuote}
                    isSigned={currentProp?.contractSigned}
                    setCustomer={setCustomer}
                    expansionPack={expansionPack}
                    expansionPackAmount={expansionPackAmount}
                    setDealerFee={setDealerFee}
                    fetchSungagePayments={fetchSungagePayments}
                    createUpdatedProposal={
                      currentProp?.contractSigned
                        ? createSignedProposal
                        : createProposal
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.0/jquery.min.js"></script>
        <div
          className={slider ? "menuGray" : "noDisplay"}
          onClick={slider ? () => closeSlider() : null}
        ></div>
        <div>
          {+view === 1 ? (
            <>
              <HelpButtonMenu />
            </>
          ) : null}
        </div>
        <div
          onClick={
            slider === true
              ? () => {
                {
                  setSlider(!slider);
                  closeSlider();
                }
              }
              : () => ""
          }
        >
          <Title
            title={`${systemSize / 1000}-${name}-Proposal-v${propVersion}`}
          />
          {+view === 1 ? (
            <>
              <button
                onClick={() => {
                  setSlider(!slider);
                  setViewCiaInfo(true);
                }}
                className={
                  slider
                    ? "hamburger hamburger--squeeze is-active"
                    : "hamburger hamburger--squeeze"
                }
                type="button"
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </>
          ) : (
            <></>
          )}
          <div className="view1">
            <div className="container">
              <div className="row g-0">
                <div className="col-1">
                  <div className="imageSmall">
                    <img className="img" src={Logo}></img>
                  </div>
                </div>
              </div>
              <div className="row pt-5 mt-5">
                <div className="col-2">
                  <div className="image">
                    <img className="img white" src={WhiteLogo}></img>
                  </div>
                </div>

                <div className="col-lg-8 offset-lg-2 ps-lg-3">
                  <div className="blur-right">
                    <div className="border-bottom border-1 border-white"></div>
                  </div>
                  <div className="blur">
                    <div className="row">
                      <div className="col pt-4">
                        <div className="row ps-4">
                          <div>
                            <div className="col fontNew">
                              ENERGY SAVINGS REPORT
                            </div>
                          </div>
                        </div>
                        <div className="row ps-lg-4">
                          <div>
                            <div className="col border-bottom border-1 border-white"></div>
                          </div>
                        </div>
                        {name ? (
                          <>
                            <div className="row ps-4">
                              <div className="col fontName mt-3">
                                {primaryContact.firstName}{" "}
                                {primaryContact.middleName}{" "}
                                {primaryContact.lastName}
                              </div>
                            </div>
                            <div className="row ps-4">
                              <div className="col fontBottom pt-1">
                                {street?.replace(/\b\w/g, (char) =>
                                  char.toUpperCase()
                                )}{" "}
                                {city?.replace(/\b\w/g, (char) =>
                                  char.toUpperCase()
                                )}
                                , {state} {zip}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="row ps-4">
                            <div className="col">
                              <div className="progress-circle">
                                <CircularProgress size={50} color="inherit" />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="view2">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="fontNew2">
                    Going Solar Protects You from
                    <br className="d-none d-sm-block" /> the Rising Costs of
                    Energy
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col" align="center">
                  <div className="row">
                    <div className="fontCost">
                      As the cost of electricity rises year after year, utility
                      prices continue to increase. <br />
                      {isCash ? null : (
                        <>
                          By going solar, you could save an estimated{" "}
                          <span>
                            $
                            {loanA.loanName === "GoodLeap PPA"
                              ? arcadiaSavingsReport.lifetimeAvoidedCost
                                ? Math.round(
                                  arcadiaSavingsReport.lifetimeAvoidedCost
                                ).toLocaleString(undefined)
                                : Math.round(
                                  total(years) * 0.75 * 12 -
                                  (getPpaTotalCost(
                                    loanA.firstMonthPayment,
                                    loanA.ppaEscalator
                                  ) +
                                    total(postYears) * 12)
                                ).toLocaleString(undefined)
                              : Math.round(loan1Savings).toLocaleString(
                                undefined
                              )}
                          </span>{" "}
                          over the next {loanA.loanTerm} years.
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="savingsContainer">
                    <div className="savingsEstimate red v2">
                      <div className="savingsNumber">
                        $
                        {loanA.isPpa === 1
                          ? Math.round(
                            total(years) * 0.924 * 12
                          ).toLocaleString(undefined)
                          : Math.round(total(years) * 12).toLocaleString(
                            undefined
                          )}
                      </div>
                      <div className="savingsText">
                        Your Estimated Cost of Doing{" "}
                        <br className="d-sm-none" /> Nothing
                      </div>
                    </div>
                  </div>
                </div>
                <div className="savingsText v2">
                  Your Estimated Cost of Doing Nothing is determined based on if
                  you purchased the same amount of kWh from your utility
                  provider that the proposed solar system is estimated to
                  produce, your utility’s costs/costs per kWh, any additional
                  kWh that you may need to purchase from your utility company
                  based on your square footage/estimated power needs, and on an
                  estimated 4% increase in utility costs each year over. See
                  “Assumptions and Details” section below.
                </div>
              </div>
              <div className="row">
                <div className="saveText">
                  SAVE WITH SOLAR AS UTILITY COSTS RISE
                </div>
              </div>
              <div className="row">
                <div className="chartContainer">
                  <div className="utilityChart">
                    <UtilityChart
                      index={index}
                      years={years}
                      loan1Bills={loan1Bills}
                      loan2Bills={loan2Bills}
                      viewPayments={viewPayments}
                      width={width}
                      smallBreakPoint={smallBreakPoint}
                      firstMonthPayment={loanA?.firstMonthPayment}
                      escalationRate={loanA?.ppaEscalator}
                      loanTerm={loanA.loanTerm}
                    />
                  </div>
                </div>
              </div>

              <div className="row g-lg-5">
                <div className="col">
                  <div className="costs">
                    <div className="redCircle"></div>
                    <div className="costsText">Est. Utility Costs</div>
                  </div>
                </div>
                {isCash || +view !== 1 ? null : (
                  <>
                    <div className="col">
                      <div className="costs">
                        <div className="form-check form-switch form-switch">
                          <input
                            onChange={(e) => setViewPayments(!viewPayments)}
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            checked={viewPayments}
                          />
                        </div>
                        <div className="costsText">Solar Payments</div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="costs">
                        <div
                          className={viewPayments ? "blueCircle" : "grayCircle"}
                        ></div>
                        <div
                          className={
                            viewPayments ? "costsText" : "costsTextGray"
                          }
                        >
                          Est. Savings
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="savingsText v2">
                  See “Estimated Utility Costs Without the Offset of Solar” page
                  and “Assumptions and Definitions” section below for
                  assumptions used for how estimated utility costs reflected on
                  this graph are calculated. This graph and the reflected
                  “Estimated Savings” shows the different in cost of the
                  proposed “Solar Payments” versus your “Estimated Utility
                  Costs”. This graph does not include post-solar utility costs.
                </div>
              </div>
              <div className="row">
                <div className="saveText">
                  ESTIMATED UTILITY COSTS WITHOUT THE OFFSET OF SOLAR
                </div>
              </div>
              <div className="row justify-content-center">
                <div align="center">
                  <div className="lineBreak"></div>
                </div>
              </div>
              <div className="row g-lg-5">
                <div className="col-sm-12 col-md-4">
                  <div className="savingsEstimate red">
                    <div className="savingsNumber">
                      ${Math.round(billCalc[1]) - 20} - $
                      {Math.round(billCalc[1]) + 20}
                    </div>
                    <div className="savingsText red">
                      Average Monthly Utility Bill
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="savingsEstimate red">
                    <div className="savingsNumber">
                      $
                      {(Math.round(billCalc[1]) * 12).toLocaleString(undefined)}
                    </div>
                    <div className="savingsText red">Annual Utility Bill</div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="savingsEstimate red">
                    <div className="savingsNumber">
                      {loanA.isPpa ? 4.0 : increase}%
                    </div>
                    <div className="savingsText red">
                      Yearly Utility Increase
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="savingsText v2">
                    Your “Average Monthly Utility Bill” is determined based on
                    an average of the costs provided in your historical utility
                    bills that have been provided by you. The “Yearly Utility
                    Increase” is based upon historical utility trends.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="view3">
            <div className="view3 bg">
              <div className="container-lg p-0">
                <div className="costs trees">
                  <div className="container">
                    <div className="row">
                      <div className='col align="center"'>
                        <div className="saveText v3">
                          Going Solar Has Multiple Environmental Benefits
                        </div>
                        <div align="center">
                          <div className="lineBreak"></div>
                        </div>
                        <div className="costsText trees v3">
                          By going solar, you are improving the environment for
                          your family & neighbors. <br /> Your system can offset
                          your carbon footprint equivalent to:
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div className="col-lg-3 col" align="center">
                        <div className="image svg text-center">
                          <img className="img tr" src={treeSvg}></img>
                        </div>
                        <div className="savingsNumber env">
                          {trees().toLocaleString(undefined)}
                        </div>
                        <div className="savingsText env">New Trees</div>
                      </div>
                      <div className="col-lg-3 col" align="center">
                        <div className="image svg text-center">
                          <img className="img gar" src={garbageSvg}></img>
                        </div>
                        <div className="savingsNumber env">
                          {garbages().toLocaleString(undefined)}
                        </div>
                        <div className="savingsText env">Tons of Waste</div>
                      </div>
                      <div className="col-lg-3 col" align="center">
                        <div className="image svg text-center">
                          <img className="img waste" src={gasSvg}></img>
                        </div>
                        <div className="savingsNumber env">
                          {gallons().toLocaleString(undefined)}
                        </div>
                        <div className="savingsText env">Gallons of Gas</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row gx-0">
                  <div className="savingsText bot v3">
                    Environmental impact calculations based on the EPA's
                    greenhouse gas calculator.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="view4">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="fontNew2 v4">
                    Your ION Solar System Overview
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="saveText v4">YOUR SYSTEM DESIGN</div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div align="center">
                  <div className="lineBreak v4"></div>
                </div>
                <div className="row">
                  <div className="col" align="center">
                    <div className="costsText v4">
                      {panelAmount} Total Panels
                    </div>
                  </div>
                </div>
                <div className="row  w-100 justify-content-center">
                  <div className="col px-0" align="center">
                    <img className="image v4" src={design}></img>
                  </div>
                </div>
                {shadeWaiver ? (
                  <div className="row g-5">
                    <div className="col">
                      <div className="costsText v5">
                        This solar design was engineered with the assumption of
                        trees having been removed.
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div className="view5">
            <div className="container">
              {customer.solarGrafProjectId &&
                customer.solarGrafDesignId &&
                +view === 1 ? (
                <div className="row d-flex justify-content-center">
                  <div className="col-sm-4">
                    <button
                      className="custButton confirm"
                      onClick={getAuroraDesignLink}
                    >
                      Edit Design
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <button
                      onClick={getAuroraDesigns}
                      className="custButton confirm"
                    >
                      {loading ? (
                        <CircularProgress size={40} color="inherit" />
                      ) : (
                        "Sync Design"
                      )}
                    </button>
                  </div>
                </div>
              ) : null}
              {showDesignModal && (
                <AuroraDesignListModal
                  show={showDesignModal}
                  onHide={() => {setLoading(false); setShowDesignModal(false); }}
                  sfProjectId={proposal.projectId}
                  currentDesignId={customer.solarGrafDesignId}
                  designs={designList}
                  syncDesign={getAuroraDesignData}
                />
              )}
              {showErrorModal && (
              <ErrorModal 
                errorMessage={errorMessage}
                onHideParent={() => {setErrorMessage(''); setShowErrorModal(false);}} 
              />
              )}

              <div className="col" align="center">
                <div className="saveText">SYSTEM DETAILS</div>
                <div align="center">
                  <div className="lineBreak"></div>
                </div>
              </div>
              <div className="costsContainer v5-1">
                <div className="row g-lg-5">
                  <div className="col-sm-12 col-md-4">
                    <div className="savingsEstimate v5">
                      <div className="savingsNumber v5">
                        {systemSize / 1000} kW
                      </div>
                      <div className="savingsText">System Size</div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <div className="savingsEstimate v5">
                      <div className="savingsNumber v5">
                        {getAnnualProductionString(displayProd, salesTeam)} kWh
                      </div>
                      <div className="savingsText">Est. Annual Production</div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <div className="savingsEstimate v5">
                      <div className="savingsNumber v5">
                        {inverter.type} {inverter.model}
                      </div>
                      <div className="savingsText">Inverter Type</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="savingsContainer v5">
                <div className="savingsEstimate">
                  <div className="panel-container">
                    <div className="panel-amount">
                      <div>
                        <div className="savingsNumber v5">
                          {panelAmount} Panels
                        </div>
                      </div>
                      <div>
                        <div className="savingsText p-0 panels">
                          Premium Tier 1 Panels - {mod[3]}W
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {uType === "Square Footage" ? (
                <></>
              ) : (
                <>
                  <div className="row">
                    <div className="col">
                      <div className="saveText v5">
                        ESTIMATED ANNUAL SOLAR POWER OFFSET
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col" align="center">
                      <div className="prodContainer v5">
                        <div className="prod">{offset}%</div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col" align="center">
                      <div className="donutChart">
                        <DonutChart
                          utility={utility}
                          totalUsage={totalUsage}
                          propRatio={propRatio}
                          systemSize={systemSize}
                          totalProduction={totalProduction}
                          nestAmount={nestAmount}
                          nest={nest}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="col" align="center">
                <div className="saveText">
                  ENERGY PRODUCTION{" "}
                  {uType === "Square Footage" ? "" : "& CONSUMPTION"}
                </div>
              </div>
              <div className="chartContainer">
                <ProdChart
                  uType={uType}
                  usage={usage}
                  production={production}
                  systemSize={systemSize}
                  totalProduction={totalProduction}
                  nestAmount={nestAmount}
                  pRatio={pRatio}
                  currentUsage={currentUsage}
                  width={width}
                  smallBreakPoint={smallBreakPoint}
                  salesTeam={salesTeam}
                />
              </div>
              <div className="costsContainer">
                <div className="row g-5 px-3">
                  {uType === "Square Footage" ? (
                    <></>
                  ) : (
                    <div className="col px-1 px-sm-4">
                      <div className="costs v5">
                        <div className="blueCircle v5"></div>
                        <div className="costsText">
                          <span className="d-none d-lg-inline costsText">
                            {" "}
                            Energy
                          </span>{" "}
                          Consumption
                        </div>
                      </div>
                    </div>
                  )}
                  {uType === "Partial 12 Months" ? (
                    <div className="col px-1 px-sm-4">
                      <div className="costs v5">
                        <div className="grayCircle partial"></div>
                        <div className="costsText">
                          Est.
                          <span className="d-none d-lg-inline costsText">
                            Energy
                          </span>{" "}
                          Consumption
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="col px-1 px-sm-4">
                    <div className="costs v5">
                      <div
                        className={`redCircle ${shouldShowProductionRange(salesTeam) ? "range" : "v5"
                          }`}
                      ></div>
                      <div className="costsText">
                        Solar Production{" "}
                        {shouldShowProductionRange(salesTeam) ? " Range" : ""}
                      </div>
                    </div>
                  </div>
                </div>
                {uType === "Partial 12 Months" ? (
                  <div className="row g-5">
                    <div className="col">
                      <div className="costsText v5">
                        This is an estimate based on the partial usage you have
                        provided. Missing or inaccurate data could result in
                        projections that are different than your actual results
                        and may result in a system that is larger or smaller
                        than you may need.
                      </div>
                    </div>
                  </div>
                ) : uType === "Square Footage" ? (
                  <div className="row g-5">
                    <div className="col">
                      <div className="costsText v5">
                        This is an estimate based on the livable square footage
                        of your home. Missing or inaccurate data could result in
                        projections that are different than your actual results
                        and may result in a system that is larger or smaller
                        than you may need.
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="row">
                <div className="col">
                  <div className="savingsText v5">
                    The forecasted production data provided in this proposal was
                    generated based on the forecasting tools of PVWATTS, a
                    service of the national renewable energy laboratory (NREL)
                    of the U.S. Department of Energy (www.pvwatts.nrel.gov). The
                    forecasted production data provided is an estimate and does
                    not represent a binding agreement or obligation. System
                    production estimates assume the annual degradation on the
                    manufacturer data sheet. The annual degradation is an
                    estimate based on the solar panel manufacturer's data sheet,
                    which typically represents degradation over decades of time.
                    Actual degradation may vary and typically the 1st year has a
                    higher panel degradation. Annual O&M costs are estimated at
                    approximately $0.02 per watt (see
                    www.nrel.gov/analysis/tech-cost-om-dq.html as of 2/2018).
                    O&M costs are not considered in this proposal. The assumed
                    useful life of the photovoltaic system is based on the
                    estimated range from NREL of 25 to 40 years
                    (www.nrel.gov/analysis/tech- cost-om-dg.html as of 2/20/18).
                    Other factors may impact the amount of power actually
                    generated by your system, including but not limited to the
                    number of overcast days, covering of solar panels from snow,
                    dust, or other debris, changes in shading, and damage to the
                    system.
                  </div>
                </div>
              </div>
              <div className="costsContainer v5">
                <div className="row">
                  <div className="col" align="center">
                    <div className="grayCircle v5"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col" align="center">
                    <div className="prod v5">
                      <div className="image v5">
                        <img className="img" src={arrowDown}></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {+loanA.isPpa === 1 ? view6Ppa() : view6()}
          <EstimatedSavings
            isCash={isCash}
            view={view}
            viewOptions={viewOptions}
            loanA={loanA}
            loanB={loanB}
            loanAmount={loanAmount}
            mappedLoans1={mappedLoans}
            mappedLoans2={mappedLoans2}
            sungagePayments={sungagePayments}
            lightReachQuote={lightReachQuote}
            years={years}
            loan1Bills={loan1Bills}
            loan2Bills={loan2Bills}
            postYears={postYears}
            postYears1={postYears1}
            loan1Savings={loan1Savings}
            loan2Savings={loan2Savings}
            setLoanAId={setLoanAId}
            setLoanBId={setLoanBId}
            total={total}
            uType={uType}
            customerState={state}
            batteryCount={state === "Texas" ? (+battery10 >= 11 && +battery10 < 20 ? +battery10 - 10 : 0) : 0}
            pricingDisclosures={pricingDisclosures}
            arcadiaSavingsReport={arcadiaSavingsReport}
            lifetimeWithoutCost={arcadiaSavingsReport.lifetimeWithoutCost}
            lifetimeSolarCost={arcadiaSavingsReport.lifetimeSolarCost}
            lifeTimeUtilityAfterCost={
              arcadiaSavingsReport.lifeTimeUtilityAfterCost
            }
            lifetimeAvoidedCost={arcadiaSavingsReport.lifetimeAvoidedCost}
            state={state}
            battery10={battery10}
          />
          {/* View Study */}
          <div className="view8">
            <div className="view8 bg">
              <div className="container-lg p-0">
                <div className="costs panels">
                  <div className="container">
                    <div className="costsContainer v8">
                      <div className="row">
                        <div className="col" align="center">
                          <div className="grayCircle v8"></div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col" align="center">
                          <div className="prod v8">
                            <div className="savingsNumber v8">4%</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className='col align="center"'>
                        <div className="saveText v8">
                          SOLAR INCREASES YOUR HOME'S VALUE
                        </div>
                        <div align="center">
                          <div className="lineBreak"></div>
                        </div>
                        <div className="costsText trees">
                          A 2019 study from Zillow showed that homes with solar
                          energy systems sold for 4.1% more on average than
                          comparable homes without solar power. More than 80% of
                          home buyers say energy-efficient features are
                          important, according to the Zillow Group Consumer
                          Housing Trends Report.
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="image zillow">
                          <a
                            href="https://www.zillow.com/research/solar-panels-house-sell-more-23798/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span>VIEW STUDY</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Brinks */}
          {securityToggled && (
            <div className="brinks-container">
              <h3 className="fontNew2 v7">Security Fit for Your Needs</h3>
              <p className="saveText v4 brinks-subheader">
                An exclusive offer to make your home a smart Home
              </p>
              <p className="saveText v4 brinks-subheader">
                <span className="free-span">
                  <del>$1,099</del> Value Included!
                </span>
              </p>

              <div className="lineBreak v4 "></div>
              <div className=" brinks-image-container">
                <img
                  src={brinksBundle}
                  alt="Home Security"
                  className="brinks-image"
                />
                <ul className="brinks-list">
                  <li className="li-brinks">
                    &#x2713; Touchscreen Panel with Solar Integration
                  </li>
                  <li className="li-brinks">
                    &#x2713; 3 Door Sensors + 1 Motion Sensor
                  </li>
                  <li className="li-brinks">
                    &#x2713; 1 Video Doorbell with People & Package Protection
                  </li>
                  <li className="li-brinks">
                    &#x2713; Brinks Home&trade; Mobile App w/ Solar Integration
                  </li>
                </ul>
              </div>

              <ul className="brinks-promo-list">
                <li className="li-promo" style={{ fontSize: "24px" }}>
                  <strong>Monitoring:</strong> 6 months{" "}
                  <span className="free-span">Free</span>, then $39.99/mo
                </li>
                <li className="li-promo" style={{ fontSize: "24px" }}>
                  <strong>Professional Installation:</strong>{" "}
                  <span className="free-span">Free</span>
                </li>
              </ul>

              <button
                onClick={() => {
                  window.open("http://www.brinkshome.com/ionsolar", "_blank");
                }}
                className="custButton link"
              >
                Welcome To Brinks Home
              </button>
            </div>
          )}

          <div className="view9">
            <div className="container">
              <div className="col">
                <div className="fontNew2 v9">Assumptions and Definitions</div>
              </div>
              <div className="v9Container">
                <div className="row">
                  <div className="row">
                    <div className="saveText v9">UTILITY ASSUMPTIONS</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <ul className="leaders">
                      <li>
                        <span className="savingsText v9">Utility Company</span>
                        <span className="savingsText v9 bold">
                          {custUtility}
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Current Estimated Annual Utility Bill
                        </span>
                        <span className="savingsText v9 bold">
                          {/* Update to Aurora Number */}
                          $
                          {Math.round(currentAnnualUtilityBill).toLocaleString(
                            undefined
                          )}
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Current Estimated Cost Per kWh
                        </span>
                        <span className="savingsText v9 bold">
                          {/* Update to Aurora Number */}
                          ${currentPerKw.toFixed(3)} 
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Annual Utility Price Escalator
                        </span>
                        <span className="savingsText v9 bold">
                          {loanA.isPpa ? 4.0 : increase}%
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Estimated Annual Usage{" "}
                          {uType === "Square Footage" &&
                            "Based off of Square Footage"}
                        </span>
                        <span className="savingsText v9 bold">
                          {`${totalUsage.toLocaleString(undefined)} kWh`}
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Livable Square Footage
                        </span>
                        <span className="savingsText v9 bold">
                          {squareFootage &&
                            Math.floor(squareFootage).toLocaleString()}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="v9Container">
                <div className="row">
                  <div className="row">
                    <div className="saveText v9">SYSTEM ASSUMPTIONS</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <ul className="leaders">
                      <li>
                        <span className="savingsText v9">System Size DC</span>
                        <span className="savingsText v9 bold">
                          {systemSize / 1000} kW
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">System Size AC</span>
                        <span className="savingsText v9 bold">
                          {(
                            panelAmount *
                            ((mod[4] * inverter.rating) / 1000)
                          ).toFixed(2)}{" "}
                          kW
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Year 1 System Production
                          {shouldShowProductionRange(salesTeam)
                            ? " Range "
                            : " "}
                          (kWh)
                        </span>
                        <span className="savingsText v9 bold">
                          {getAnnualProductionString(displayProd, salesTeam)}
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">Sun Hours</span>
                        <span className="savingsText v9 bold">
                          {Intl.NumberFormat().format(+newPropRatio)}
                        </span>
                      </li>
                      <li>
                        <span className="savingsText v9">
                          Annual System Degradation
                        </span>
                        <span className="savingsText v9 bold">0.5%</span>
                      </li>
                      {recValue.afterEnergy ? (
                        <>
                          <li>
                            <span className="savingsText v9">
                              Number of RECS
                            </span>
                            <span className="savingsText v9 bold">
                              {Intl.NumberFormat().format(recValue.numRecs)}
                            </span>
                          </li>
                          <li>
                            <span className="savingsText v9">
                              Capacity Factor
                            </span>
                            <span className="savingsText v9 bold">
                              {(recValue?.capacityFactor * 100).toFixed(2)}%
                            </span>
                          </li>
                          <li>
                            <span className="savingsText v9">
                              Additional Collateral Required
                            </span>
                            <span className="savingsText v9 bold">
                              ${(recValue?.additionalCollateral).toFixed(2)}
                            </span>
                          </li>
                          <li>
                            <span className="savingsText v9">
                              Utility Held Collateral
                            </span>
                            <span className="savingsText v9 bold">
                              ${(recValue?.utilityCollateral).toFixed(2)}
                            </span>
                          </li>
                          <li>
                            <span className="savingsText v9">
                              Application Fee
                            </span>
                            <span className="savingsText v9 bold">
                              ${(recValue?.applicationFee).toFixed(2)}
                            </span>
                          </li>
                          <li>
                            <span className="savingsText v9">
                              Gross Contract Value
                            </span>
                            <span className="savingsText v9 bold">
                              {(recValue?.grossValue).toLocaleString(
                                undefined,
                                { style: "currency", currency: "USD" }
                              )}
                            </span>
                          </li>
                          <li>
                            <span className="savingsText v9">
                              Payment To Customer Value
                            </span>
                            <span className="savingsText v9 bold">
                              {(recValue?.afterEnergy).toLocaleString(
                                undefined,
                                { style: "currency", currency: "USD" }
                              )}
                            </span>
                          </li>
                        </>
                      ) : null}
                    </ul>
                  </div>
                </div>
              </div>
              {+loanA.isPpa === 1 ? (
                <div className="v9Container">
                  <div className="row">
                    <div className="row">
                      <div className="saveText v9">TPO ASSUMPTIONS</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <ul className="leaders">
                        <li>
                          <span className="savingsText v9">TPO kWh Rate</span>
                          <span className="savingsText v9 bold">
                            ${loanA.ppaRate.toLocaleString(undefined)}
                          </span>
                        </li>
                        <li>
                          <span className="savingsText v9">TPO Escalator</span>
                          <span className="savingsText v9 bold">
                            {(loanA.ppaEscalator * 100).toLocaleString(
                              undefined
                            )}
                            %
                          </span>
                        </li>
                        <li>
                          <span className="savingsText v9">Year 1 Payment</span>
                          <span className="savingsText v9 bold">
                            $
                            {Math.round(
                              loanA?.firstMonthPayment
                                ? loanA.firstMonthPayment
                                : +loanA.ppaRate * (totalProduction / 12)
                            )}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="v9Container">
                  <div className="row">
                    <div className="row">
                      <div className="saveText v9">
                        {isCash ? "PURCHASE" : "LOAN"} & INCENTIVE ASSUMPTIONS
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <ul className="leaders">
                        <li>
                          <span className="savingsText v9">
                            Total System Cost
                          </span>
                          <span className="savingsText v9 bold">
                            ${Math.ceil(systemCost).toLocaleString(undefined)}
                          </span>
                        </li>
                        <li>
                          {(utility === "Portland General Electric (PGE)" ||
                            utility === "Pacific Power") &&
                            +rebateSF > 0 ? (
                            <>
                              <span className="savingsText v9">
                                {oregonLabel}
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="savingsText v9">
                                Installer Paid Incentive
                              </span>
                            </>
                          )}
                          <span className="savingsText v9 bold">
                            ${Math.round(rebate).toLocaleString(undefined)}
                          </span>
                        </li>
                        <li>
                          <span className="savingsText v9">Down Payment</span>
                          <span className="savingsText v9 bold">
                            ${downPayment}
                          </span>
                        </li>
                        <li className={isCash ? "noDisplay" : ""}>
                          <span className="savingsText v9">Interest Rate</span>
                          <span className="savingsText v9 bold">
                            {loanA.loanInterest}%{" "}
                            {viewOptions === 0
                              ? `/ ${loanB.loanInterest}%`
                              : ""}
                          </span>
                        </li>
                        <li className={isCash ? "noDisplay" : ""}>
                          <span className="savingsText v9">Loan Term</span>
                          <span className="savingsText v9 bold">
                            {loanA.loanTerm} Years{" "}
                            {viewOptions === 0
                              ? `/ ${loanB.loanTerm} Years`
                              : ""}
                          </span>
                        </li>
                        <li>
                          <span className="savingsText v9">
                            Incentive Investment Applied by Deadline
                          </span>
                          <span className="savingsText v9 bold">
                            $
                            {Math.round(
                              (loanAmount + +downPayment - homeEnergyTotal) *
                              loanA.itc
                            ).toLocaleString(undefined)}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={
                  isCash || +loanA.isPpa === 1 ? "noDisplay" : "v9Container"
                }
              >
                <div className="row">
                  <div className="row">
                    <div className="saveText v9">NO PREPAYMENT PENALTIES</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="savingsText v9 par">
                      You can prepay your loan at any time without any penalty.
                      Prepayments will not change the interest rate, but paying
                      early during the repayment period will reduce the
                      effective term of your loan and save you money by reducing
                      the amount of interest you will pay in the future. If you
                      choose to use your monthly savings to help pay off your
                      loan, you can maximize savings over the life of the
                      system.
                    </div>
                  </div>
                </div>
              </div>
              <div className="v9Container">
                <div className="row">
                  <div className="row">
                    <div className="saveText v9">
                      SAVINGS RESULTS & SYSTEM SIZE
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="savingsText v9 par">
                      {uType !== "Square Footage"
                        ? "The calculations included in this proposal represent your estimated or actual utility power usage and costs, and is based on information provided by you."
                        : "The calculations included in this proposal represent your estimated utility power usage based on your livable square footage as provided by you. Cost savings estimates are based on costs related to your proposed solar system’s estimated production and your estimated utility needs based solely on your square footage. This is not based on your actual or historical power usage."}{" "}
                      The accuracy of projected savings and solar offset is
                      dependent upon accurate usage and costs. Missing or
                      inaccurate data could result in projections that are
                      different than your actual results and may result in a
                      system that is larger or smaller than you may need. If you
                      would like to update the information you have provided to
                      improve the accuracy of the projections, we will be happy
                      to prepare a revised proposal. Savings are based on
                      multiple factors and cannot be guaranteed. Additionally,
                      changes in your power usage in the future will also impact
                      your savings. Additionally, changes in you power usage in
                      the future will also impact your savings.
                    </div>
                  </div>
                </div>
              </div>
              <div className="v9Container">
                <div className="row">
                  <div className="row">
                    <div className="saveText v9">
                      ION SOLAR INDUSTRY-BEST WARRANTIES
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="savingsText v9 par">
                      <span className="savingsText v9 bold">
                        Service Warranty:
                      </span>{" "}
                      Not only does your system have the solar industry's best
                      manufacturer warranties and workmanship warranty, but our
                      service professional will waive the service call fee for
                      the first two years so you can sleep soundly knowing your
                      system is covered from any defects.
                    </div>
                    <div className="savingsText v9 par">
                      <span className="savingsText v9 bold">
                        10-Year Workmanship Warranty:
                      </span>{" "}
                      Our in-house team of expert installers are obsessive about
                      the details and take the time to ensure your system is
                      installed to perfection. Our workmanship warranty covers
                      an industry-best ten years and is explained in our
                      Customer Installation Agreement.{" "}
                    </div>
                    <div className="savingsText v9 par">
                      <span className="savingsText v9 bold">
                        Manufacturer's Warranty:
                      </span>{" "}
                      <ul>
                        <li>25-year product warranty on Tier 1 solar panels</li>
                        <li>
                          30-year performance warranty on Tier 1 solar panels
                        </li>
                        <li>25-year warranty on inverters</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {custUtility === "Austin Energy" ? (
                <></>
              ) : (
                <div className="v9Container">
                  <div className="row">
                    <div className="row">
                      <div className="saveText v9">NET METERING</div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="savingsText v9 par">
                        You will be able to use energy at the same time your
                        solar energy system produces energy. If your solar
                        energy system produces more energy than you can
                        simultaneously use at any given time, the surplus energy
                        is returned to the utility grid to be used by other
                        consumers. This process is called “net metering,” and it
                        effectively credits you for this excess production. You
                        will also be billed by the utility for the energy you
                        pull from the grid. The specific net metering policies
                        offered by different utilities may directly impact the
                        savings you may be able to actualize from your solar
                        energy system. Please be sure to check with your utility
                        company regarding those offerings.
                      </div>
                      {stateDisclosures()}
                    </div>
                  </div>
                </div>
              )}
              <div
                className={
                  state === "South Carolina" ? "v9Container" : "v9Container bot"
                }
              >
                <div className="row">
                  <div className="row">
                    <div className="saveText v9">POST-SOLAR UTILITY FEES</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="savingsText v9 par">
                      Post-solar base utility fees are estimated by an
                      industry-leading utility rate plan data provider.
                      Depending on the system offset, additional post-solar
                      utility costs are also assumed to apply. You should check
                      with your utility for exact charges. Future utility rates
                      and charges, as well as net metering value (where
                      available) may change and cannot be accurately projected.
                      We have presented projected solar savings based on a range
                      of potential annual utility price increases. The actual
                      utility price increases could fall outside of this range.
                      Projected savings from the solar system are therefore
                      subject to change and are not guaranteed.
                    </div>
                  </div>
                </div>
              </div>
              {state === "South Carolina" && (
                <>
                  <div className="v9Container bot">
                    <div className="row">
                      <div className="row">
                        <div className="saveText v9">
                          SOUTH CAROLINA DISCLOSURES
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="savingsText v9 par">
                          The estimated projected savings over the life of the
                          renewable energy facility agreement; Any material
                          assumptions used to calculate estimated projected
                          savings and the source of those assumptions,
                          including: If a change in the retail electric
                          provider's annual electricity rate is assumed, the
                          rate of the change and the retailer's basis for the
                          assumption of the change; The consumer's eligibility
                          for or receipt of tax credits or other governmental or
                          retail electric provider incentives; Facility
                          production data, including production degradation; The
                          facility's eligibility for interconnection under any
                          net metering or similar program; The consumer's
                          electrical usage and the facility's designed offset of
                          the electrical usage; Historical retail electric
                          provider costs paid by the consumer, to include a
                          period of not less than twelve months; Any escalation
                          affecting a payment between the consumer and the
                          retailer; and The costs associated with replacing
                          equipment making up part of the facility or, if those
                          costs are not assumed, a statement indicating that
                          those costs are not assumed.
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="savingsText v9 par">
                          Savings estimates do not assume or include any costs
                          associated with replacing any parts of the solar
                          system.
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div
                          className="savingsText v9 par"
                          style={{
                            fontSize: 14,
                            fontWeight: "bold",
                          }}
                        >
                          This is a quote. Your power company's rate solar rate
                          may be different from your current rate. Rates may go
                          up or down and the money you may save, if any, may
                          vary. Past data may not be a good gauge of future
                          results. For more information about rates, contact
                          your power company.
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div
                          className="savingsText v9 par"
                          style={{
                            fontSize: 14,
                            fontWeight: "bold",
                          }}
                        >
                          Tax and credits or incentives including those provided
                          by federal, state, or local governments may change or
                          end. This can impact the amount of money you might
                          save. Consult a tax professional to understand any tax
                          liability or eligibility for any tax credits that may
                          result from the purchase of your solar system.
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="view10">
            <div className="container">
              <div className="costs v10">
                <div className="row">
                  <div className='col align="center"'>
                    <div className="saveText v10">
                      NEED TO CONTACT YOUR{" "}
                      {utilityLocation === "Colorado"
                        ? "ENERGY SPECIALIST"
                        : "ENERGY ADVISOR"}
                      ?
                    </div>
                    <div align="center">
                      <div className="lineBreak v10"></div>
                    </div>
                    <div className="costsText v10">{customer.salesRep}</div>
                    <div className="costsText v10">
                      <a href={`tel:${customer.repPhone}`}>
                        {customer.repPhone}
                      </a>
                    </div>
                    <div className="costsText v10">
                      <a href={`mail:${customer.repEmail}`}>
                        {customer.repEmail}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row g-0 pt-sm-5 mt-sm-5 pt-3 mt-0">
                <div className="col-2"></div>
                <div className="col-lg-12 ps-lg-3">
                  <div className="blur v10">
                    <div className="row">
                      <div className="col pt-4" align="center">
                        <div className="row ps-4">
                          <div>
                            <img className="bottom-logo" src={Logo} alt="" />
                          </div>
                        </div>
                        <div className="row ps-lg-4">
                          <div>
                            <div className="col border-bottom border-1 border-dark"></div>
                          </div>
                        </div>
                        <div className="row ps-4">
                          <div>
                            <div className="col fontName v10 mt-3">
                              Thank You
                            </div>
                          </div>
                        </div>
                        <div className="row ps-4">
                          <div>
                            <div className="col fontBottom v10 pt-1">
                              <a href="tel: 8887817074">(888) 781-7074</a> •{" "}
                              <a
                                href="https://www.ionsolar.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                www.ionsolar.com
                              </a>{" "}
                              {state === "North Carolina" ? (
                                <span className="costsText v10">
                                  ION Developer, LLC N. Carolina U.33336
                                </span>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="row ps-4">
                          <div className="footer-logos">
                            <img className="footer-logo" src={inc500} alt="" />
                            <img className="footer-logo" src={nabcep} alt="" />
                            <img className="footer-logo" src={bbb} alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {+reRoof > 1 ? (
            <>
              <RoofProp customer={customer} roofQuote={roofQuote} />
            </>
          ) : (
            <></>
          )}
          {+battery10 > 0 ? (
            <>
              <div className={batteryClass}>
                <div className="batteryButton">
                  <a
                    href={`https://es-media-prod.s3.amazonaws.com/media/components/panels/spec-sheets/Powerwall_3_Datasheet_IN5Bniz_CFbEyjY_3Na5CPX_QPs7Hp1_BsTrV4S.pdf`}
                    target="_blank"
                  >
                    Powerwall 3 Spec Sheet
                  </a>
                </div>
                <div className="filler"></div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};
export default PropView;
